// 1040 Form Imports
import Address from '../components/forms/OrganizerForm/1040/Address';
import Dependent from '../components/forms/OrganizerForm/1040/Dependent';
import Deduction from '../components/forms/OrganizerForm/1040/Deduction';
import LifeEvent from '../components/forms/OrganizerForm/1040/LifeEvents';
import TaxPayer from '../components/forms/OrganizerForm/1040/TaxPayerForm';
import IncomeSource from '../components/forms/OrganizerForm/1040/IncomeSource';
import EstimateTaxes from '../components/forms/OrganizerForm/1040/EstimateTaxes';
import FilliingStatus from '../components/forms/OrganizerForm/1040/FillingStatus';
import OthersQuestions from '../components/forms/OrganizerForm/1040/OtherQuestions';
import FinancialEvents from '../components/forms/OrganizerForm/1040/FinancialEvents';
import ExpensesSummary from '../components/forms/OrganizerForm/1040/ExpensesSummary';
import RefundAndPayment from '../components/forms/OrganizerForm/1040/RefundAndPayment';
// 1065 Forms Import
import BusinessInformation from '../components/forms/OrganizerForm/1065/BusinessInformation';
import BusinessAddress from '../components/forms/OrganizerForm/1065/BusinessAddress';
import BusinessDetails from '../components/forms/OrganizerForm/1065/BusinessDetails';
import PartnerInformation from '../components/forms/OrganizerForm/1065/PartnerInformation';
import QuestionnairePart1 from '../components/forms/OrganizerForm/1065/QuestionariePart1';
import QuestionnairePart2 from '../components/forms/OrganizerForm/1065/QuestionnairePart2';
import Income from '../components/forms/OrganizerForm/1065/Income';
import CostOfGoodsSale from '../components/forms/OrganizerForm/1065/CostOfGoodsSale';
import Expenses from '../components/forms/OrganizerForm/1065/Expenses';
import Assets from '../components/forms/OrganizerForm/1065/Assets';
import LiabilitiesAndCapital from '../components/forms/OrganizerForm/1065/LiabilitiesAndCapital';
import FixedAssets from '../components/forms/OrganizerForm/1065/FixedAssets';
import Comments from '../components/forms/OrganizerForm/1065/Comments';

// 1120 Forms Import

import Officer from '../components/forms/OrganizerForm/1120/C/Officers';
import ShareHolder from '../components/forms/OrganizerForm/1120/S/ShareHolder';
import ClientIntake from '../components/forms/OrganizerForm/taxPlaningIndividual/ClientIntake';
import GeneralInformation from '../components/forms/OrganizerForm/taxPlaningIndividual/GeneralInformation';
import BusinessGeneralFinances from '../components/forms/OrganizerForm/taxPlaningIndividual/BusinessGeneralFinances';
import BusinessExpenses from '../components/forms/OrganizerForm/taxPlaningIndividual/BusinessExpenses';
import Qbid from '../components/forms/OrganizerForm/taxPlaningIndividual/QbidForm.js';
import TaxFreeRental from '../components/forms/OrganizerForm/taxPlaningIndividual/TaxFreeRental.js';
import Retirement from '../components/forms/OrganizerForm/taxPlaningIndividual/Retirement.js';
import Employees from '../components/forms/OrganizerForm/taxPlaningIndividual/Employess.js';
import Payroll from '../components/forms/OrganizerForm/taxPlaningIndividual/Payroll.js';
import Covid19 from '../components/forms/OrganizerForm/taxPlaningIndividual/Covid19.js';
import FringeBenefits from '../components/forms/OrganizerForm/taxPlaningIndividual/FringeBenefits.js';
import Insurance from '../components/forms/OrganizerForm/taxPlaningIndividual/Insurance.js';
// import FuturePartners from '../components/forms/OrganizerForm/taxPlaningIndividual/FuturePartners.js';
import SCorp from '../components/forms/OrganizerForm/taxPlaningIndividual/SCorp.js';
import Farm from '../components/forms/OrganizerForm/taxPlaningIndividual/Farm.js';
import FarmRental from '../components/forms/OrganizerForm/taxPlaningIndividual/FarmRental.js';
import Depreciation from '../components/forms/OrganizerForm/taxPlaningIndividual/Depreciation.js';
import FICATipCredit from '../components/forms/OrganizerForm/taxPlaningIndividual/FICATipCredit.js';
import RanDTaxCredits from '../components/forms/OrganizerForm/taxPlaningIndividual/RanDTaxCredits.js';
import International from '../components/forms/OrganizerForm/taxPlaningIndividual/International.js';
import WorkOppoutubity from '../components/forms/OrganizerForm/taxPlaningIndividual/WorkOpportunity.js';
import TaxPaymentRefund from '../components/forms/OrganizerForm/taxPlaningIndividual/TaxPaymentRefund.js';
import ForeignAccounts from '../components/forms/OrganizerForm/taxPlaningIndividual/ForeignAccounts.js';
import BusinessVehicles from '../components/forms/OrganizerForm/taxPlaningIndividual/BusinessVehicles.js';
import SalesAssets from '../components/forms/OrganizerForm/taxPlaningIndividual/SalesAssets.js';
import PurchaseAssets from '../components/forms/OrganizerForm/taxPlaningIndividual/PurchaseAssets.js';
import CorporateCSCorp from '../components/forms/OrganizerForm/taxPlaningIndividual/CorporateCSCorp.js';
import PartnerShip from '../components/forms/OrganizerForm/taxPlaningIndividual/PartnerShip.js';
import SoleProprietorship from '../components/forms/OrganizerForm/taxPlaningIndividual/SoleProprietorship.js';
import FuturePartnerShareholder from '../components/forms/OrganizerForm/taxPlaningIndividual/FuturePartnerShareholder.js';
import RentalEstateRoyaltyIncome from '../components/forms/OrganizerForm/taxPlaningIndividual/RentalEstateRoyaltyIncome.js';
import BusinessIncome from '../components/forms/OrganizerForm/taxPlaningIndividual/BusinessIncome.js';
import BIncome from '../components/forms/OrganizerForm/taxPlaningIndividual/BIncome.js';
import PersonalInformation from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/PersonalInformation.js';
import Dependents from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/Dependents.js';
import PrimaryResidence from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/PrimaryResidence.js';
import SecondaryResidence from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/SecondaryResidence.js';
import IncomeDetails from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/IncomeDetails.js';
import InterestIncomeDetails from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/InterestIncomeDetails.js';
import DividendIncomeDetail from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/DividendIncomeDetail.js';
import ForeignAccountsDetail from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/ForeignAccountsDetail.js';
import OtherIncomeDetail from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/OtherIncomeDetail.js';
import RetirementPlans from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/RetirementPlans.js';
import HealthAndMedical from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/HealthAndMedical.js';
import OtherDeductionsSummary from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/OtherDeductionsSummary.js';
import OtherAdjustmentDetail from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/OtherAdjustmentDetail.js';
import ItemizedDeductionsDetail from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/ItemizedDeductionsDetail.js';
import RealEstateTaxes from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/RealEstateTaxes.js';
import EducationalExpenses from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/EducationalExpenses.js';
import AdditionalQuestions from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/AdditionalQuestions.js';
import OtherCredits from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/OtherCredits.js';
import FederalPrioryear from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientShort/FederalPrioryear.js';
import PersonalInformationLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/PersonalInformation.js';
import DependentsLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/Dependents.js';
import PrimaryResidenceLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/PrimaryResidence.js';
import SecondaryResidenceLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/SecondaryResidence.js';
import WagesSummaryLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/WagesSummary.js';
import IncomeDetailsLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/IncomeDetails.js';
import OtherIncomeSummaryLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/OtherIncomeSummary.js';
import InterestIncomeDetailsLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/InterestIncomeDetails.js';
import DividendIncomeDetailLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/DividendIncomeDetail.js';
import ForeignAccountsDetailLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/ForeignAccountsDetail.js';
import OtherIncomeDetailsLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/OtherIncomeDetails.js';
import CapitalGainLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/CapitalGain.js';
import IncomeFromPartnershipsLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/IncomeFromPartnerships.js';
import RetirementPlansLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/RetirementPlans.js';
import HealthAndMedicalLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/HealthAndMedical.js';
import OtherDeductionsSummaryLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/OtherDeductionsSummary.js';
import OtherAdjustmentDetailsLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/OtherAdjustmentDetails.js';
import ItemizedDeductionDetailLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/ItemizedDeductionDetail.js';
import IntangibleTaxLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/IntangibleTax.js';
import IncomeTaxPreparationFees from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/IncomeTaxPreparationFees.js';
import EducationalExpensesLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/EducationalExpenses.js';
import SalesOfAssets from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/SalesOfAssets.js';
import PurchaseOfAsset from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/PurchaseOfAsset.js';
import Charity from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/Charity.js';
import OtherCreditsLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/OtherCredits.js';
import QBIDLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/QBID.js';
import OIlAndGas from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/OIlAndGas.js';
import InternationalLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/International.js';
import NetOpeartingLosses from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/NetOpeartingLosses.js';
import AssetProtection from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/AssetProtection.js';
import AdditionalQuestionsLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualCurrentClientLong/AdditionalQuestions.js';
import PersonalInformationNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/PersonalInformation.js';
import DependentsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/Dependents.js';
import PrimaryResidenceNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/PrimaryResidence.js';
import SecondaryResidenceNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/SecondaryResidence.js';
import IncomeDetailsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/IncomeDetails.js';
import InterestIncomeDetailsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/InterestIncomeDetails.js';
import DividendIncomeDetailsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/DividendIncomeDetails.js';
import ForeignAccountsDetailsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/ForeignAccountsDetail.js';
import OtherIncomeDetailsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/OtherIncomeDetail.js';
import RetirementPlansNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/RetirementPlans.js';
import HealthAndMedicalNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/HealthAndMedical.js';
import OtherDeductionsSummaryNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/OtherDeductionsSummary.js';
import OtherAdjustmentDetailsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/OtherAdjustmentDetails.js';
import ItemizedDeductionsDetailsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/ItemizedDeductionsDetails.js';
import EducationalExpensesNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/EducationalExpenses.js';
import OtherCreditsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/OtherCredits.js';
import AdditionalQuestionsNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientShort/AdditionalQuestions.js';
import PersonalInformationNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/PersonalInformation.js';
import PriorYearTaxReturnNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/PriorYearTaxReturn.js';
import DependentsNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/Dependents.js';
import PrimaryResidenceNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/PrimaryResidence.js';
import SecondaryResidenceNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/SecondaryResidence.js';
import WagesSummaryNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/WagesSummary.js';
import IncomeDetailsNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/IncomeDetails.js';
import OtherIncomeSummaryNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/OtherIncomeSummary.js';
import InterestIncomeDetailsNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/InterestIncomeDetails.js';
import DividendIncomeDetailNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/DividendIncomeDetail.js';
import ForeignAccountsDetailNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/ForeignAccountsDetail.js';
import OtherIncomeDetailsNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/OtherIncomeDetails.js';
import CapitalGainNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/CapitalGain.js';
import RetirementPlansNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/RetirementPlans.js';
import HealthAndMedicaNewClientlLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/HealthAndMedical.js';
import OtherDeductionsSummaryNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/OtherDeductionsSummary.js';
import OtherAdjustmentDetailsNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/OtherAdjustmentDetails.js';
import ItemizedDeductionDetailNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/ItemizedDeductionDetail.js';
import IntangibleTaxNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/IntangibleTax.js';
import IncomeTaxPreparationFeesNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/IncomeTaxPreparationFees.js';
import EducationalExpensesNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/EducationalExpenses.js';
import SalesOfAssetsNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/SalesOfAssets.js';
import PurchaseOfAssetNewClient from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/PurchaseOfAsset.js';
import CharityNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/Charity.js';
import OtherCreditsNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/OtherCredits.js';
import QBIDNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/QBID.js';
import OIlAndGasNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/OIlAndGas.js';
import InternationalNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/International.js';
import NetOperatingLossesNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/NetOpeartingLosses.js';
import AssetProtectionNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/AssetProtection.js';
import AdditionalQuestionsNewClientLong from '../components/forms/OrganizerForm/OptionsTaxPreperationIndividualNewClientLong/AdditionalQuestions.js';
import GeneralInformationBusinessCurrentClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort/GeneralInformation.js';
import BusinessFinancialsBusinessCurrentClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort/BusinessFinancials.js';
import SaleOfAssetBusinessCurrentClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort/SaleOfAsset.js';
import PurchaseOfAssetBusinessCurrentClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort/PurchaseOfAssets.js';
import MiscellaneousBusinessCurrentClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort/Miscellaneous.js';
import PriorYearTaxReturnBusinessNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientShort/PriorYearTaxReturn.js';
import GeneralInformationBusinessNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientShort/GeneralInformation.js';
import BusinessFinancialsBusinessNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientShort/BusinessFinancials.js';
import SaleOfAssetBusinessNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientShort/SaleOfAsset.js';
import PurchaseOfAssetBusinessNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientShort/PurchaseOfAssets.js';
import MiscellaneousBusinessNewClientShort from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientShort/Miscellaneous.js';
import RentalRealEstateAndRoyaltyOncome from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientShort/RentalRealEstateAndRoyaltyOncome.js';
import GeneralInformationBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/GeneralInformation.js';
import BusinessIncomeBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/BusinessIncome.js';
import BusinessExpensesBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/BusinessExpenses.js';
import OtherInterestBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/OtherInterest.js';
import SuppliesBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Supplies.js';
import BusinessVehiclesBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/BusinessVehicles.js';
import ShareHolderIncomeBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/ShareHolderIncome.js';
// import { BsFillArrowLeftSquareFill } from 'react-icons/bs';
import QBIDBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/QBID.js';
import TaxFreeRentalBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/TaxFreeRental.js';
import RetirementBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Retirement.js';
import EmployeesBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Employees.js';
import PayRollBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/PayRoll.js';
import Covid19BCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Covid19.js';
import FringeBenefitsBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/FringeBenefits.js';
import InsuranceBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Insurance.js';
import SalesOfAssetsBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/SalesOfAssets.js';
import PurchaseOfAssetBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/PurchaseOfAsset.js';
import CorporateBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Corporate.js';
import SCorpBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/SCorp.js';
import PartnershipBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Partnership.js';
import SoleProprietorshipBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/SoleProprietorship.js';
import FuturePartnersAndShareholdersBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/FuturePartnersAndShareholders.js';
import RentalRealEstateAndRoyaltyIncomeBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/RentalRealEstateAndRoyaltyIncome.js';
import FarmBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Farm.js';
import FarmRentalBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/FarmRental.js';
import DepriciationBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Depriciation.js';
import FICATipCreditBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/FICATipCredit.js';
import RAndDTaxCreditsBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/RAndDTaxCredits.js';
import WorkOpportunityCreditBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/WorkOpportunityCredit.js';
import InternationalBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/International.js';
import ForeignAccountsBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/ForeignAccounts.js';
import MiscellaneousBCCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong/Miscellaneous.js';
import PriorYearTaxReturnBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/PriorYearTaxReturn.js';
import GeneralInformationBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/GeneralInformation.js';
import BusinessIncomeBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/BusinessIncome.js';
import BusinessExpensesBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/BusinessExpenses.js';
import OtherInterestBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/OtherInterest.js';
import SuppliesBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Supplies.js';
import BusinessVehiclesBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/BusinessVehicles.js';
import ShareHolderIncomeBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/ShareHolderIncome.js';
import QBIDBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/QBID.js';
import TaxFreeRentalBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/TaxFreeRental.js';
import RetirementBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Retirement.js';
import EmployeesBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Employees.js';
import PayRollBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/PayRoll.js';
import Covid19BNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Covid19.js';
import FringeBenefitsBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/FringeBenefits.js';
import InsuranceBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Insurance.js';
import SalesOfAssetsBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/SalesOfAssets.js';
import PurchaseOfAssetBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/PurchaseOfAsset.js';
import CorporateBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Corporate.js';
import SCorpBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/SCorp.js';
import PartnershipBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Partnership.js';
import SoleProprietorshipBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/SoleProprietorship.js';
import FuturePartnersAndShareholdersBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/FuturePartnersAndShareholders.js';
import RentalRealEstateAndRoyaltyIncomeBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/RentalRealEstateAndRoyaltyIncome.js';
import FarmBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Farm.js';
import FarmRentalBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/FarmRental.js';
import DepriciationBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Depriciation.js';
import FICATipCreditBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/FICATipCredit.js';
import RAndDTaxCreditsBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/RAndDTaxCredits.js';
import WorkOpportunityCreditBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/WorkOpportunityCredit.js';
import InternationalBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/International.js';
import ForeignAccountsBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/ForeignAccounts.js';
import MiscellaneousBNCL from '../components/forms/OrganizerForm/OptionsTaxPreperationQuestionnaireBusinessNewClientLong/Miscellaneous.js';
import ClientIntakeTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/ClientIntake.js';
import PersonalInformationTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/PersonalInformation.js';
import WagesTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/Wages.js';
import DependentChildrenTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/DependentChildren.js';
import PrimaryResidenceTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/PrimaryResidence.js';
import SecondaryResidenceTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/SecondaryResidence.js';
import HealthAndMedicalTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/HealthAndMedical.js';
import CharityTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/Charity.js';
import RetirementPlansTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/RetirementPlans.js';
import SaleofAssetsTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/SaleofAssets.js';
import PurchaseofAssetsTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/PurchaseofAssets.js';
import OtherIncomeTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/OtherIncome.js';
import CapitalGainsTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/CapitalGains.js';
import OtherDeductionsTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/OtherDeductions.js';
import QBIDTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/QBID.js';
import OilAndGasTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/OilAndGas.js';
import AssetProtectionTPI from '../components/forms/OrganizerForm/TaxPlaningIndividualFirst/AssetProtection.js';
import ClientIntakeTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/ClientIntake.js';
import GeneralInformationTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/GeneralInformation.js';
import IncomeTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/Income.js';
import PartnersAndShareHoldersTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/PartnersAndShareHolders.js';
import QBIDTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/QBID.js';
import TaxFreeRentalTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/TaxFreeRental.js';
import RetirementTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/Retirement.js';
import COVID19TPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/COVID19.js';
import PayRollTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/PayRoll.js';
import BusinessExpensesTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/BusinessExpenses.js';
import FringeBenefitsTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/FringeBenefits.js';
import InsuranceTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/Insurance.js';
import EmployeesTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/Employees.js';
import SaleofAssetsTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/SaleofAssets.js';
import PurchaseofAssetsTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/PurchaseofAssets.js';
import RentalRealEstateTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/RentalRealEstate.js';
import FarmTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/Farm.js';
import FarmRentalTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/FarmRental.js';
import DepreciationTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/Depreciation.js';
import FICATipCreditTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/FICATipCredit.js';
import RandDTaxCreditsTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/RandDTaxCredits.js';
import WorkOpportunityCreditTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/WorkOpportunityCredit.js';
import InternationalTPBO from '../components/forms/OrganizerForm/TaxPlanningBusinessOwner/International.js';


let DocumentOptions = [
	{ value: '1040 Individual Return', label: 'Individual Tax Organizer (1040)' },
	{ value: '1065 Organizer - Partnership', label: 'Partnership Tax Organizer (1065)' },
	{
		value: '1120 C - Corp Business Return',
		label: 'Corp Tax Organizer (1120C)',
	},
	{
		value: '1120 S Organizer',
		label: 'S-Corp Tax Organizer (1120S)',
	},
	{ value: 'Tax Planning Individual', label: 'Tax Planning Individual', },

	{ value: 'Tax Planning Business Owner', label: 'Tax Planning Business Owner', },

	{ value: 'Tax Preparation (Individual, Current Client - Short)', label: 'Tax Preparation (Individual, Current Client - Short)', },
	{ value: 'Tax Preparation (Individual Current Client - Long)', label: 'Tax Preparation (Individual Current Client - Long)', },
	{ value: 'Tax Preparation (Individual New Client, Short)', label: 'Tax Preparation (Individual New Client, Short)', },
	{ value: 'Tax Preparation (Individual New Client, Long)', label: 'Tax Preparation (Individual New Client, Long)', },
	{ value: 'Tax Preparation Questionnaire (Business, Current Client, Short)', label: 'Tax Preparation Questionnaire (Business, Current Client, Short)', },
	{ value: 'Tax Preparation Questionnaire (Business, New Client, Short)', label: 'Tax Preparation Questionnaire (Business, New Client, Short)', },
	{ value: 'Tax Preparation Questionnaire (Business, Current Client, Long)', label: 'Tax Preparation Questionnaire (Business, Current Client, Long)', },
	{ value: 'Tax Preparation Questionnaire (Business, New Client, Long)', label: 'Tax Preparation Questionnaire (Business, New Client, Long)', },



];
// *****************************************
// ------------ FORM Var -----------------
// *****************************************

// All Forms Name

// Tax Pro Form
const prefix = [
	{
		label: 'Mr.',
		value: 'Mr.',
	},
	{ label: 'Miss.', value: 'Miss.' },
];

// Tax pro expertises
const taxProExpertises = [
	{
		label: 'Bookkeeping',
		value: 'Bookkeeping',
	},
	{
		label: 'Tax Preparation',
		value: 'Tax Preparation',
	},
	{
		label: 'Tax Planning',
		value: 'Tax Planning',
	},
	{
		label: 'IRS Representation',
		value: 'IRS Representation',
	},
	{
		label: 'Payroll',
		value: 'Payroll',
	},
	{
		label: 'Financial Planning',
		value: 'Financial Planning',
	},
	{
		label: 'Business Consulting',
		value: 'Business Consulting',
	},
];

// Tax Pro Form
const insuranceOptions = [
	{
		label: 'Individual',
		value: 'Individual.',
	},
	{ label: 'Group', value: 'Group' },
];

const identificationOption = [
	{ question: "Driver's license" },
	{ question: 'State-issued identification card' },
	{
		question: 'Taxpayer does not have a driver license , state-issued identification card',
	},
];

const otherQuestions = [
	{ question: 'Was the taxpayer legally blind as of 12/31/2023?', bool: null },
	{
		question: 'Was the taxpayer permanently and totally disabled at any time during 2023?',
		bool: null,
	},
	{
		question: "Could the taxpayer be claimed as a dependent on another Inckodual's 2023 return?",
		bool: null,
	},
	{
		question: 'Was the taxpayer a full-time student during 2023?',
		bool: null,
	},
	{
		question: 'Does the taxpayer want S3 to go to the Presidential Election Campaign Fund?',
		bool: null,
	},
];

// Status Filling Form

const StatusOption = [
	{ question: 'Single' },
	{ question: 'Married filing jointly' },
	{
		question: 'Married filing separately',
	},
	{
		question: 'Head of household ',
	},
	{
		question: 'Qualifying surviving spouse ',
	},
];

// Dependent Form
const DependentsOptions = [{ question: 'Do you have any dependents during 2023?', bool: null }];
const durationLiveWith = [
	{
		label: '1-5',
		value: '1-5',
	},
	{ label: '5-10', value: '5-10' },
];
const DependentPersonAppliedOptions = [
	{ question: 'Married as of 12/31/2023' },
	{ question: 'Fill-time student during 2023' },
	{ question: 'Totally and permanently disabled at any time during 2023' },
	{ question: 'Had income during 2023' },
	{ question: 'Filed or will file their own 2023 income tax return ' },
	{ question: 'None of above' },
];

const relationShipType = [
	{
		label: 'Relative',
		value: 'Relative',
	},
	{ label: 'Others', value: 'Others' },
];
// Address Form

const usStates = [
	{
		label: 'Alabama',
		value: 'Alabama',
	},
	{
		label: 'Alaska',
		value: 'Alaska',
	},
	{
		label: 'Arizona',
		value: 'Arizona',
	},
	{
		label: 'Arkansas',
		value: 'Arkansas',
	},
	{
		label: 'California',
		value: 'California',
	},
	{
		label: 'Colorado',
		value: 'Colorado',
	},
	{
		label: 'Connecticut',
		value: 'Connecticut',
	},
	{
		label: 'Delaware',
		value: 'Delaware',
	},
	{
		label: 'Florida',
		value: 'Florida',
	},
	{
		label: 'Georgia',
		value: 'Georgia',
	},
	{
		label: 'Hawaii',
		value: 'Hawaii',
	},
	{
		label: 'Idaho',
		value: 'Idaho',
	},
	{
		label: 'Illinois',
		value: 'Illinois',
	},
	{
		label: 'Indiana',
		value: 'Indiana',
	},
	{
		label: 'Iowa',
		value: 'Iowa',
	},
	{
		label: 'Kansas',
		value: 'Kansas',
	},
	{
		label: 'Kentucky',
		value: 'Kentucky',
	},
	{
		label: 'Louisiana',
		value: 'Louisiana',
	},
	{
		label: 'Maine',
		value: 'Maine',
	},
	{
		label: 'Maryland',
		value: 'Maryland',
	},
	{
		label: 'Massachusetts',
		value: 'Massachusetts',
	},
	{
		label: 'Michigan',
		value: 'Michigan',
	},
	{
		label: 'Minnesota',
		value: 'Minnesota',
	},
	{
		label: 'Mississippi',
		value: 'Mississippi',
	},
	{
		label: 'Missouri',
		value: 'Missouri',
	},
	{
		label: 'Montana',
		value: 'Montana',
	},
	{
		label: 'Nebraska',
		value: 'Nebraska',
	},
	{
		label: 'Nevada',
		value: 'Nevada',
	},
	{
		label: 'New Hampshire',
		value: 'New Hampshire',
	},
	{
		label: 'New Jersey',
		value: 'New Jersey',
	},
	{
		label: 'New Mexico',
		value: 'New Mexico',
	},
	{
		label: 'New York',
		value: 'New York',
	},
	{
		label: 'North Carolina',
		value: 'North Carolina',
	},
	{
		label: 'North Dakota',
		value: 'North Dakota',
	},
	{
		label: 'Ohio',
		value: 'Ohio',
	},
	{
		label: 'Oklahoma',
		value: 'Oklahoma',
	},
	{
		label: 'Oregon',
		value: 'Oregon',
	},
	{
		label: 'Pennsylvania',
		value: 'Pennsylvania',
	},
	{
		label: 'Rhode Island',
		value: 'Rhode Island',
	},
	{
		label: 'South Carolina',
		value: 'South Carolina',
	},
	{
		label: 'South Dakota',
		value: 'South Dakota',
	},
	{
		label: 'Tennessee',
		value: 'Tennessee',
	},
	{
		label: 'Texas',
		value: 'Texas',
	},
	{
		label: 'Utah',
		value: 'Utah',
	},
	{
		label: 'Vermont',
		value: 'Vermont',
	},
	{
		label: 'Virginia',
		value: 'Virginia',
	},
	{
		label: 'Washington',
		value: 'Washington',
	},
	{
		label: 'West Virginia',
		value: 'West Virginia',
	},
	{
		label: 'Wisconsin',
		value: 'Wisconsin',
	},
	{
		label: 'Wyoming',
		value: 'Wyoming',
	},
];

const addressType = [{ label: 'US' }, { label: 'Foreign' }];

const otherLivings = [
	{
		question: 'During 2023 do you live somewhere other then listed above',
		bool: null,
	},
];

// Life Events
const LifeEventOptions = [
	{ question: 'Did your marital status change?', bool: null },
	{
		question:
			'Did the taxpayer, spouse, or a dependent change then name with the Social Security Administration? ',
		bool: null,
	},
	{
		question: 'Did you receive a notice or letter from the IRS or a state revenue agency? ',
		bool: null,
	},
	{
		question:
			'Did the taxpayer, spouse, or a dependent receive an identity protection PIN (IP PIN) from the IRS? ',
		bool: null,
	},
	{ question: 'Were any children born or adopted?', bool: null },
	{ question: 'Were you a member of the Armed Forces? ', bool: null },
];

// Financial Events
const FinancialEventOptions = [
	{
		question: 'Did you buy, sell, or refinance a home or rental property? ',
		bool: null,
	},
	{
		question: 'Did you incur property damage or theft caused by a federally declared disaster?',
		bool: null,
	},
	{
		question: 'Did you convert or roll over any retirement accounts?',
		bool: null,
	},
	{
		question: 'Did you receive, sell, exchange, gilt, or otherwise dispose of a digital asset?',
		bool: null,
	},
	{
		question:
			'Did you have a financial interest in or signature authority over a foreign account or trust?',
		bool: null,
	},
	{
		question: 'Did you gift $16,000 or more to another individual? ',
		bool: null,
	},
	{
		question: 'Did you purchase health insurance through the Marketplace or a public exchange? ',
		bool: null,
	},
	{
		question:
			'Did you have health insurance coverage for the entire year? (CA, DC, MA, NJ, and RI only)',
		bool: null,
	},
];

// OptionsTaxPreperationIndividualCurrentClientShort Answers
const PersonalInformationAnswers = [
	{
		question: "Were you married on the last day of the tax year?",
		bool: null
	},
	{
		question: "Your date of birth",
		values: [{ dob: new Date() }]

	},
	{
		question: "Preferred phone number",
		values: [{ phone: "" }]


	},
	{
		question: "Preferred email address",
		values: [{ email: "" }]


	},
	{
		question: "Spouse's date of birth",
		values: [{ spouseDob: new Date() }]


	},
	{
		question: "Spouse's mobile phone number",
		values: [{ spousePhone: "" }]


	},
	{
		question: "Spouse's email address",
		values: [{ spouseEmail: "" }]


	},
	{
		question: "Was there a change in address?",
		values: [{ changeAddress: "" }]


	},
	{
		question: "Did any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return?",
		bool: null
	},
	{
		question: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.",
		values: [{ describeEventOccur: "" }]
	}

]
const PersonalInformationAnswersStyles = [
	{
	},
	{
		valData: [{ placeholder: "Your date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		valData: [{ placeholder: "Preferred phone number", styleProp: "col-lg-6 col-md-8 col-sm-12" }]


	},
	{
		valData: [{ placeholder: "Preferred email address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" }]


	},
	{
		valData: [{ placeholder: "Spouse's date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }]


	},
	{
		valData: [{ placeholder: "Spouse's mobile phone number", styleProp: "col-lg-6 col-md-8 col-sm-12" }]


	},
	{
		valData: [{ placeholder: "Spouse's email address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" }]


	},
	{
		valData: [{ placeholder: "Was there a change in address?", styleProp: "col-lg-6 col-md-8 col-sm-12" }]


	},
	{
		bool: null
	},
	{
		valData: [{ placeholder: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	}

]
const dependentAnswers = [
	{
		question: "Did any of your dependent children turn 18 during the year?",
		bool: null
	},
	{
		question: "Are they current students?",
		bool: null
	},
	{
		question: "Did any births or adoptions happen in the past year?",
		bool: null,
		values: [{ name: "", placeholder: "Name", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { dob: new Date(), placeholder: "Date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { isStudent: "", placeholder: "Is this dependent a student in college full-time?" }, { monthLiveHome: "", placeholder: "How many months did this dependent live in your home?", mask: "99" }, { disabled: "", placeholder: "Is this dependent totally and permanently disabled?" }, { dependentTaxReturn: "", placeholder: "Do you want us to prepare your dependent's tax return?" }, { WasDepentPriorYearTaxReturn: "", placeholder: "Was this dependent on the prior year's tax return?" }]
	},
]
const PrimaryResidenceAnswers = [
	{
		question: "Do you plan to perform work-related tasks at home?",
		bool: null,
		values: [{ homeOfficeSquareFoot: "" }, { homeSquareFoot: "" }]
	},
	// @date 1-0
	{
		question: "Did you sell or purchase a personal residence?",
		bool: null,
		values: [{ datePurchase: new Date() }, { pricePurchase: "" }]
	},
	// @date 2-1&2
	{
		question: "Did you change your address?",
		bool: null,
		values: [{ address: "" }, { dateFrom: new Date() }, { dateTo: new Date() }]
	},
]
const PrimaryResidenceAnswersStyles = [
	{
		valData: [{ placeholder: "Home office square footage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Home square footage", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "What was the date of purchase?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "What was the purchase price?", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Date from", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Date To", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
// secondary residence
const SecondaryResidenceAnswersStyles = [
	{
		valData: [{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Mortgage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Total annual mortgage amount", mask: "999999999", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }, { placeholder: "Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	}
]
const SecondaryResidenceAnswers = [
	{
		question: "Do you own a vacation property or second home for personal use?",
		bool: null,
		values: [{ address: "" }, { propertyType: "" }, { Mortgage: "" }, { TotalAnuualMortageAmount: "" }]
	},
	{
		question: "Have you purchased or acquired an interest in any rental real estate since your last tax return?",
		bool: null,
		values: [{ address: "" }, { propertyType: "" }, { PurchasePrice: "" }, { Ownership: "" }]
	}
]
// const SecondaryResidenceAnswers = [
// 	{
// 		question:"Do you own a vacation property or second home for personal use?",
// 		bool:null,
// 		values:[{address:"",placeholder:"Address",styleProp: "col-lg-6 col-md-8 col-sm-12"},{propertyType:"",placeholder:"Type of Property?",styleProp: "col-lg-6 col-md-8 col-sm-12"},{Mortgage:"",placeholder:"Mortgage",styleProp: "col-lg-6 col-md-8 col-sm-12"},{TotalAnuualMortageAmount:"",placeholder:"Total annual mortgage amount",mask:"999999999",styleProp: "col-lg-6 col-md-8 col-sm-12"}]
// 	},
// 	{
// 		question:"Have you purchased or acquired an interest in any rental real estate since your last tax return?",
// 		bool:null,
// 		values:[{address:"",placeholder:"Address",styleProp: "col-lg-6 col-md-8 col-sm-12"},{propertyType:"",placeholder:"Type of Property?",styleProp: "col-lg-6 col-md-8 col-sm-12"},{PurchasePrice:"",placeholder:"Purchase Price",styleProp: "col-lg-6 col-md-8 col-sm-12"},{Ownership:"",placeholder:"Ownership",styleProp: "col-lg-6 col-md-8 col-sm-12"}]
// 	}
// ]
const incomeDetailsBool = [
	{
		question: "Did you receive any wages, salaries and other employee compensation?",
		bool: null,
	},
	{
		question: "Did you receive any pension, IRA and annuity income?",
		bool: null,
	},
	{
		question: "What was the total social security benefits you may have received in the past year?",
		values: [{ securityBenefits: "" }]
	},
]
const incomeDetailsBoolStyles = [
	{},
	{},
	{
		valData: [{ placeholder: "security benefits", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
// interst income styles
const interestIncomeDetailsBoolStyles = [
	{
		valData: [
			{ placeholder: "Interest income Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Name of payer for Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Banks, savings and loan (S&L), etc.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "U.S. bonds, T-bills", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Tax-exempt Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "In-state Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Out-of-state Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Early-withdrawal penalties for Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	}
]
const interestIncomeDetailsBool = [
	{
		question: "Did you have any interest income in the past year?",
		bool: null,
		values: [
			{ interestIncomeOwnership: "" },
			{ nameOfPayerForInterestIncome: "" },
			{ banksSavigAndLoan: "" },
			{ bonsTBills: "" },
			{ taxExempt: "" },
			{ inStateInterest: "" },
			{ outOfStateInterest: "" },
			{ earlyWithDrawlPenalties: "" },
		]
	},
]
// const interestIncomeDetailsBool = [
// 	{
// 		question:"Did you have any interest income in the past year?",
// 		bool:null,
// 		values:[
// 			{interestIncomeOwnership:"",placeholder:"Interest income Ownership",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{nameOfPayerForInterestIncome:"",mask:"9999999999",placeholder:"Name of payer for Interest income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{banksSavigAndLoan:"",mask:"9999999999",placeholder:"Banks, savings and loan (S&L), etc.",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{bonsTBills:"",mask:"9999999999",placeholder:"U.S. bonds, T-bills",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{taxExempt:"",placeholder:"Tax-exempt Interest income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{inStateInterest:"",mask:"9999999999",placeholder:"In-state Interest income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{outOfStateInterest:"",mask:"9999999999",placeholder:"Out-of-state Interest income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{earlyWithDrawlPenalties:"",mask:"9999999999",placeholder:"Early-withdrawal penalties for Interest income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 		]
// 	},
// ]

const dividentIncomeDetailsBoolStyles = [
	{
		valData: [
			{ placeholder: "Dividend income ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Name of payer for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Ordinary dividends", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Qualified dividends", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Capital gain distributions", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Non-taxable dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Federal tax withheld for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Foreign tax withheld for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	}
]
const dividentIncomeDetailsBool = [
	{
		question: "Did you have dividend income in the past year?",
		bool: null,
		values: [
			{ dividendIncomeOwnership: "" },
			{ nameOfPayerForIndividualIncome: "" },
			{ ordinaryDividends: "" },
			{ qualifiedDividends: "" },
			{ capitalGainDistributions: "" },
			{ nonTaxableDividendIncome: "" },
			{ federalTaxWithHeld: "" },
			{ foreignTaxWithHeld: "" },
		]
	},
]
// const dividentIncomeDetailsBool = [
// 	{
// 		question:"Did you have dividend income in the past year?",
// 		bool:null,
// 		values:[
// 			{dividendIncomeOwnership:"",placeholder:"Dividend income ownership",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{nameOfPayerForIndividualIncome:"",mask:"9999999999",placeholder:"Name of payer for dividend income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{ordinaryDividends:"",placeholder:"Ordinary dividends",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{qualifiedDividends:"",placeholder:"Qualified dividends",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{capitalGainDistributions:"",placeholder:"Capital gain distributions",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{nonTaxableDividendIncome:"",mask:"9999999999",placeholder:"Non-taxable dividend income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{federalTaxWithHeld:"",mask:"9999999999",placeholder:"Federal tax withheld for dividend income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{foreignTaxWithHeld:"",mask:"9999999999",placeholder:"Foreign tax withheld for dividend income",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 		]
// 	},
// ]

const foreignAccountsDetailBoolStyles = [
	{
		valData: [
			{ placeholder: "Name of financial institution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Address of financial institution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Account type (bank securities/ other)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Account number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "How were these assets held?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "If Jointly, Joint owner’s name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "If Jointly, Joint owner’s address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "If Jointly, Joint owner’s US taxpayer ID number", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Maximum value during the year (in the foreign currency)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	}
]
const foreignAccountsDetailBool = [
	{
		question: "Did you have any interest in, or signature or other authority over, a bank, securities or other financial account in a foreign country?",
		bool: null,
		values: [
			{ financialInstitutionName: "" },
			{ addressOfFinancialInstitution: "" },
			{ accountType: "" },
			{ accountNumber: "" },
			{ howTheseAssetsHeld: "" },
			{ jointOwnersName: "" },
			{ jointOwnersAddress: "" },
			{ jointOwnersUSTaxPayerIDNumber: "" },
			{ maximumValueDuringTheYear: "" },
		]
	},
]
// const foreignAccountsDetailBool = [
// 	{
// 		question:"Did you have any interest in, or signature or other authority over, a bank, securities or other financial account in a foreign country?",
// 		bool:null,
// 		values:[
// 			{financialInstitutionName:"",placeholder:"Name of financial institution",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{addressOfFinancialInstitution:"",placeholder:"Address of financial institution",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{accountType:"",placeholder:"Account type (bank securities/ other)",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{accountNumber:"",mask:"9999999999",placeholder:"Account number",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{howTheseAssetsHeld:"",placeholder:"How were these assets held?",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{jointOwnersName:"",placeholder:"If Jointly, Joint owner’s name",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{jointOwnersAddress:"",placeholder:"If Jointly, Joint owner’s address",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{jointOwnersUSTaxPayerIDNumber:"",mask:"9999999999",placeholder:"If Jointly, Joint owner’s US taxpayer ID number",styleProp: "col-lg-12 col-md-8 col-sm-12"},
// 			{maximumValueDuringTheYear:"",mask:"9999999999", placeholder:"Maximum value during the year (in the foreign currency)",styleProp: "col-lg-12 col-md-8 col-sm-12"},
// 		]
// 	},
// ]
// relevent to incomeDetailsBool
const otherIncomeDetailBool = [
	{
		question: "Did you receive any income or expenses from a K-1s from an entity that we did not prepare this year?",
		bool: null,
	},
	{
		values: [{ capitalGains: "" }]
	},
	{
		values: [{ incomeFromSources: "" }]
	},
]
const otherIncomeDetailBoolStyles = [
	{},
	{
		valData: [{ placeholder: "Capital Gains (or Losses)", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "Income from Partnerships, Estates, LLCs, Trusts and S corporations", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
]
const RetirementPlansBool = [
	{
		question: "Did you convert IRA funds or any other qualified retirement plan funds into a Roth IRA?",
		bool: null,
	},
]
const HealthAndMedicalFields = [
	{
		values: [
			{ securityBenefits: "" },
			{ securityBenefits: "" },
			{ securityBenefits: "" },
			{ securityBenefits: "" },
		]
	},
]
const HealthAndMedicalFieldsStyles = [
	{
		valData: [
			{ mask: "9999999999", placeholder: "Family medical insurance premiums", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Other medical and dental expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Premiums for health and accident insurance including Medicare, not claimed elsewhere", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "What are your other unreimbursed medical expenses not already submitted above?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]
const otherDeductionSummaryFields = [
	{
		question: "What are the total unreimbursed business expenses?",
		values: [
			{ unreimbursedBusinessExpensesNinteen: "" },
			{ unreimbursedBusinessExpensesTwenty: "" },
			{ unreimbursedBusinessExpensesTwentyOne: "" },
		]
	},
	{
		question: "What is the total student loan interest deduction?",
		values: [
			{ studentLoanInerestNinteen: "" },
			{ studentLoanInerestTwenty: "" },
			{ studentLoanInerestTwentyOne: "" },
		]
	},
]
const otherDeductionSummaryFieldsStyles = [
	{
		valData: [
			{ mask: "9999999999", placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		valData: [
			{ mask: "9999999999", placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
]
const otherAdjustmentBool = [
	{
		question: "Did you receive any distributions from an HSA? Were all distributions made for qualified medical expenses?",
		bool: null,
	},
]
const itemizedDeductionsDetail = [
	{
		question: "Did you have any taxes paid?",
		bool: null,
	},
]
const realEstateTaxes = [
	// {
	// 	question:"Real estate taxes for primary residence.)",
	// 	values:[{unreimbursedBusinessExpenses:"",mask:"9999999999",placeholder:"Real estate taxes for primary residence",styleProp: "col-lg-12 col-md-8 col-sm-12"}]
	// },
	{
		question: "Sales tax on major items (auto, boat, home improvements, etc.)",
		values: [
			{ unreimbursedBusinessExpenses: "" },
			{ studentLoanInerest: "" }
		]
	},
	// 4 bools
	{
		question: "Did you pay mortgages interest for primary residence?",
		bool: null,
	},
	{
		question: "Did you incur expenses in performing volunteer work for charitable organizations?",
		bool: null,
	},
	{
		question: "Did you make charitable contributions?",
		bool: null,
	},
	{
		question: "Did you pay an individual or an organization to perform services for the care of a dependent under 13 years old?",
		bool: null,
	},
	//3 input fields 
	{
		question: "Volunteer work other expenses",
		values: [{ volunteerWorkOtherExpenses: "" }]
	},
	{
		question: "Volunteer work automobile mileage",
		values: [{ volunteerWorkOtherAutomobileMileage: "" }]
	},
	{
		question: "Please describe the service paid for as well as the total amount paid.",
		values: [{ describeTheServicePaid: "" }]
	},
]
const realEstateTaxesStyles = [
	{
		valData: [
			{ placeholder: "Description Of Tax", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ mask: "9999999999", placeholder: "Tax amount", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	// 4 bools
	{
		question: "Did you pay mortgages interest for primary residence?",
		bool: null,
	},
	{
		question: "Did you incur expenses in performing volunteer work for charitable organizations?",
		bool: null,
	},
	{
		question: "Did you make charitable contributions?",
		bool: null,
	},
	{
		question: "Did you pay an individual or an organization to perform services for the care of a dependent under 13 years old?",
		bool: null,
	},
	//3 input fields 
	{
		valData: [{ mask: "9999999999", placeholder: "Volunteer work other expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ mask: "9999999999", placeholder: "Volunteer work automobile mileage", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ mask: "9999999999", placeholder: "Please describe the service paid for as well as the total amount paid.", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
]
// const realEstateTaxes = [
// 	// {
// 	// 	question:"Real estate taxes for primary residence.)",
// 	// 	values:[{unreimbursedBusinessExpenses:"",mask:"9999999999",placeholder:"Real estate taxes for primary residence",styleProp: "col-lg-12 col-md-8 col-sm-12"}]
// 	// },
// 	{
// 		question:"Sales tax on major items (auto, boat, home improvements, etc.)",
// 		values:[
// 			{unreimbursedBusinessExpenses:"",mask:"9999999999",placeholder:"Description Of Tax",styleProp: "col-lg-6 col-md-8 col-sm-12"},
// 			{studentLoanInerest:"",mask:"9999999999",placeholder:"Tax amount",styleProp: "col-lg-6 col-md-8 col-sm-12"}
// 		]
// 	},
// 	// 4 bools
// 	{
// 		question:"Did you pay mortgages interest for primary residence?",
// 		bool:null,
// 	},
// 	{
// 		question:"Did you incur expenses in performing volunteer work for charitable organizations?",
// 		bool:null,
// 	},
// 	{
// 		question:"Did you make charitable contributions?",
// 		bool:null,
// 	},
// 	{
// 		question:"Did you pay an individual or an organization to perform services for the care of a dependent under 13 years old?",
// 		bool:null,
// 	},
// 	//3 input fields 
// 	{
// 		question:"Volunteer work other expenses",
// 		values:[{volunteerWorkOtherExpenses:"",mask:"9999999999",placeholder:"Volunteer work other expenses",styleProp: "col-lg-6 col-md-8 col-sm-12"}]
// 	},
// 	{
// 		question:"Volunteer work automobile mileage",
// 		values:[{volunteerWorkOtherAutomobileMileage:"",mask:"9999999999",placeholder:"Volunteer work automobile mileage",styleProp: "col-lg-6 col-md-8 col-sm-12"}]
// 	},
// 	{
// 		question:"Please describe the service paid for as well as the total amount paid.",
// 		values:[{describeTheServicePaid:"",mask:"9999999999",placeholder:"Please describe the service paid for as well as the total amount paid.",styleProp: "col-lg-12 col-md-8 col-sm-12"}]
// 	},
// ]
const educationalExpenses = [
	{
		question: "Did you or any other member of your family pay attend a post secondary educational institute this year?",
		bool: null,
	}
]
const otherCreditsFields = [
	// 8 bools
	{
		question: "Did you purchase an energy efficient or other new vehicle?",
		bool: null,
	},
	{
		question: "Did you make any energy-efficient improvements (remodel or new construction) to your home?",
		bool: null,
	},
	{
		question: "Did you purchase and place in service any solar water heating, solar electric, fuel cells, small wind energy or geothermal heat pump to any property you own (not just your home)?",
		bool: null,
	},
	{
		question: "Did you incur adoption expenses or adopt a U.S. child that the state has determined to have special needs?",
		bool: null,
	},
	{
		question: "Do you want any overpayment of taxes applied to next year’s estimated taxes?",
		bool: null,
	},
	{
		question: "Do you want any federal or state refund deposited directly into your bank account?",
		bool: null,
	},
	{
		question: "Do you want any balance due directly withdrawn from this same bank account on the due date?",
		bool: null,
	},
	{
		question: "Do you want next year’s estimated taxes withdrawn from this same bank account on the due dates?",
		bool: null,
	},
	// input
	{
		question: "Other Taxes, Tax Payments and Refunds",
		values: [{ otherTaxes: "" }]
	},
]
const otherCreditsFieldsStyles = [
	// 8 bools
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	// input
	{
		valData: [{ placeholder: "Other Taxes, Tax Payments and Refunds" }]
	},
]
const federalPriorYear = [
	{
		question: "Did you have any state prior year overpayment applied?",
		bool: null,
	},
	{
		question: "Did you make any federal estimated tax payments last year?",
		bool: null,
	},
	{
		question: "Did you make any state estimated tax payments last year?",
		bool: null,
	},
	// 7 inputs
	{
		question: "Overpayment State",
		values: [{ overPaymentState: "" }]
	},
	{
		question: "Overpayment Amount",
		values: [{ overPaymentAmount: "" }]
	},
	// i5
	{
		question: "Federal estimated tax payments Date",
		values: [{ federalEstimatedTaxDate: new Date() }]
	},
	{
		question: "Federal estimated tax payments amount",
		values: [{ federalEstimatedTaxAmount: "" }]
	},
	{
		question: "State estimated tax payments state",
		values: [{ stateEstimatedTaxPaymentsState: "" }]
	},
	// i8
	{
		question: "State estimated tax payments date",
		values: [{ stateEstimatedTaxPaymentsDate: new Date() }]
	},
	{
		question: "State estimated tax payments amount",
		values: [{ stateEstimatedTaxPaymentsAmount: "" }]
	},
];
const federalPriorYearStyles = [
	{},
	{},
	{},
	// 7 inputs
	{
		valData: [{ placeholder: "Overpayment State", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "Overpayment Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		valData: [{ placeholder: "Federal estimated tax payments Date", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "Federal estimated tax payments amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		valData: [{ placeholder: "State estimated tax payments state", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "State estimated tax payments date", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "State estimated tax payments amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
];
const additionalQuestions = [
	{
		question: "Did you receive an economic stimulus payment in the prior year?",
		bool: null,
		values: [
			{ nameOfRecipient: "" },
			{ paymentReceivedOn: new Date() },
			{ totalAmountOfPaymentReceived: "" },
		]
	},
];
const additionalQuestionsStyles = [
	{
		valData: [
			{ placeholder: "Name of recipient", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Payment received on", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total amount of payment received", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
];
// Other  Questions

const otherQuestionsOptions = [
	{
		question:
			'Did you make a coronavirus-related distribution from a retirement account during 2020?',
		bool: null,
	},
	{
		question: 'Did our firm prepare your 2021 tax returns?',
		bool: null,
	},
];

// Income Sources Options
const IncomeSourcesList = [
	{ question: 'Employment (W-2)' },
	{ question: 'Retirement distribution (1099-RI)' },
	{ question: 'Social Security (SSA-1099)' },
	{ question: 'self-employment (1099-NEC or 1099-K)' },
	{ question: 'State or local tax refund (1099-G)' },
	{ question: 'Unemployment 11099-G)' },
	{ question: 'Interest (1099-INTJ)' },
	{ question: 'Dividends 11099-D(V)' },
	{ question: 'Sold stock or investments (1099-B)' },
	{ question: 'Canceled debt (1099-C)' },
	{ question: 'Rents (1099-IASC)' },
	{ question: 'Royalties (1099-MISC)' },
	{ question: 'ESA or 529 distribution (1099-Q)' },
	{ question: 'HS.A or MSA distribution (1099-SA1)' },
	{ question: "Partnership 'Schedule K-1)" },
	{ question: 'Sectxporation (Schedule K-1)' },
	{ question: 'Estate or trust (Schedule K-1)' },
	{ question: 'Gambling 1W-2G1' },
	{ question: 'Farming' },
	{ question: 'Other income' },
];

// Expenses Summary

const expensesSummary = [
	{
		question: 'Did you pay any of the following expenses during 2023?',
		bool: null,
	},
];

const possibleExpenses = [
	{
		question: 'Adoption expenses',
		bool: null,
	},
	{
		question: 'Alimony from a divorce finalized on or before December 31, 2018',
		bool: null,
	},
	{
		question: 'Child or dependent care expenses',
		bool: null,
	},
	{
		question: 'Educator expenses',
		bool: null,
	},
	{
		question: 'Higher education expenses',
		bool: null,
	},
	{
		question: 'Household worker expenses',
		bool: null,
	},
	{
		question: 'Contributions to a health savings account (HSA)',
		bool: null,
	},
	{
		question: 'Contributions to an individual retirement arrangement (IRA)',
		bool: null,
	},
	{
		question: 'Student loan interest',
		bool: null,
	},
	{
		question: 'Energy-efficient home improvements',
		bool: null,
	},
];
// 
const possibleShutDowns = [
	{
		question: 'Quarter 1',
	},
	{
		question: 'Quarter 2',
	},
	{
		question: 'Quarter 3',
	},
	{
		question: 'Quarter 4',
	},
];
// Deduction Form

const deductionOptions = [
	{
		question: ' Would you like to take the standard deduction or enter itemized deductions?',
		options: ['Take the standard deduction', 'Enter itemized deductions'],
	},
];
const possibledeductionOptions = [
	{
		question: 'Medical and dental expenses',
		amount: null,
	},
	{
		question: 'Mortgage interest ',
		amount: null,
	},
	{
		question: 'State and local income taxes',
		amount: null,
	},
	{
		question: 'Donations to charity (cash)',
		amount: null,
	},
	{
		question: 'Sales taxes ',
		amount: null,
	},
	{
		question: 'Donations to charity (non-cash)',
		amount: null,
	},
	{
		question: 'Real estate taxes',
		amount: null,
	},
	{
		question: 'Casualty and theft losses ',
		amount: null,
	},
	{
		question: 'Personal property taxes',
		amount: null,
	},
	{
		question: 'Gambling Losses',
		amount: null,
	},
];

// Estimate Form

const estimateTaxesOptions = [
	{
		question: ' Did you make any 2023 estimated tax payments or apply your 2021 refund to 2023?',
		options: ['Yes', 'No'],
	},
];

const federalPaymentsOptions = [
	{
		question: 'Overpayment applied from prior year',
		amount: null,
		date: 'not Exist',
	},
	{
		question: 'First quarterly payment',
		amount: null,
		date: null,
	},
	{
		question: 'Second quarterly payment',
		amount: null,
		date: null,
	},
	{
		question: 'Third quarterly payment',
		amount: null,
		date: null,
	},
	{
		question: 'Fourth quarterly payment ',
		amount: null,
		date: null,
	},
	{
		question: 'Additional payment ',
		amount: null,
		date: null,
	},
];

const businessIncome = [
	{
		question: "Do you have a copy of financial statements, including Profit and Loss and Balance Sheets you wish to attach?",
		bool: null,
	},
	{
		question: 'Gross receipts or sales',
		amount: null,
		description: null,
	},
	{
		question: 'Returns and allowances',
		amount: null,
		description: null,
	},

]

// BusinessExpences
const businessExpencesDescAmount = [
	{
		question: 'Inventory at end of year',
		amount: null,
		discrption: null,
	},
	{
		question: 'Advertising',
		amount: null,
		discrption: null,
	},
	{
		question: 'Bad debts from sales or services',
		amount: null,
		discrption: null,
	},
	{
		question: 'Commissions and fees',
		amount: null,
		discrption: null,
	},
	{
		question: 'Depletion',
		amount: null,
		discrption: null,
	},
	{
		question: 'Depreciation and Sec 179 expense deduction',
		amount: null,
		discrption: null,
	},
	{
		question: 'Employee health insurance and other benefit programs (excluding retirement plans)',
		amount: null,
		discrption: null,
	},
	{
		question: 'Employee retirement contribution (other than owner)',
		amount: null,
		discrption: null,
	},
	{
		question: 'Car and truck expenses (complete the vehicle expense schedule)',
		amount: null,
		discrption: null,
	},
	{
		question: 'Self-employed owner: Health insurance premiums',
		amount: null,
		discrption: null,
	},
	{
		question: 'Self-employed owner: Retirement contributions',
		amount: null,
		discrption: null,
	},
	{
		question: 'Did you pay any state income tax?',
		amount: null,
		discrption: null,
	},
	{
		question: 'Does the business have an accountable plan in place (for expenses)?',
		amount: null,
		discrption: null,
	},
];
const businessExpencesStateDesc = [
	{
		question: 'Insurance (other than health)',
		state: null,
		description: null,
	},
	{
		question: 'Mortgage interest paid to banks, etc.',
		state: null,
		description: null,
	},
	{
		question: 'Other interest',
		state: null,
		description: null,
	},
	{
		question: 'Legal and professional services',
		state: null,
		description: null,
	},
	{
		question: 'Rent or lease: Vehicles, machinery and equipment',
		state: null,
		description: null,
	},
	{
		question: 'Rent or lease: Real estate or other business property',
		state: null,
		description: null,
	},
	{
		question: 'Repairs and maintenance',
		state: null,
		description: null,
	},
	{
		question: 'Supplies',
		state: null,
		description: null,
	},
	{
		question: 'Taxes and licenses (do not include state income tax)',
		state: null,
		description: null,
	},
	{
		question: 'Have you traveled or are you planning on traveling for business?',
		state: null,
		description: null,
	},
	{
		question: 'Automobile miles traveled',
		state: null,
		description: null,
	},
	{
		question: 'Travel transportation costs (plane tickets, tolls, etc)',
		state: null,
		description: null,
	},
	{
		question: 'Hotel and lodging costs',
		state: null,
		description: null,
	},
	{
		question: 'Travel meals (Restaurants only)',
		state: null,
		description: null,
	},
	{
		question: 'Travel meals (Non restaurants)',
		state: null,
		description: null,
	},
	{
		question: 'Other travel costs',
		state: null,
		description: null,
	},
	{
		question: 'What are the total meal expenses incurred or planning to incur related to business meals in restaurants?',
		state: null,
		description: null,
	},
	{
		question: 'What are the total meal expenses incurred or planning to incur in 2021 related to promotional activities that are made available to the general public, employer-provided social/recreational expenses or business gifts?',
		state: null,
		description: null,
	},
	{
		question: 'What are the total meal expenses incurred or planning to incur in 2021 provided on the employer’s premises for the employer’s convenience?',
		state: null,
		description: null,
	},
	{
		question: 'What are the total other business meal expenses incurred or planning to incur in 2021?',
		state: null,
		description: null,
	},
	{
		question: 'Entertainment',
		state: null,
		description: null,
	},
	{
		question: 'Utilities',
		state: null,
		description: null,
	},
	{
		question: 'Wages',
		state: null,
		description: null,
	},
	{
		question: 'Lobbying expenses',
		state: null,
		description: null,
	},
	{
		question: 'Club dues',
		state: null,
		description: null,
	},
	{
		question: 'Social or entertainment club dues',
		state: null,
		description: null,
	},
];
const bIncome = [
	{
		question: 'What is the entity expected gross revenue?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'What is the entity expected net profit or loss?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'What are your expected W-2 wages (from this business)? Note: If you did not receive W-2 wages as a Schedule C entity, enter $0.',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'What are your expected dividends on form 1099-DIV (from this business)?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'What are your expected guaranteed payments on Form K-1 (from this business)?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'How much does your cash compensation (wages, distributions, dividends, etc) do you need from this entity annually in order to maintain your lifestyle (from this business)?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'What are your spouse\'s expected W-2 wages (from this business)?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'What are your spouse\'s expected dividends on form 1099-DIV (from this business)?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'What are your spouse\'s expected guaranteed payments on Form K-1 (from this business)?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
	{
		question: 'What is the total expected owners compensation including taxes for all OTHER owners (not including you or your spouse)?',
		twentyTwenty: null,
		twentyTwentyOne: null,
		twentyTwentyTwo: null,
	},
];
const futurePartners = [
	{
		question: 'If you are, or were to convert to a S Corporation, how many shareholders are in the S Corporation?',
		twentyNineteen: null,
		twentyTwenty: null,
		twentyTwentyOne: null,
	},
	{
		question: 'If you are, or were to convert to a Partnership, how many partners are in the Partnership?',
		twentyNineteen: null,
		twentyTwenty: null,
		twentyTwentyOne: null,
	},
	{
		question: 'If you are, or were to convert to a Partnership, are you a general or a limited partner? A general partner is assumed.',
		twentyNineteen: null,
		twentyTwenty: null,
		twentyTwentyOne: null,
	},
];
const insuranceInputs = [
	{
		question: 'What percentage of gross revenue would you like to fund towards your reinsurance company?',
		descriptionOfRiskItem: null,
		potentialLiability: null,
	},
	{
		question: 'What is the potential liability amount to be covered by captive insurance? Enter as a positive number?',
		descriptionOfRiskItem: null,
		potentialLiability: null,
	},
];

// Refund And Payment Options
const refundPaymentOptions = [
	{
		question: 'If you are due a refund, how would you like to receive it?',
		options: ['Direct deposit into a bank account', 'Paper check by mail'],
	},
];

const refundPaymentOptions1 = [
	{
		question: 'If you owe a balance, how would you like to pay it?',
		options: [
			'Draft payment from a bank account ',
			'Mail a check',
			'Pay by credit card (additional costs apply)',
			'Setup a payment plan (additional costs apply)',
		],
	},
];
const refundBankDetails = [
	{
		question: 'Financial institution name',
		amount: null,
	},
	{
		question: 'Routing number',
		amount: null,
		numeric: true,
	},
	{
		question: 'Account number ',
		amount: null,
		numeric: true,
	},
	{
		question: 'Account holder name',
		amount: null,
	},
];

const refundAccountHolderType = [
	{
		question: 'Account type',
		options: ['Checking', 'Savings'],
	},
];

const refundAccountNature = [
	{
		question: 'Is this a personal or business account?',
		options: ['Personal', 'Business'],
	},
];

const refundAccountHolderNationality = [
	{
		question: 'Select if applicable to this account',
		options: ['IRA', 'Non-U.S'],
	},
];

const Options1065QuestionsPart1 = [
	{
		question: 'Did our firm prepare the 2021 tax returns for this business?',
		bool: null,
	},
	{
		question: 'Did the business change its legal name?',
		bool: null,
	},
	{
		question:
			'During the 2023 calendar year, did the partnership have an interest in or a signature or other authority over a financial account in a foreign country?',
		bool: null,
	},
	{
		question:
			'Did the partnership pay $600 or more of non-employee compensation to any Individual during the year? ',
		bool: null,
	},
];

const Options1065QuestionsPart2 = [
	{
		question:
			'At the end of the tax year did any foreign or domestic corporation, partnership, trust, or tax-exempt organization, or any foreign government directly or indirectly own, an interest of 50% or more in the profit, loss, or capital of the partnership? ',
		bool: null,
	},
	{
		question:
			'At the end of the tax year did any individual or estate directly or indirectly own, an interest of 50% or more in the profit, loss, or capital of the partnership? ',
		bool: null,
	},
	{
		question:
			'At the end of the tax year, did the partnership directly own 20% or more, or directly or indirectly own, 50% or more of the total voting power of all classes of stock entitled to vote of any foreign or domestic corporation?',
		bool: null,
	},
	{
		question:
			'At the end of the tax year, did the partnership directly own an interest of 20% or more, or directly or indirectly own, an interest of 50% or more in the profit, loss, or capital in any foreign or domestic partnership or in the beneficial interest of a trust? ',
		bool: null,
	},
	{
		question:
			'Did the partnership have any debt that was canceled, was forgiver), or had the terms modified so as to reduce the principal amount of the debt? ',
		bool: null,
	},
];
const OptionsForTaxPlanningIndividual = [
	{
		question:
			'Did the business make payment(s) to foreign person(s) that would require it to file an annual withholding tax return (Forms 1042 and 1042-S)?',
		bool: null,
	},
	{
		question:
			'Does the entity do business in more than one state?',
		bool: null,
	},
	{
		question:
			'Do you expect to sell the business in the next two years?',
		bool: null,
	},
	{
		question:
			'Did the business discontinue operations this year? If yes, provide details.',
		bool: null,
	},
];
// 
const businessGeneralFinancesOptions = [
	{
		question:
			'Did the business change any accounting methods during the year?',
		bool: null,
	},
	{
		question:
			'Has an application for a change in accounting method (Form 3115) been filed?',
		bool: null,
	},
	{
		question:
			'Can the IRS or other tax authorities discuss questions about this return with the preparer?',
		bool: null,
	},
	{
		question:
			'Does the business file use tax returns in any states?',
		bool: null,
	},
	{
		question:
			'Did the business own securities that became worthless or have loans that became uncollectible during the year?',
		bool: null,
	},
	{
		question:
			'Did the business make any sales qualifying for the installment method of reporting?',
		bool: null,
	},
	{
		question:
			'Did the business receive any contribution in aid or construction or any other contribution from a customer or potential customer or any contribution from any governmental entity or civic group (other than contributions made by a shareholder in its capacity as a shareholder)?',
		bool: null,
	},
	{
		question:
			'Did the business make political contributions during this tax year?',
		bool: null,
	},
	{
		question:
			'Did the business incur any expenses to influence legislation (lobbying)?',
		bool: null,
	},
	{
		question:
			'Did the business have loans with owners or other related parties during the tax year?',
		bool: null,
	},
	{
		question:
			'Does the business own an interest in any other entity including but not limited to a partnership, C corporation, LLC, S corporation, trust or disregarded entity?',
		bool: null,
	},
	{
		question:
			'Did the business pay penalties or fines?',
		bool: null,
	},
	{
		question:
			'Does the business have inventory?',
		bool: null,
	},
	{
		question:
			'Was there any change in determining quantities, costs or valuations between the opening and closing inventory?',
		bool: null,
	},
	{
		question:
			'Did the business make any payments during the year that would require you to file Forms 1099?',
		bool: null,
	},
	{
		question:
			'If yes, did you file Forms 1099?',
		bool: null,
	},
	{
		question:
			'Does the business have any unpaid use tax?',
		bool: null,
	},
	{
		question:
			'If required, do you agree to have your business return filed electronically?',
		bool: null,
	},
	// {
	// 	question:
	// 		'Will all compensation-related accruals (including vacation pay) be paid within 2½ months of year end?',
	// 	bool: null,
	// },
];


// const BusinessVehiclesQuestions = [
// 	{
// 		question: 'Does the business maintain a written policy that prohibits all personal use of vehicles, including commuting, by employees?',
// 		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
// 	},
// 	{
// 		question: 'Does the business maintain a written policy that prohibits personal use of vehicles, excluding commuting, by employees?',
// 		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

// 	},
// 	{
// 		question: 'Does the business treat all use of vehicles by employees as personal use?',
// 		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

// 	},
// 	{
// 		question: 'Does the business provide more than five vehicles to employees and retain the information received from employees concerning the use of the vehicles?',
// 		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

// 	},
// 	{
// 		question: 'Does the business require or maintain copies of vehicle logs?',
// 		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

// 	},

// ]

const BusinessVehiclesAnswersStyles = [
	{
		valData: [{ placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Do you have another vehicle available for personal purposes?" }, { placeholder: "Do you have evidence to support your deduction?" }, { placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Percent of time vehicle used for business" }, { placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Tires and other vehicle supplies" }, { placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
const BusinessVehiclesAnswers = [
	{
		question: 'Does the business maintain a written policy that prohibits all personal use of vehicles, including commuting, by employees?',
		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: 'Does the business maintain a written policy that prohibits personal use of vehicles, excluding commuting, by employees?',
		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: 'Does the business treat all use of vehicles by employees as personal use?',
		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: 'Does the business provide more than five vehicles to employees and retain the information received from employees concerning the use of the vehicles?',
		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: 'Does the business require or maintain copies of vehicle logs?',
		values: [{ description: '', placeholder: 'Description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { datePlaced: '', placeholder: 'Date Placed', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalBusinessMiles: "", placeholder: "Total Business Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalCoumtingMiles: "", placeholder: "Total Coumting Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { totalOtherPersonalMiles: "", placeholder: "Total Other Personal Miles", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherPersonalVehicle: "", placeholder: "Do you have another vehicle available for personal purposes?" }, { evidenceSupportDeduction: "", placeholder: "Do you have evidence to support your deduction?" }, { writtenEvidence: "", placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedVehicleTimePercentage: "", placeholder: "Percent of time vehicle used for business" }, { parking: "", placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tolls: "", placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleTaxes: "", placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loadLeasePayment: "", placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleInsurance: "", placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { repaireMaintenance: "", placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { inspectionRegistration: "", placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAnnualVehicleExpenses: "", placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { gasOil: "", placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { vehicleLoadInterest: "", placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { tiresOtherSupplies: "", placeholder: "Tires and other vehicle supplies" }, { costFairMarketValue: "", placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { leaseTerm: "", placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},

]
const BusinessVehiclesRadioAnswers = [
	{
		question: 'Does the business maintain a written policy that prohibits all personal use of vehicles, including commuting, by employees?',
		bool: null
	},
	{
		question: 'Does the business maintain a written policy that prohibits personal use of vehicles, excluding commuting, by employees?',
		bool: null
	},
	{
		question: 'Does the business treat all use of vehicles by employees as personal use?',
		bool: null
	},
	{
		question: 'Does the business provide more than five vehicles to employees and retain the information received from employees concerning the use of the vehicles?',
		bool: null
	},
	{
		question: 'Does the business require or maintain copies of vehicle logs?',
		bool: null
	},

]
const SalesAssetsAnswers = [
	{
		question: 'Do you expect to sell significant business assets for a gain this year?',
		values: [{ assetName: '', placeholder: 'Name of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { expectedSellingPrice: '', placeholder: 'Expected selling price of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { expectedgainSale: '', placeholder: 'Expected gain on sale of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { sellHoldLoan: '', placeholder: 'If willing to sell asset as an installment sale, how many years would you be willing to hold the loan?' }, { gainOpportunityZoneInvestment: "", placeholder: "How much of the gain on the sale would you be willing to contribute to an Opportunity Zone Investment?" }, { exchangeRealEstateAsset: "", placeholder: "If this is real estate, how much would you be willing to exchange into another real estate asset?" }]
	},
]
const PurchaseAssetsAnswers = [
	{
		question: 'Do you expect to purchase an asset in the current year (non real estate)?',
		values: [{ assetDescription: '', placeholder: 'Asset description', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { loanLeasePayments: '', placeholder: 'Loan / Lease Payments', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { insurance: '', placeholder: 'Insurance (if applicable)', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { otherAssetExpenses: '', placeholder: 'Other asset expenses', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usedBusinessPercentage: "", placeholder: "% used for business (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
const CorporateCSCorpAnswers = [
	{
		question: 'Does the corporation compensate employees or directors using restricted property, including options to purchase stock or restricted stock?',
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { title: '', placeholder: 'Title', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { socialSecurityNumber: '', placeholder: 'Social Security Number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { compensation: "", placeholder: "Compensation", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { timeDevotedBusinessPercentage: '', placeholder: 'Percentage of time devoted to business' }, { commonStockOwnedPercentage: "", placeholder: "Percentage common stock owned" }, { preferredStockOwnedPercentage: "", placeholder: "Percentage preferred stock owned" }]
	},
	{
		question: "Does the corporation pay life insurance premiums (other than group-term life) for officers of the corporation?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { title: '', placeholder: 'Title', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { socialSecurityNumber: '', placeholder: 'Social Security Number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { compensation: "", placeholder: "Compensation", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { timeDevotedBusinessPercentage: '', placeholder: 'Percentage of time devoted to business' }, { commonStockOwnedPercentage: "", placeholder: "Percentage common stock owned" }, { preferredStockOwnedPercentage: "", placeholder: "Percentage preferred stock owned" }]

	},
	{
		question: "Did the corporation purchase life insurance on any employee after Aug. 17, 2006?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { title: '', placeholder: 'Title', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { socialSecurityNumber: '', placeholder: 'Social Security Number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { compensation: "", placeholder: "Compensation", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { timeDevotedBusinessPercentage: '', placeholder: 'Percentage of time devoted to business' }, { commonStockOwnedPercentage: "", placeholder: "Percentage common stock owned" }, { preferredStockOwnedPercentage: "", placeholder: "Percentage preferred stock owned" }]

	},
	{
		question: "If yes, have employees been notified?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { title: '', placeholder: 'Title', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { socialSecurityNumber: '', placeholder: 'Social Security Number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { compensation: "", placeholder: "Compensation", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { timeDevotedBusinessPercentage: '', placeholder: 'Percentage of time devoted to business' }, { commonStockOwnedPercentage: "", placeholder: "Percentage common stock owned" }, { preferredStockOwnedPercentage: "", placeholder: "Percentage preferred stock owned" }]

	},
	{
		question: "Did the corporation include taxable fringe or welfare benefits, such as health insurance, group-term life insurance, educational assistance, non-accountable expense allowances and personal use of corporate vehicles in compensation on employees’ Forms W-2 and, if applicable, subject such amounts to payroll taxes?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { title: '', placeholder: 'Title', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { socialSecurityNumber: '', placeholder: 'Social Security Number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { compensation: "", placeholder: "Compensation", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { timeDevotedBusinessPercentage: '', placeholder: 'Percentage of time devoted to business' }, { commonStockOwnedPercentage: "", placeholder: "Percentage common stock owned" }, { preferredStockOwnedPercentage: "", placeholder: "Percentage preferred stock owned" }]

	},
	{
		question: "At year end, did the corporation own, directly or indirectly, 50% or more of the voting stock of a domestic corporation?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { title: '', placeholder: 'Title', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { socialSecurityNumber: '', placeholder: 'Social Security Number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { compensation: "", placeholder: "Compensation", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { timeDevotedBusinessPercentage: '', placeholder: 'Percentage of time devoted to business' }, { commonStockOwnedPercentage: "", placeholder: "Percentage common stock owned" }, { preferredStockOwnedPercentage: "", placeholder: "Percentage preferred stock owned" }]

	},
	{
		question: "At year end, did any corporation, individual, partnership, trust or estate own, directly or indirectly, 50% or more of the corporation’s voting stock?",
		values: [{ corporationName: '', placeholder: 'Corporation name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownedPercentage: '', placeholder: 'Percentage owned', styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Do the shareholders owning 80% or more of this corporation own 80% or more of any other corporation?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identification number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownershipPercentage: "", placeholder: "Ownership percentage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usCitizen: '', placeholder: 'US Citizen', styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Is this corporation a shareholder of any foreign corporation? If yes, identify each corporation.",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identification number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownershipPercentage: "", placeholder: "Ownership percentage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usCitizen: '', placeholder: 'US Citizen', styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "Is this corporation a partner in any foreign partnership? If yes, identify each partnership.",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identification number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownershipPercentage: "", placeholder: "Ownership percentage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usCitizen: '', placeholder: 'US Citizen', styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "Did this corporation own a disregarded entity for tax purposes at any time during the year? If yes, provide details",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identification number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownershipPercentage: "", placeholder: "Ownership percentage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usCitizen: '', placeholder: 'US Citizen', styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "Does an individual own (directly, indirectly or constructively) at least 80% of the voting stock of the corporation and does the corporation have at least 50% of its assets produce or held for the production of passive income?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identification number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownershipPercentage: "", placeholder: "Ownership percentage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usCitizen: '', placeholder: 'US Citizen', styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "If yes, does the corporation have an interest in specified foreign financial assets valued at more than $50,000 on the last day of the tax year, or more than $75,000 at any time during the year for assets not previously listed for FinCEN 114 reporting?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identification number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownershipPercentage: "", placeholder: "Ownership percentage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { usCitizen: '', placeholder: 'US Citizen', styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "During this taxable year did the corporation pay dividends?",
		values: [{ assetDescription: '', placeholder: 'Description of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identifyingNumber: '', placeholder: 'Identifying number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { dateDisposedYear: '', placeholder: 'Date acquired or disposed of during the year' }, { maxValueDuringYear: "", placeholder: "Maximum value during the year (in the foreign currency)" }, { currencyExchangeRate: '', placeholder: 'Currency and exchange rate used' }, { foreignEntityAsset: "", placeholder: "If asset is a stock of a foreign entity provide name, type, and mailing address" }, { notAForeignEntityAsset: "", placeholder: "If asset is NOT a stock of a foreign entity provide name of issuer, type, and mailing address" }]

	},
	{
		question: "Did one foreign person, at any time during the tax year, own directly or indirectly, 25% or more of the total voting power or value of all classes of stock of the corporation?",
		values: [{ assetDescription: '', placeholder: 'Description of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identifyingNumber: '', placeholder: 'Identifying number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { dateDisposedYear: '', placeholder: 'Date acquired or disposed of during the year' }, { maxValueDuringYear: "", placeholder: "Maximum value during the year (in the foreign currency)" }, { currencyExchangeRate: '', placeholder: 'Currency and exchange rate used' }, { foreignEntityAsset: "", placeholder: "If asset is a stock of a foreign entity provide name, type, and mailing address" }, { notAForeignEntityAsset: "", placeholder: "If asset is NOT a stock of a foreign entity provide name of issuer, type, and mailing address" }]
	}
]
const CSCorpAnswers = [
	{
		question: "Have fringe benefits paid on behalf of more than two-percent shareholders (including, but not limited to medical, life insurance, disability, housing, etc.) been included in the shareholder’s compensation and subjected to payroll taxes, if applicable?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { percentageOwned: '', placeholder: 'Percentage owned', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownerCountry: '', placeholder: 'Owner\'s country', styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Indicate to which accounts these amounts have been posted. These rules also apply to relatives of more than two-percent shareholders.",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { percentageOwned: '', placeholder: 'Percentage owned', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ownerCountry: '', placeholder: 'Owner\'s country', styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	}
]
const PartnerShipAnswers = [
	{
		question: "Which general partner, LLC member or third party should be designated as the partnership representative?",
		values: [{ name: '', placeholder: 'Name', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { taxPayerIdentification: '', placeholder: 'Taxpayer Identification', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { contactInformation: '', placeholder: 'Contact information', styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Was there a distribution of property or a transfer (for example, by sale or death) of a partnership or LLC interest during this tax year?",
		values: [{ transferFrom: '', placeholder: 'Transferred from', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferTo: '', placeholder: 'Transferred to', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferDate: '', placeholder: 'Date of transfer', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferType: '', placeholder: 'Type of transfer', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { fairMarketValue: "", placeholder: "Sale price or fair market value (FMV) of partnership interest transferred" }]
	},
	{
		question: "Has the partnership or LLC ever elected to “step up” the basis of any assets in connection with the death of a partner/member or a change in ownership (Sec. 754 election)?",
		values: [{ transferFrom: '', placeholder: 'Transferred from', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferTo: '', placeholder: 'Transferred to', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferDate: '', placeholder: 'Date of transfer', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferType: '', placeholder: 'Type of transfer', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { fairMarketValue: "", placeholder: "Sale price or fair market value (FMV) of partnership interest transferred" }]

	},
	{
		question: "Does an individual own (directly, indirectly or constructively) at least 80% of the capital or profit interest in the partnership and does the partnership have at least 50% of its gross income from passive income?",
		values: [{ transferFrom: '', placeholder: 'Transferred from', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferTo: '', placeholder: 'Transferred to', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferDate: '', placeholder: 'Date of transfer', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { transferType: '', placeholder: 'Type of transfer', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { fairMarketValue: "", placeholder: "Sale price or fair market value (FMV) of partnership interest transferred" }]

	},
	{
		question: "Were there any payments to partners or members during the year for services or for the use of capital determined without regard to income?",
		values: [{ assetDescription: '', placeholder: 'Description of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identifying number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { dateDisposedYear: '', placeholder: 'Date acquired or disposed of during the year' }, { maxValueDuringYear: "", placeholder: "Maximum value during the year (in the foreign currency)" }, { currencyExchangeRate: '', placeholder: 'Currency and exchange rate used' }, { foreignEntityAsset: "", placeholder: "If asset is a stock of a foreign entity provide name, type, and mailing address" }, { notAForeignEntityAsset: "", placeholder: "If asset is NOT a stock of a foreign entity provide name of issuer, type, and mailing address" }]

	},
	{
		question: "Did any partner or member contribute any assets to the partnership or LLC during the year?",
		values: [{ assetDescription: '', placeholder: 'Description of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identifying number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { dateDisposedYear: '', placeholder: 'Date acquired or disposed of during the year' }, { maxValueDuringYear: "", placeholder: "Maximum value during the year (in the foreign currency)" }, { currencyExchangeRate: '', placeholder: 'Currency and exchange rate used' }, { foreignEntityAsset: "", placeholder: "If asset is a stock of a foreign entity provide name, type, and mailing address" }, { notAForeignEntityAsset: "", placeholder: "If asset is NOT a stock of a foreign entity provide name of issuer, type, and mailing address" }]

	},
	{
		question: "Did the partnership or LLC acquire any “qualified small business stock?” If yes, provide details",
		values: [{ assetDescription: '', placeholder: 'Description of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identifying number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { dateDisposedYear: '', placeholder: 'Date acquired or disposed of during the year' }, { maxValueDuringYear: "", placeholder: "Maximum value during the year (in the foreign currency)" }, { currencyExchangeRate: '', placeholder: 'Currency and exchange rate used' }, { foreignEntityAsset: "", placeholder: "If asset is a stock of a foreign entity provide name, type, and mailing address" }, { notAForeignEntityAsset: "", placeholder: "If asset is NOT a stock of a foreign entity provide name of issuer, type, and mailing address" }]

	},
	{
		question: "Did the partnership or LLC invest any gain proceeds in a qualified opportunity fund? If yes, provide details",
		values: [{ assetDescription: '', placeholder: 'Description of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { identificationNumber: '', placeholder: 'Identifying number', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { dateDisposedYear: '', placeholder: 'Date acquired or disposed of during the year' }, { maxValueDuringYear: "", placeholder: "Maximum value during the year (in the foreign currency)" }, { currencyExchangeRate: '', placeholder: 'Currency and exchange rate used' }, { foreignEntityAsset: "", placeholder: "If asset is a stock of a foreign entity provide name, type, and mailing address" }, { notAForeignEntityAsset: "", placeholder: "If asset is NOT a stock of a foreign entity provide name of issuer, type, and mailing address" }]

	}
]
const SoleProprietorshipBoolAnswers = [
	{
		question: 'Did you materially participate in the operation of the business during the year?',
		bool: null,
	},
	{
		question: 'Was all your investment in this activity at risk?',
		bool: null,
	},
]
const SoleProprietorshipAnswers = [

	{
		question: 'Were any assets sold, retired or converted to personal use during the year?',
		values: [{ descriptionName: '', placeholder: 'Description of asset', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { soldDate: '', placeholder: 'Date sold', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { dateAcquired: '', placeholder: 'Date acquired', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { salePrice: "", placeholder: "Sales price", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { originalCost: "", placeholder: "Original cost.", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: 'Did you conduct business outside of your home state?',
		values: [{ state: '', placeholder: 'State', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { businessIncomeState: '', placeholder: 'Business Income in that state', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { businessExpensesState: '', placeholder: 'Business expenses in that state', styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
const FuturePartnerShareholderAnswers = [

	{
		question: 'If you are, or were to convert to a S Corporation, how many shareholders are in the S Corporation?',
		twentyTwentyNine: null,
		twentyTwenty: null,
		twentyTwentyOne: null,
	},
	{
		question: 'If you are, or were to convert to a Partnership, how many partners are in the Partnership?',
		twentyTwentyNine: null,
		twentyTwenty: null,
		twentyTwentyOne: null,
	},
	{
		question: 'If you are, or were to convert to a Partnership, are you a general or a limited partner? A general partner is assumed.',
		twentyTwentyNine: null,
		twentyTwenty: null,
		twentyTwentyOne: null,
		// values: [{ state: '', placeholder: 'State', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { businessIncomeState	: '', placeholder: 'Business Income in that state', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { businessExpensesState: '', placeholder: 'Business expenses in that state', styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
const RentalEstateRoyaltyIncomeAnswers = [
	{
		question: 'Is this property eligible for the Qualified Business Income Deduction (Section 199A)?',
		values: [{ address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { propertyType: '', placeholder: 'Type of Property', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PurchasePrice: '', placeholder: 'Purchase Price', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { Ownership: '', placeholder: '% Ownership', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { DaysOccupiedProperty: "", placeholder: "Number of days the property was occupied by you, a member of your family or any individual not paying rent at the fair market value." }, { DaysNotOccupiedProperty: "", placeholder: "Number of days the property was not occupied." }, { WasAvailableForRent: "", placeholder: "If not occupied, was it available for rent during this time?" }, { DaysPropertyRented: "", placeholder: "How many days was the property rented during the year?" }]
	},
	{
		question: "Do you have prior suspended losses on your real estate property and if so, how much is the total prior suspended loss amount? Enter as a positive number.",
		values: [{ address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { propertyType: '', placeholder: 'Type of Property', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PurchasePrice: '', placeholder: 'Purchase Price', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { Ownership: '', placeholder: '% Ownership', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { DaysOccupiedProperty: "", placeholder: "Number of days the property was occupied by you, a member of your family or any individual not paying rent at the fair market value." }, { DaysNotOccupiedProperty: "", placeholder: "Number of days the property was not occupied." }, { WasAvailableForRent: "", placeholder: "If not occupied, was it available for rent during this time?" }, { DaysPropertyRented: "", placeholder: "How many days was the property rented during the year?" }]

	},
	{
		question: "Did you, or your spouse, spend more than 50% of your time performing real estate related activities?",
		values: [{ address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { propertyType: '', placeholder: 'Type of Property', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PurchasePrice: '', placeholder: 'Purchase Price', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { Ownership: '', placeholder: '% Ownership', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { DaysOccupiedProperty: "", placeholder: "Number of days the property was occupied by you, a member of your family or any individual not paying rent at the fair market value." }, { DaysNotOccupiedProperty: "", placeholder: "Number of days the property was not occupied." }, { WasAvailableForRent: "", placeholder: "If not occupied, was it available for rent during this time?" }, { DaysPropertyRented: "", placeholder: "How many days was the property rented during the year?" }]

	},
	{
		question: "Did you, or your spouse, spend more than 750 hours performing real estate related activities?",
		values: [{ address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { propertyType: '', placeholder: 'Type of Property', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PurchasePrice: '', placeholder: 'Purchase Price', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { Ownership: '', placeholder: '% Ownership', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { DaysOccupiedProperty: "", placeholder: "Number of days the property was occupied by you, a member of your family or any individual not paying rent at the fair market value." }, { DaysNotOccupiedProperty: "", placeholder: "Number of days the property was not occupied." }, { WasAvailableForRent: "", placeholder: "If not occupied, was it available for rent during this time?" }, { DaysPropertyRented: "", placeholder: "How many days was the property rented during the year?" }]

	},
	{
		question: "Do you intend to sell any rental property in the current year?",
		values: [{ address: '', placeholder: 'Address', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { propertyType: '', placeholder: 'Type of Property', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PurchasePrice: '', placeholder: 'Purchase Price', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { Ownership: '', placeholder: '% Ownership', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { DaysOccupiedProperty: "", placeholder: "Number of days the property was occupied by you, a member of your family or any individual not paying rent at the fair market value." }, { DaysNotOccupiedProperty: "", placeholder: "Number of days the property was not occupied." }, { WasAvailableForRent: "", placeholder: "If not occupied, was it available for rent during this time?" }, { DaysPropertyRented: "", placeholder: "How many days was the property rented during the year?" }]

	},
	{
		question: "Do you intend to purchase or acquire interest in any rental real estate in the next 24 months?",
		values: [{ expectedSellingPrice: '', placeholder: 'Expected selling price', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { CostBasisProperty: '', placeholder: 'Cost basis in the property', styleProp: "col-lg-6 col-md-8 col-sm-12" }, { TotalDepreciation: '', placeholder: 'Total depreciation on the property prior to sale' }, { PropertyType: '', placeholder: 'Type of Property', styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Rents received",
		values: [{ RentalPropertyAddress: "", placeholder: "Address of Rental Property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ExpectedPurchasePrice: "", placeholder: "Expected purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { MortagePaymentsAnnually: "", placeholder: "Mortgage payments annually", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { OwnershipProperty: "", placeholder: "% ownership of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PropertyType: "", placeholder: "Type of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Royalties received",
		values: [{ RentalPropertyAddress: "", placeholder: "Address of Rental Property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ExpectedPurchasePrice: "", placeholder: "Expected purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { MortagePaymentsAnnually: "", placeholder: "Mortgage payments annually", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { OwnershipProperty: "", placeholder: "% ownership of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PropertyType: "", placeholder: "Type of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "Mortgage interest",
		values: [{ RentalPropertyAddress: "", placeholder: "Address of Rental Property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ExpectedPurchasePrice: "", placeholder: "Expected purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { MortagePaymentsAnnually: "", placeholder: "Mortgage payments annually", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { OwnershipProperty: "", placeholder: "% ownership of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PropertyType: "", placeholder: "Type of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "Cleaning and maintenance of property",
		values: [{ RentalPropertyAddress: "", placeholder: "Address of Rental Property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ExpectedPurchasePrice: "", placeholder: "Expected purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { MortagePaymentsAnnually: "", placeholder: "Mortgage payments annually", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { OwnershipProperty: "", placeholder: "% ownership of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PropertyType: "", placeholder: "Type of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "Real estate commissions",
		values: [{ RentalPropertyAddress: "", placeholder: "Address of Rental Property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ExpectedPurchasePrice: "", placeholder: "Expected purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { MortagePaymentsAnnually: "", placeholder: "Mortgage payments annually", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { OwnershipProperty: "", placeholder: "% ownership of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PropertyType: "", placeholder: "Type of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	},
	{
		question: "Real estate management fees",
		values: [{ RentalPropertyAddress: "", placeholder: "Address of Rental Property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { ExpectedPurchasePrice: "", placeholder: "Expected purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { MortagePaymentsAnnually: "", placeholder: "Mortgage payments annually", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { OwnershipProperty: "", placeholder: "% ownership of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { PropertyType: "", placeholder: "Type of property", styleProp: "col-lg-6 col-md-8 col-sm-12" }]

	}
]

const covid19Options = [
	{
		question:
			'Do you have any employees located in a disaster zone in 2021?',
		bool: null,
	},
	{
		question:
			'Were there any employees that were on family and/or medical leave due to COVID-19?',
		bool: null,
	},
	{
		question:
			'Did you receive EIDL funding?',
		bool: null,
	},
	{
		question:
			'Did you receive PPP forgiveness?',
		bool: null,
	},
	{
		question:
			'Did the business receive any other funds/loans/grants (local, state, federal or other) related to the COVID-19 pandemic (besides PPP or EIDL)?',
		bool: null,
	},
	{
		question:
			'Did the business claim the employee retention credit and/or credits for qualified leave wages paid to employees due to paid sick leave or expanded family and medical leave for reasons related to COVID-19?',
		bool: null,
	},
	{
		question:
			'Did you receive PPP funding?',
		bool: null,
	},
];
const fringeOptions = [
	{
		question:
			'Qualified Retirement Plan',
		bool: null,
	},
	{
		question:
			'Simplified Employee Pension (SEP)',
		bool: null,
	},
	{
		question:
			'Savings Incentive Match Plan for Employees (SIMPLE)',
		bool: null,
	},
	{
		question:
			'Cafeteria plan',
		bool: null,
	},
	{
		question:
			'Non-qualified deferred compensation plan(s) or agreement(s)',
		bool: null,
	},
];
const insuranceRadioOptions = [
	{
		question:
			'Does the business pay a portion of the health insurance premium for your employees?',
		bool: null,
	},
	{
		question:
			'Do you have a health reimbursement arrangement or otherwise reimburse your employees for medical expenses or health insurance premiums?',
		bool: null,
	},
	{
		question:
			'Do you pay an average wage of less than $50,000?',
		bool: null,
	},
	{
		question:
			'Do you pay at least half of the employees’ health insurance premiums?',
		bool: null,
	},
];
const depreciationRadioOptions = [
	{
		question:
			'Did the business participate in a cost segregation study this year?',
		bool: null,
	},
	{
		question:
			'Do you have any qualified improvement property?',
		bool: null,
	},
	{
		question:
			'Has the taxpayer purchased or is planning to purchase tangible, non-real estate assets?',
		bool: null,
	},
];
const retirementOptions = [
	{
		question:
			'Do the business currently have a retirement plan in place?',
		bool: null,
	},
	{
		question:
			'Do you wish to maximize your retirement plan contributions?',
		bool: null,
	},
	{
		question:
			'Do you wish to contribute 3% of each employee\'s salary to an employee retirement plan?',
		bool: null,
	},
];
const TaxPaymentRefundData = [
	{
		question:
			'Do you want any overpayment of taxes applied to next year’s estimated taxes?',
		bool: null,
	},
	{
		question:
			'Do you want any federal or state refund deposited directly into your bank account?',
		bool: null,
	},
	{
		question:
			'Do you want any balance due directly withdrawn from this same bank account on the due date?',
		bool: null,
	},
	{
		question:
			'Do you want next year’s estimated taxes withdrawn from this same bank account on the due dates?',
		bool: null,
	},
	{
		question:
			'If you owe federal or state tax upon completion of your return, are you able to pay the balance due?',
		bool: null,
	},
	{
		question:
			'If you owe federal or state tax upon completion of your return, are you able to pay the balance due?',
		bool: null,
	},
];
const BusinessVehiclesData = [
	{
		question:
			'Do you want any overpayment of taxes applied to next year’s estimated taxes?',
		value: '',
	},
	{
		question:
			'Do you want any federal or state refund deposited directly into your bank account?',
		value: '',
	},
	{
		question:
			'Do you want any balance due directly withdrawn from this same bank account on the due date?',
		value: '',
	},
	{
		question:
			'Do you want next year’s estimated taxes withdrawn from this same bank account on the due dates?',
		value: '',
	},
	{
		question:
			'If you owe federal or state tax upon completion of your return, are you able to pay the balance due?',
		value: '',
	},
	{
		question:
			'If you owe federal or state tax upon completion of your return, are you able to pay the balance due?',
		value: '',
	},
];
const employeesOptions = [
	{
		question:
			'Did the business have any employees?',
		bool: null,
	},
	{
		question:
			'Do you want to provide employee achievement awards for your staff if there are tax benefits?',
		bool: null,
	},
];
// Business Information Form
const entityType = [
	{
		label: 'Single',
		value: 'Single',
	},
	{ label: 'Group', value: 'Group' },
];
const DDEntityType = [
	{
		label: 'Half',
		value: 'Half',
	},
	{ label: 'Full', value: 'Full' },
];

// Business Details Form

const accountingMethods = [
	{
		question: 'Accounting method',
		options: ['Cash', 'Accrual', 'Other'],
	},
];

const accountingPeriods = [
	{
		question: 'Accounting period',
		options: ['Calendar year', 'Fiscal year', 'Short tax year'],
	},
];

// Partner Information
const PartnerInformationOption = [
	{
		question: 'Select one of following',
		options: ['General partner or LLC member-manager', 'Limited partner or other LLC member'],
	},
];

const PartnerType = [
	{
		question: 'Select one of following',
		options: ['Domestic partner', 'Foreign partner'],
	},
];

// INCOME FORM
const incomeInformation = [
	{
		question: 'Gross receipts or sales',
		amount: null,
	},
	{
		question: 'Returns and allowances',
		amount: null,
	},
	{
		question: 'Dividends',
		amount: null,
	},
	{
		question: 'Interest',
		amount: null,
	},
	{
		question: 'Gross rents',
		amount: null,
	},
	{
		question: 'Gross royalties',
		amount: null,
	},
	{
		question: 'Net gain (loss)',
		amount: null,
	},
];

const incomeInformation1120 = [
	...incomeInformation,
	{
		question: 'Capital Gain net Income',
		amount: null,
	},
];

const costOfGoodSaleOptions = [
	{
		question: 'Inventory at beginning of year',
		amount: null,
	},
	{
		question: 'Purchases',
		amount: null,
	},
	{
		question: 'Cost of labor',
		amount: null,
	},
	{
		question: 'Other costs',
		amount: null,
	},
	{
		question: 'Inventory at end of year',
		amount: null,
	},
];

const SimpleChoiceOptions = [{ label: 'yes' }, { label: 'no' }];

const goodsSalesMethodsOptions = {
	question: 'Methods used to value inventory',
	Options: [{ label: 'cost' }, { label: 'lower of cost' }, { label: 'other' }],
};

const expensesOptions = [
	{
		question: 'Guaranteed payments to partners',
		amount: null,
	},
	{
		question: 'Salaries and wages (other than to partners)',
		amount: null,
	},
	{
		question: 'Advertizing',
		amount: null,
	},
	{
		question: 'Automobile expenses',
		amount: null,
	},
	{
		question: 'Bad debts',
		amount: null,
	},
	{
		question: 'Bank Charges',
		amount: null,
	},
	{
		question: 'Cleaning and janitorial',
		amount: null,
	},

	{
		question: 'Contract labor',
		amount: null,
	},
	{
		question: 'Dues and subscriptions',
		amount: null,
	},
	{
		question: 'Employee benefit programs',
		amount: null,
	},
	{
		question: 'Entertainment',
		amount: null,
	},
	{
		question: 'Healthcareplans - employees',
		amount: null,
	},

	{
		question: 'Insurance - other than health',
		amount: null,
	},
	{
		question: 'Interest',
		amount: null,
	},
	{
		question: 'Internet',
		amount: null,
	},
	{
		question: 'Legal and professional services',
		amount: null,
	},
	{
		question: 'Licenses and permits',
		amount: null,
	},

	{
		question: 'Meals',
		amount: null,
	},
	{
		question: 'Office expenses',
		amount: null,
	},
	{
		question: 'Postage and shipping',
		amount: null,
	},
	{
		question: 'Professional education and training',
		amount: null,
	},
	{
		question: 'Rent or lease - car, machinery equipment',
		amount: null,
	},
	{
		question: 'Rent or lease - other business property',
		amount: null,
	},

	{
		question: 'Repairs and maintenance',
		amount: null,
	},
	{
		question: 'Retirement plans',
		amount: null,
	},
	{
		question: 'Software',
		amount: null,
	},
	{
		question: 'Supplies',
		amount: null,
	},
	{
		question: 'Taxes - payroll',
		amount: null,
	},
	{
		question: 'Taxes - local and property',
		amount: null,
	},

	{
		question: 'Taxes - other',
		amount: null,
	},
	{
		question: 'Telephone',
		amount: null,
	},
	{
		question: 'Tools',
		amount: null,
	},
	{
		question: 'Travel',
		amount: null,
	},
	{
		question: 'Utilities',
		amount: null,
	},
];

const assetsOptions = [
	{
		question: 'Cash and bank account',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Trade notes and accounts receiable',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Inventories',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Loans to partners',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Mortgages and loans held by partnership',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Stock , bonds and securities',
		BeginningOfYear: null,
		EndOfYear: null,
	},
];

const LiabilitiesOptions = [
	{
		question: 'Account payable',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Payables less than 1 year',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'All nonrecourse loans',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Loans from partners',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Payables more than 1 year',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Partner capital account',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Retained earnings',
		BeginningOfYear: null,
		EndOfYear: null,
	},
];

const LiabilitiesOptions1120 = [
	{
		question: 'Account payable',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Payables less than 1 year',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Loans from shareholder',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Payables more than 1 year',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Capital stock - preferred',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Capital stock - common',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'Additional paid in capital',
		BeginningOfYear: null,
		EndOfYear: null,
	},
	{
		question: 'RetainedEarning',
		BeginningOfYear: null,
		EndOfYear: null,
	},
];
const Options1120QuestionsPart1 = [
	{
		question: 'Did our firm prepare the 2021 tax returns for this business? ',
		bool: null,
	},
	{
		question: 'Did the business change its legal name?',
		bool: null,
	},
	{
		question:
			'During the 2023 calendar year, did the corporation have an Interest In or a signature or other authority over a financial account in a foreign country? ',
		bool: null,
	},
	{
		question:
			'Did the corporation pay $600 or more of non-employee compensation to any individual during the year?',
		bool: null,
	},

	{
		question:
			'At any time during the tax year, was any shareholder of the corporation a disregarded entity, a trust, an estate, or a nominee or similar person? ',
		bool: null,
	},
	{
		question:
			'Is the corporation a subsidiary in an affiliated group or a parent-subsidiary controlled group? ',
		bool: null,
	},
	{
		question:
			'Does the corporation have an available net operating loss (NOL) from a prior tax year? ',
		bool: null,
	},
];

const Options1120QuestionsPart2 = [
	{
		question:
			'At the end of the tax year, did the corporation directly own 20% or more, or directly or indirectly own, 50% or more of the total voting power of all classes of stock entitled to vote of any foreign or domestic corporation not included in an affiliated group? ',
		bool: null,
	},
	{
		question:
			'At the end of the tax year, did the corporation directly own an interest of 20% or more, or directly or indirectly own, an Interest of 50% or more in any foreign or domestic partnership or in the beneficial interest of a trust?',
		bool: null,
	},
	{
		question:
			"At any time during the tax year, did one foreign person directly or indirectly own, at least 25% of the total voting power of all classes of the corporation's stock entitled to vote or at least 25% of the total value of all classes of the corporation's stock?",
		bool: null,
	},
	{
		question:
			'During this tax year, did the corporation have an 80%-or-more change in ownership, Including a change due to redemption of its own stock?',
		bool: null,
	},
	{
		question:
			'During or subsequent to this tax year, but before the filing of this return, did the corporation dispose of more than 65% (by value) of its assets in a taxable, non-taxable, or tax deferred transaction?',
		bool: null,
	},
	{
		question:
			'Did the corporation receive assets in a property-for-stock nontaxable exchange in which any of the transferred assets had a fair market basis or fair market value of more than $1 million?',
		bool: null,
	},
	{
		question: 'Is the corporation operating on a cooperative basis?',
		bool: null,
	},
];

const OptionsShareHolders = [
	{
		question:
			"At the end of the tax year did any foreign or domestic corporation, partnership, trust, or tax-exempt organization directly own 20% or more, or directly or indirectly own, 50'.% or more of the total voting power of all classes of the corporation's stock entitled to vote?",
		bool: null,
	},
	{
		question:
			"DAt the end of the tax year did any individual or estate directly own 20% or more, or directly or indirectly own, 50% or more of the total voting power of all classes of the corporation's stock entitled to vote?",
		bool: null,
	},
];

const yearEndReport = [
	{
		question: "Select how you will provide the company's 2023 year-end reports ",
		options: [
			'Enter the information in the following sections',
			'Upload a profit and loss statement and balance sheet',
			'Our firm has Of will prepare these reports ',
		],
	},
];

const OfficerApplicableOptions = [
	{ question: 'Officer is also a shareholder' },
	{ question: 'Officer will sign the tax return' },
];

const Options1120SQuestionsPart1 = [];
const Options1120SQuestionsPart2 = [
	{
		question:
			'At any time during the tax year, was any shareholder of the corporation a disregarded entity, a trust, an estate, e a nominee or similar parson?',
		bool: null,
	},
	{
		question:
			'At the and of the tax year, did the corporation directly own 20% ee arena, or dfredily or indirectly own, 50% or more of the total stock issued and outstanding of any lce titian or domestic corporation?',
		bool: null,
	},
	{
		question:
			'At the and of the tax year, did the corporation directly own an interest of 20% or more, or directly or indirectly own, an interest of 50% or more in the profit, loss, or capital in any foreign or domestic partnership or in the beneficial interest of a trust? ',
		bool: null,
	},
	{
		question:
			'At the and of the tar year, did the corporation have any outstanding shares of restricted stock?',
		bool: null,
	},
	{
		question:
			"At the and of the tar 'scat, did the corporation have an outstanding stock options, warrants, or similar instruments?",
		bool: null,
	},
	{
		question: 'Was the corporation a C corporation before h sleeted to be an S corporation?',
		bool: null,
	},
	{
		question:
			'Did the corporation have any non-shareholder debt that was canceled, was forgiven, or had the terms modified so as to reduce the principal anount of the debt?',
		bool: null,
	},
];

const Options1120SQuestionsPart2ThreeOptions = [
	{
		question: "Select how you will provide the company's 2023 year-end reports",
		options: [
			'Enter the information in the following sections',
			'Upload a profit and loss statement and balance sheet',
			'Our firm has Of will prepare these reports ',
		],
	},
];

// Long
const PersonalInformationAnswers_Long = [
	{
		question: "Were you married on the last day of the tax year?",
		bool: null
	},
	{
		question: "Are you blind?",
		bool: null
	},
	{
		question: "Is spouse blind?",
		bool: null
	},
	{
		question: "Are you entitled to a dependency exemption due to a divorce decree?",
		bool: null
	},
	{
		question: "Was there a change in address?",
		bool: null
	},
	{
		question: "Did any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return?",
		bool: null
	},
	{
		question: "Your first name",
		values: [{ firstName: "" }]
	},
	{
		question: "Your last name",
		values: [{ lastName: "" }]
	},
	{
		question: "What is your current filing status?",
		values: [{ currentFiliingStatus: "" }]
	},
	// 9
	{
		question: "Your date of birth",
		values: [{ dob: new Date() }]
	},
	{
		question: "Your Social Security number",
		values: [{ socialSecurityNumber: "" }]
	},
	{
		question: "Your occupation",
		values: [{ occupation: "" }]
	},
	{
		question: "Preferred phone number",
		values: [{ phneNumber: "" }]
	},
	{
		question: "Preferred email address",
		values: [{ email: "" }]
	},
	{
		question: "Your citizenship or visa status",
		values: [{ citizenshipStatus: "" }]
	},
	{
		question: "Spouse's first name",
		values: [{ spouseFirstName: "" }]
	},
	{
		question: "Spouse's last name",
		values: [{ spouseLastName: "" }]
	},
	{
		question: "Spouse's Social Security number",
		values: [{ spouseSocialSecurityNumber: "" }]
	},
	// 18
	{
		question: "Spouse's date of birth",
		values: [{ spouseDOB: new Date() }]
	},
	{
		question: "Spouse's occupation",
		values: [{ spouseOccupation: "" }]
	},
	{
		question: "Spouse's mobile phone number",
		values: [{ spouseMobileNumber: "" }]
	},
	{
		question: "Spouse's email address",
		values: [{ spouseEmailAddress: "" }]
	},
	{
		question: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.",
		values: [{ detailsAboutBithAdoptions: "" }]
	},
	{
		question: "Spouse's citizenship or visa status",
		values: [{ spouseCitizenship: "" }]
	},

]
const PersonalInformationAnswersStyles_Long = [
	{},
	{},
	{},
	{},
	{},
	{},
	{
		question: "Your first name",
		valData: [{ placeholder: "Your first name", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Your last name",
		valData: [{ placeholder: "Your last name", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "What is your current filing status?",
		valData: [{ placeholder: "What is your current filing status?", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Your date of birth",
		valData: [{ placeholder: "Your date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Your Social Security number",
		valData: [{ placeholder: "Your Social Security number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Your occupation",
		valData: [{ placeholder: "Your occupation", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Preferred phone number",
		valData: [{ placeholder: "Preferred phone number", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Preferred email address",
		valData: [{ placeholder: "Preferred email address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" }]
	},
	{
		question: "Your citizenship or visa status",
		valData: [{ placeholder: "Your citizenship or visa status", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's first name",
		valData: [{ placeholder: "Spouse's first name", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's last name",
		valData: [{ placeholder: "Spouse's last name", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's Social Security number",
		valData: [{ placeholder: "Spouse's Social Security number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Spouse's date of birth",
		valData: [{ placeholder: "Spouse's date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's occupation",
		valData: [{ placeholder: "Spouse's occupation", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's mobile phone number",
		valData: [{ placeholder: "Spouse's mobile phone number", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's email address",
		valData: [{ placeholder: "Spouse's email address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" }]
	},
	{
		question: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.",
		valData: [{ placeholder: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's citizenship or visa status",
		valData: [{ placeholder: "Spouse's citizenship or visa status", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
// dependents
const Dependents_Long = [
	{
		question: "Do you have any dependents?",
		bool: null,
		values: [
			{ name: "" },
			{ dateOfBirth: new Date() },
			{ socialSecurityNumber: "" },
			{ Relationship: "" },
			{ dependentEarnLastYear: "" },
			{ dependentProjectingToEarn: "" },
			{ unearnedIncomeWasAllocated: "" },
			{ dependentStudentInCollege: "" },
			{ dependentLiveInYourHome: "" },
			{ totallyAndPermanentlyDisabled: "" },
			{ marriedAndFillingAJoint: "" },
			{ relevantInformationAboutDependent: "" },
			{ dependentTaxReturn: "" },
			{ priorYearTaxReturn: "" },
		]
	},
	{
		question: "Did any births or adoptions happen in the past year?",
		bool: null
	},
]
const DependentsStyles_Long = [
	{
		valData: [
			{ placeholder: "Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date of Birth", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Social Security Number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Relationship", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "How much did this dependent earn last year?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: `How much is this dependent projecting to earn as income in ${new Date().getFullYear()} (not from businesses you directly own)?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much unearned income was allocated to this dependent?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Is this dependent a student in college full-time?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How many months did this dependent live in your home?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Is this dependent totally and permanently disabled?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Is this dependent married and filing a joint return with their spouse?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Provide any other relevant information about the dependent", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Do you want us to prepare your dependent’s tax return?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Was this dependent on the prior year's tax return?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{},
]
// Primary residence
const PrimaryResidence_Long = [
	{
		question: "Did you change your address?",
		bool: null,
		values: [
			{ address: "" },
			{ dateFrom: new Date() },
			{ dateTo: new Date() },
		]
	},
	{
		question: "Primary residence land purchase price",
		bool: null,
		values: [
			{ description: "" },
			{ datePlacedInService: new Date() },
			{ costOrBasis: "" },
		]
	},
	{
		question: "Do you plan to move next year?",
		bool: null,
		values: [{ stateToMove: {}, placeholder: "What state do you plan to move to?" }]
	},
	{
		question: "Did you sell or purchase a personal residence?",
		bool: null,
		values: [
			{ dateOfPurchase: new Date(), placeholder: "What was the date of purchase?" },
			{ purchasePrice: "", placeholder: "What was the purchase price?" },
		],
	},
	{
		question: "Do you have an office outside of your home?",
		bool: null,
		values: [{ roundTripMileage: "", placeholder: "Total ANNUAL roundtrip mileage from your home to your office location" }]
	},
	// 5
	{
		question: "For sale of personal residence, did you own and live in it for two of the five years prior to the sale?",
		bool: null
	},
	{
		question: "Was there any rental or business use during the period of ownership?",
		bool: null
	},
	{
		question: "Do you plan to perform work-related tasks at home?",
		bool: null
	},
	// 8
	// inputs
	{
		question: "Please describe the business or activity for which you have an office",
		values: [{ businessOrActivity: "" }]
	},
	{
		question: "Home office square footage",
		values: [{ officeSquareFootage: "" }]
	},
	{
		question: "Home square footage",
		values: [{ homeSquareFootage: "" }]
	},
	{
		question: "Do you rent or own your home?",
		values: [{ rentOrOwnHome: "" }]
	},
	{
		question: "Annual rent cost",
		values: [{ annualrentCost: "" }]
	},
	{
		question: "Annual rental insurance",
		values: [{ annualRentalInsurance: "" }]
	},
	{
		question: "Annual mortgage interest cost",
		values: [{ annualMortageInterestCost: "" }]
	},
	{
		question: "Annual property taxes",
		values: [{ annualPropertyTaxes: "" }]
	},
	// 16
	{
		question: "Annual home insurance",
		values: [{ annualHomeInsurance: "" }]
	},
	{
		question: "Annual HOA fees",
		values: [{ annualHOAFees: "" }]
	},
	{
		question: "Annual cleaning (DIY & service) fees",
		values: [{ annualCleaning: "" }]
	},
	{
		question: "Annual lawn & landscaping (DIY or Service) fees",
		values: [{ annualLawn: "" }]
	},
	{
		question: "Annual pest control fees",
		values: [{ annualPestControl: "" }]
	},
	{
		question: "Annual security fees",
		values: [{ annualSecurityFees: "" }]
	},
	{
		question: "Annual repairs & maintenance fees",
		values: [{ annualRepairsFees: "" }]
	},
	{
		question: "Annual renovations fees",
		values: [{ annualRenovations: "" }]
	},
	{
		question: "Annual snow removal fees",
		values: [{ showRemovalFees: "" }]
	},
	{
		question: "Annual supplies fees",
		values: [{ annualSuppliesFees: "" }]
	},
	// 26
	{
		question: "Annual utilities: internet",
		values: [{ annualUtilitiesInternet: "" }]
	},
	{
		question: "Annual utilities: telephone",
		values: [{ annualUtilitiesTelephone: "" }]
	},
	{
		question: "Annual utilities: water & sewer",
		values: [{ annualUtilitiesWaterSewer: "" }]
	},
	{
		question: "Annual utilities: gas & oil",
		values: [{ annualUtilitiesGasOil: "" }]
	},
	{
		question: "Annual utilities: electric",
		values: [{ annualUtilitiesElectric: "" }]
	},
	{
		question: "Annual utilities: other expenses",
		values: [{ annualUtilitiesOther: "" }]
	},
	{
		question: "Allowable annual home office depreciation",
		values: [{ annualHomeOfficeDepriciation: "" }]
	},
	{
		question: "Expenses that are used 100% in the office itself (telephone, maintenance)",
		values: [{ officeHundredPercentExpenses: "" }]
	},
	{
		question: "Annual other home costs",
		values: [{ annualOtherHomeCosts: "" }]
	},
	// 35
	{
		question: "Primary residence date placed in service",
		values: [{ primaryResidenceDatePlaced: new Date() }]
	},
	{
		question: "Primary residence cost/basis",
		values: [{ primaryResidenceCost: "" }]
	},
	{
		question: "Primary residence method",
		values: [{ primaryResidenceMethod: "" }]
	},
	{
		question: "Primary residence life",
		values: [{ primaryResidenceLife: "" }]
	},
	{
		question: "Primary residence value prior depreciation",
		values: [{ primaryResidenceValuePrior: "" }]
	},
	// 40
	{
		question: "Primary residence purchase price",
		values: [{ primaryResidencePurchasePrice: "" }]
	},
]
const PrimaryResidenceStyles_Long = [
	{
		question: "Did you change your address?",
		bool: null,
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date From", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date To", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Primary residence land purchase price",
		bool: null,
		valData: [
			{ placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date placed in service", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Cost or basis", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Do you plan to move next year?",
		bool: null,
		valData: [{ placeholder: "What state do you plan to move to?", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Did you sell or purchase a personal residence?",
		bool: null,
		valData: [
			{ placeholder: "What was the date of purchase?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "What was the purchase price?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		],
	},
	{
		question: "Do you have an office outside of your home?",
		bool: null,
		valData: [{ roundTripMileage: "", placeholder: "Total ANNUAL roundtrip mileage from your home to your office location", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{},
	{},
	{},
	// 8
	// inputs
	{
		question: "Please describe the business or activity for which you have an office",
		valData: [{ placeholder: "Please describe the business or activity for which you have an office", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "Home office square footage",
		valData: [{ placeholder: "Home office square footage", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Home square footage",
		valData: [{ placeholder: "Home square footage", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Do you rent or own your home?",
		valData: [{ placeholder: "Do you rent or own your home?", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Annual rent cost",
		valData: [{ placeholder: "Annual rent cost", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual rental insurance",
		valData: [{ placeholder: "Annual rental insurance", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual mortgage interest cost",
		valData: [{ placeholder: "Annual mortgage interest cost", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual property taxes",
		valData: [{ placeholder: "Annual property taxes", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual home insurance",
		valData: [{ placeholder: "Annual home insurance", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual HOA fees",
		valData: [{ placeholder: "Annual HOA fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual cleaning (DIY & service) fees",
		valData: [{ placeholder: "Annual cleaning (DIY & service) fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual lawn & landscaping (DIY or Service) fees",
		valData: [{ placeholder: "Annual lawn & landscaping (DIY or Service) fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual pest control fees",
		valData: [{ placeholder: "Annual pest control fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	// 21
	{
		question: "Annual security fees",
		valData: [{ placeholder: "Annual security fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual repairs & maintenance fees",
		valData: [{ placeholder: "Annual repairs & maintenance fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual renovations fees",
		valData: [{ placeholder: "Annual renovations fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual snow removal fees",
		valData: [{ placeholder: "Annual snow removal fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual supplies fees",
		valData: [{ placeholder: "Annual supplies fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual utilities: internet",
		valData: [{ placeholder: "Annual utilities: internet", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual utilities: telephone",
		valData: [{ placeholder: "Annual utilities: telephone", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual utilities: water & sewer",
		valData: [{ placeholder: "Annual utilities: water & sewer", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual utilities: gas & oil",
		valData: [{ placeholder: "Annual utilities: gas & oil", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual utilities: electric",
		valData: [{ placeholder: "Annual utilities: electric", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	// 31
	{
		question: "Annual utilities: other expenses",
		valData: [{ placeholder: "Annual utilities: other expenses", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Allowable annual home office depreciation",
		valData: [{ placeholder: "Allowable annual home office depreciation", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Expenses that are used 100% in the office itself (telephone, maintenance)",
		valData: [{ placeholder: "Expenses that are used 100% in the office itself (telephone, maintenance)", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Annual other home costs",
		valData: [{ placeholder: "Annual other home costs", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Primary residence date placed in service",
		valData: [{ placeholder: "Primary residence date placed in service", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Primary residence cost/basis",
		valData: [{ placeholder: "Primary residence cost/basis", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Primary residence method",
		valData: [{ placeholder: "Primary residence method", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Primary residence life",
		valData: [{ placeholder: "Primary residence life", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Primary residence value prior depreciation",
		valData: [{ placeholder: "Primary residence value prior depreciation", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Primary residence purchase price",
		valData: [{ placeholder: "Primary residence purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
]
// secondary
const SecondaryResidence_Long = [
	{
		question: "Do you own a vacation property or second home for personal use?",
		bool: null,
		values: [
			{ address: "" },
			{ typesOfProperty: "" },
			{ mortgage: "" },
			{ totalAnnualMortgageAmount: "" },
		]
	},
	{
		question: "Have you purchased or acquired an interest in any rental real estate since your last tax return?",
		bool: null,
		values: [
			{ address: "" },
			{ typesOfProperty: "" },
			{ purchasePrice: "" },
			{ ownershipPercentage: "" },
		]
	},
	{
		question: "Do you intend to purchase or acquire interest in any rental real estate in the next 24 months?",
		bool: null,
		values: [
			{ address: "" },
			{ typesOfProperty: "" },
			{ purchasePrice: "" },
			{ ownershipPercentage: "" },
		]
	},
]
// 
const SecondaryResidenceStyles_Long = [
	{
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Mortgage?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total annual mortgage amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "% Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "% Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// 
const WagesSummary_Long = [
	{
		question: "What are your expected total annual wages from businesses you do NOT directly own?",
		// bool:null,
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What were your spouse's total annual wages from businesses you do NOT directly own?",
		// bool:null,
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
]
const WagesSummaryStyles_Long = [
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// incomeDetails
const IncomeDetails_Long = [
	{
		question: "Did you receive any wages, salaries and other employee compensation?",
		bool: null
	},
	{
		question: "Did you receive any pension, IRA and annuity income?",
		bool: null
	},
	{
		question: "Did you receive a lump sum distribution from your employer?",
		bool: null
	},
	{
		question: "Did you convert a lump sum distribution into another plan or IRA account?",
		bool: null
	},
	{
		question: "If over age 70½, did you or your spouse make a contribution from your IRA directly to a charitable organization?",
		bool: null
	},
	{
		question: "Have you elected a lump sum treatment for any retirement distributions after 1986?",
		bool: null,
		values: [
			{ detailsRegardingLumpSum: "" },
		]
	},
	{
		question: "What was the total social security benefits you may have received in the past year?",
		values: [
			{ socialSecurityBenefits: "" },
		]
	},
]
const IncomeDetailsStyles_Long = [
	{},
	{},
	{},
	{},
	{},
	{
		valData: [
			{ placeholder: "Provide details regarding this lump sum.", styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		valData: [
			{ placeholder: "What was the total social security benefits you may have received in the past year?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// 
const OtherIncomeSummary_Long = [
	{
		question: "What is your total taxable INTEREST income?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are your total ordinary dividends from businesses you do NOT directly own?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What portion of dividends are qualified dividends from businesses you do NOT directly own?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are your total taxable IRA distributions?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is your total taxable pension?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are your total taxable Social Security benefits?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are your total state and local taxable refunds?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is your total alimony received?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are your total other gains and losses from businesses you do NOT directly own?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is your total unemployment income?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is your total estates and trusts income?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is your total taxable other income from businesses you do NOT directly own?",
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
]
const OtherIncomeSummaryStyles_Long = [
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// incomeDetails
const InterestIncomeDetails_Long = [
	{
		question: "Did you have any interest income in the past year?",
		bool: null,
		values: [
			{ interestIncomeOwnership: "" },
			{ interestIncomePayerName: "" },
			{ banksSavingsAndLoan: "" },
			{ USbondsTbills: "" },
			{ taxExemptInterestIncome: "" },
			{ inStateInterestIncome: "" },
			{ outOfStateInterestIncome: "" },
			{ earlyWithDrawlPenalties: "" },
		]
	},
	{
		question: "Did you have any interest income from seller financed mortgages?",
		bool: null,
		values: [
			{ nameOfPlayer: "" },
			{ socialSecurityNumber: "" },
			{ address: "" },
			{ interestReceived: "" },
		]
	},
	{
		question: "Did you surrender any U.S. savings bonds, or did they mature?",
		bool: null,
		values: [
			{ detailsRegardingLumpSum: "" },
		]
	},

]
const IntersetIncomeDetailsStyles_Long = [
	{
		valData: [
			{ placeholder: "Interest income Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Name of payer for Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Banks, savings and loan (S&L), etc.", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "U.S. bonds, T-bills", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Tax-exempt Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "In-state Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Out-of-state Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Early-withdrawal penalties for Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "Name of payer", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Social Security number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Interest received", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "Amount of proceeds from Series EE U.S. savings bonds purchased after 1989 to pay for higher education expenses?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
const DividendIncomeDetails_Long = [
	{
		question: "Did you have dividend income in the past year?",
		bool: null,
		values: [
			{ dividendIncomeOwnership: "" },
			{ dividendIncomePayer: "" },
			{ ordinaryDividends: "" },
			{ qualifiedDividends: "" },
			{ capitalGainDistributions: "" },
			{ nonTaxableDividendIncome: "" },
			{ federalTaxWithheld: "" },
			{ foreignTaxWithheld: "" },
		]
	},
]
const DividendIncomeDetailsStyles_Long = [
	{
		valData: [
			{ placeholder: "Dividend income ownership", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Name of payer for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Ordinary dividends", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Qualified dividends", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Capital gain distributions", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Non-taxable dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Federal tax withheld for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Foreign tax withheld for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
const ForeignAccountsDetails_Long = [
	{
		question: "Did you have any interest in, or signature or other authority over, a bank, securities or other financial account in a foreign country?",
		bool: null,
		values: [
			{ nameOfFinancialInstitution: "" },
			{ addressOfFinancialInstitution: "" },
			{ accountType: "" },
			{ accountNumber: "" },
			{ maximumValueDuringTheYear: "" },
			{ assetsHeld: "" },
			{ jointOwnerName: "" },
			{ jointOwnerAddress: "" },
			{ jointOwnersUSTaxPayerIDNumber: "" },
		]
	},
	{
		question: "Did you have an interest in specified foreign financial assets valued at more than $50,000 on the last day of the tax year or more than $75,000 at any time during the tax year?",
		bool: null,
		values: [
			{ descriptionOfAsset: "" },
			{ identifyingNumber: "" },
			{ dateAssetAcquired: "" },
			{ dateAssetDisposed: "" },
			{ maximumValueOfAsset: "" },
			{ currencyExchangeRate: "" },
			{ nameOfEntity: "" },
			{ foreignEntityStock: "" },
			{ entityType: "" },
			{ entityMailingAddress: "" },
		]
	},
	{
		question: "Did you have foreign income, pay any foreign taxes that are not reflected on an enclosed Form 1099, or file any foreign information reporting or tax forms?",
		bool: null,
		values: [
			{ dividendIncomeOwnership: "" },
		]
	},
	{
		question: "Were you the grantor, transferor or beneficiary of a foreign trust?",
		bool: null,
	},
]
const ForeignAccountsDetailsStyles_Long = [
	{
		valData: [
			{ placeholder: "Name of financial institution", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Address of financial institution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Account type (bank securities/ other)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Account number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Maximum value during the year (in the foreign currency)", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How were these assets held?", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If Jointly, Joint owner’s name", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If Jointly, Joint owner’s address", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If Jointly, Joint owner’s US taxpayer ID number", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "Description of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Identifying number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date asset acquired during the year", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Date asset disposed of during the year", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Maximum value of asset during the tax year", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Currency/exchange rate", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Name of Entity", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Is the asset a stock of a foreign entity?", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Type of Entity", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Entity Mailing Address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" },
		]
	},
	{
		valData: [
			{ placeholder: "Provide details regarding foreign income", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{}
]
// __________________________________________________
const OtherIncomeDetails_Long = [
	{
		question: "Did you receive tip income not reported to your employer?",
		bool: null,
	},
	{
		question: "Did you acquire or sell any qualified small business stock?",
		bool: null,
	},
	{
		question: "Were you granted or did you exercise any stock options?",
		bool: null,
		values: [
			{ grantedStockOptions: "" },
		]
	},
	{
		question: "Were you granted any restricted stock?",
		bool: null,
		values: [
			{ grantedRestrictedStock: "" },
		]
	},
	{
		question: "Did you receive unemployment compensation?",
		bool: null,
	},
	{
		question: "Did you have any taxable distributions from an ABLE (achieving a better life experience) account?",
		bool: null,
	},
	// inputs
	{
		question: "Date of your divorce or separation agreement",
		type: "Date",
		values: [{ divorceDate: new Date() }]
	},
	{
		question: "Jury fees",
		values: [{ juryFees: "" }]
	},
	{
		question: "Finder’s fees",
		values: [{ findersFees: "" }]
	},
	{
		question: "Director’s fees",
		values: [{ directorsFees: "" }]
	},
	{
		question: "Prizes",
		values: [{ Prizes: "" }]
	},
	{
		question: "Gambling winnings",
		values: [{ gamblingWinnings: "" }]
	},
	{
		question: "Trustee fees",
		values: [{ trustedFees: "" }]
	},
	{
		question: "Executor fees",
		values: [{ executorFees: "" }]
	},
	{
		question: "Other miscellaneous income",
		values: [{ otherMisc: "" }]
	},

]
const OtherIncomeDetailsStyles_Long = [
	{},
	{},
	{
		valData: [
			{ placeholder: "Please provide details.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "Please provide details.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{},
	{},
	// inputs
	{
		question: "Date of your divorce or separation agreement",
		valData: [{ placeholder: "Date of your divorce or separation agreement", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Jury fees",
		valData: [{ placeholder: "Jury fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Finder’s fees",
		valData: [{ placeholder: "Finder’s fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Director’s fees",
		valData: [{ placeholder: "Director’s fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Prizes",
		valData: [{ placeholder: "Prizes", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Gambling winnings",
		valData: [{ placeholder: "Gambling winnings", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Trustee fees",
		valData: [{ placeholder: "Trustee fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Executor fees",
		valData: [{ placeholder: "Executor fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Other miscellaneous income",
		valData: [{ placeholder: "Other miscellaneous income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
]

// capitalGain or losses
const CapitalGainQuestions_Long = [
	{
		question: "Did you sell or purchase a principal residence or other real estate not previously reported?",
		bool: null,
	},
	{
		question: "Did you refinance any existing loans on your home or other real estate you own?",
		bool: null,
	},
	{
		question: "Capital Gains",
		values: [
			{ description: "" },
			{ dateAcquired: new Date() },
			{ dateSold: new Date() },
			{ salesProceeds: "" },
			{ costOrBasis: "" },
			{ washSaleAdjustment: "" },
			{ salesNotReportedOnForms: "" },
		]
	},
	// inputs
	{
		question: "Did you collect on any installment contracts during the year? Provide details.",
		values: [{ installmentContracts: "" }]
	},
	{
		question: "During this year, do you have any securities that became worthless or loans that became uncollectible? Provide details.",
		values: [{ worthlessSecurities: "" }]
	},
	{
		question: "What are your expected gains from the sale of securities in {{CURRENT_YEAR}}?",
		values: [{ expectedGainsFromSale: "" }]
	},
	{
		question: "How much of the gains on the sale would you be willing to contribute to an opportunity zone investment?",
		values: [{ gainsOnTheSale: "" }]
	},
	{
		question: "What are your expected gains from the sale of securities in {{FUTURE_YEAR1}}?",
		values: [{ expectedGainsFromTheSaleOfSecurities: "" }]
	},
	{
		question: "What were your gains from the sale of securities in {{PRIOR_YEAR1}}?",
		values: [{ gainsFromtheSaleOfSecurities: "" }]
	},
	{
		question: "What are your expected unrealized losses from securities in {{CURRENT_YEAR}}? Enter as a positive number?",
		values: [{ expectedUnrealizedLoss: "" }]
	},
	{
		question: "Income from Partnerships, Estates, LLCs, Trusts and S corporations",
		values: [{ IncomeFromPartnerships: "" }]
	}

]
const CapitalGainQuestionsStyles_Long = [
	{},
	{},
	{
		question: "Capital Gains",
		valData: [
			{ placeholder: "Description", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Date acquired", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date" },
			{ placeholder: "Date sold", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date" },
			{ placeholder: "Sales proceeds", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Cost or basis", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Wash sale adjustment", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Enter any sales NOT reported on Forms 1099-B and 1099-S", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	// inputs
	{
		question: "Did you collect on any installment contracts during the year? Provide details.",
		valData: [{ placeholder: "Did you collect on any installment contracts during the year? Provide details.", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "During this year, do you have any securities that became worthless or loans that became uncollectible? Provide details.",
		valData: [{ placeholder: "During this year, do you have any securities that became worthless or loans that became uncollectible? Provide details.", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "What are your expected gains from the sale of securities in {{CURRENT_YEAR}}?",
		valData: [{ placeholder: `What are your expected gains from the sale of securities in curent year?`, styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "How much of the gains on the sale would you be willing to contribute to an opportunity zone investment?",
		valData: [{ placeholder: "How much of the gains on the sale would you be willing to contribute to an opportunity zone investment?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "What are your expected gains from the sale of securities in {{FUTURE_YEAR1}}?",
		valData: [{ placeholder: `What are your expected gains from the sale of securities in future year 1?`, styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "What were your gains from the sale of securities in {{PRIOR_YEAR1}}?",
		valData: [{ placeholder: `What were your gains from the sale of securities in prior year}?`, styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "What are your expected unrealized losses from securities in {{CURRENT_YEAR}}? Enter as a positive number.",
		valData: [{ placeholder: `What are your expected unrealized losses from securities in ${new Date().getFullYear()}? Enter as a positive number.`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Income from Partnerships, Estates, LLCs, Trusts and S corporations",
		valData: [{ placeholder: "Income from Partnerships, Estates, LLCs, Trusts and S corporations", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }]
	}
]

// incomefrom parnerships
const IncomeFromPartnerships_Long = [
	{
		question: "Did you receive any income or expenses from a K-1s from an entity that we did not prepare this year?",
		bool: null,
		values: [
			{ entityName: "" },
			{ entityType: "" },
			{ ownedBy: "" },
			{ employerIdentificationNumber: "" },
			{ KOneExplanation: "" },
		]
	},
]
const IncomeFromPartnershipsStyles_Long = [
	{
		valData: [
			{ placeholder: "Entity Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Entity type", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date" },
			{ placeholder: "Owned by", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date" },
			{ placeholder: "Employer Identification Number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "If K-1 is not available as attached above, provide explanation.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// **
// RetirementPlans
const RetirementPlans_Long = [
	{
		question: "Do you or your spouse have any personal (not from businesses you own) retirement plans currently in place?",
		bool: null,
		values: [
			{ typeOfAccount: "" },
			{ Custodian: "" },
			{ currentValue: "" },
			{ currentYearContribution: "" },
		]
	},
	{
		question: "Did you, or do you plan to, contribute money before April 15, 2021 to a traditional or Roth IRA for the last calendar year?",
		bool: null,
		values: [
			{ ifContributeWriteDetails: "" },
		]
	},
	{
		question: "Did you receive any distribution from an individual retirement account (IRA) or other qualified plan?",
		bool: null
	},
	{
		question: "Did you convert IRA funds or any other qualified retirement plan funds into a Roth IRA?",
		bool: null
	},
	{
		question: "Did you receive any Social Security income or disability payments this year?",
		bool: null
	},
	{
		question: "Do you want to make the maximum deductible IRA contribution?",
		bool: null
	},
	{
		question: "Do you want to make an IRA contribution even if part or all of it may not be deducted?",
		bool: null
	},
	{
		question: "Have you made or do you want to make a Roth IRA contribution?",
		bool: null
	},
	{
		question: "Do you want to make the maximum allowable Keogh/SEP/SIMPLE IRA contribution?",
		bool: null
	},
	{
		question: "Does your spouse want to make the maximum deductible IRA contribution?",
		bool: null
	},
	{
		question: "Does your spouse you want to make an IRA contribution even if part or all of it may not be deducted?",
		bool: null
	},
	{
		question: "Have your spouse made or does your spouse want to make a Roth IRA contribution?",
		bool: null
	},
	{
		question: "Does your spouse want to make the maximum allowable Keogh SEP/SIMPLE IRA contribution",
		bool: null
	},
	// inputs fields
	{
		question: "At what age do you plan to retire?",
		values: [{ agePlanToRetire: "" }]
	},
	{
		question: "How much have you saved for retirement in total?",
		values: [{ totalRetirementSavings: "" }]
	},
	{
		question: "How much is contributed by your business or employer to your retirement plan annually?",
		values: [{ employerAnnualContribution: "" }]
	},
	{
		question: "How much do you plan to contribute to your retirement plan annually?",
		values: [{ annualPersonalContribution: "" }]
	},
	{
		question: "What do you think your annual investment return will be?",
		values: [{ expectedAnnualReturn: "" }]
	},
	{
		question: "At what age does your spouse plan to retire?",
		values: [{ spouseAgePlanToRetire: "" }]
	},
	{
		question: "How much does your spouse have saved for retirement in total?",
		values: [{ spouseTotalSavings: "" }]
	},
	{
		question: "How much is contributed by your spouse's business or employer to their retirement plan annually?",
		values: [{ spouseEmployerAnnualContribution: "" }]
	},
	{
		question: "How much do you plan to contribute to a retirement plan for your spouse annually?",
		values: [{ spouseAnnualPersonalContribution: "" }]
	},
	{
		question: "If you or your spouse withdraw amounts from your IRA or other qualified plan to acquire a personal residence, pay for unreimbursed medical expenses or pay higher education expenses, or was the withdrawal related to certain qualified disasters or COVID-19 provide details.",
		values: [{ withdrawalsForSpecificExpenses: "" }]
	},
	{
		question: "Keogh/SEP/SIMPLE IRA contributions made for this return",
		values: [
			{ keoghSepSimpleIraContributions: "" },
			{ keoghSimpleIraEstablishmentDate: new Date() },
		]
	},
	{
		question: "Date Keogh/SIMPLE IRA plan established",
		values: [{ keoghSimpleIraEstablishmentDate: new Date() }]
	},
]
const RetirementPlansStyles_Long = [
	{
		valData: [
			{ placeholder: "Type of Account", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Custodian", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date" },
			{ placeholder: "Current Value", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date" },
			{ placeholder: "Current Year Contribution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "Provide details (note that some states may have earlier due dates)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{
		valData: [{ placeholder: "At what age do you plan to retire?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "How much have you saved for retirement in total?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "How much is contributed by your business or employer to your retirement plan annually?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "How much do you plan to contribute to your retirement plan annually?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "What do you think your annual investment return will be?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "At what age does your spouse plan to retire?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "How much does your spouse have saved for retirement in total?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "How much is contributed by your spouse's business or employer to their retirement plan annually?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "How much do you plan to contribute to a retirement plan for your spouse annually?", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "If you or your spouse withdraw amounts from your IRA or other qualified plan to acquire a personal residence, pay for unreimbursed medical expenses or pay higher education expenses, or was the withdrawal related to certain qualified disasters or COVID-19 provide details.", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		valData: [
			{ placeholder: "Keogh/SEP/SIMPLE IRA contributions made for this return", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Date Keogh/SIMPLE IRA plan established", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [{ placeholder: "Date Keogh/SIMPLE IRA plan established", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
// _______________Health and Medical INPUTS________________
const HealthAndMedical_Long = [
	{
		question: "Payments for in-home care",
		values: [
			{ nameOfExpense: "" },
			{ amountOfExpense: "" },
			{ percentUsedForBusiness: "" },
		]
	},
	{
		question: "Family medical insurance premiums",
		values: [{ familyMedicalInsurancePremiums: "" }]
	},
	{
		question: "Family medical out-of-pocket expenses",
		values: [{ familyMedicalOutOfPocketExpenses: "" }]
	},
	{
		question: "Family medical copays",
		values: [{ familyMedicalCopays: "" }]
	},
	{
		question: "Family life insurance premiums",
		values: [{ familyLifeInsurancePremiums: "" }]
	},
	{
		question: "Family disability insurance premiums",
		values: [{ familyDisabilityInsurancePremiums: "" }]
	},
	{
		question: "Family long term care premiums",
		values: [{ familyLongTermCarePremiums: "" }]
	},
	{
		question: "Premiums for health and accident insurance including Medicare, not claimed elsewhere",
		values: [{ premiumsHealthAccidentInsuranceNotClaimedElsewhere: "" }]
	},
	{
		question: "Medicine and drugs (prescription only)",
		values: [{ prescriptionMedicineAndDrugs: "" }]
	},
	{
		question: "Over the counter medications",
		values: [{ overTheCounterMedications: "" }]
	},
	{
		question: "Doctors, dentists, nurses",
		values: [{ doctorsDentistsNurses: "" }]
	},
	{
		question: "Hospitals, clinics, laboratories",
		values: [{ hospitalsClinicsLaboratories: "" }]
	},
	{
		question: "Ambulance",
		values: [{ ambulance: "" }]
	},
	{
		question: "Medical supplies/equipment",
		values: [{ medicalSuppliesEquipment: "" }]
	},
	{
		question: "Hearing aids",
		values: [{ hearingAids: "" }]
	},
	{
		question: "Eye exams, glass, and contacts",
		values: [{ eyeExamsGlassesContacts: "" }]
	},
	{
		question: "Orthodontics",
		values: [{ orthodontics: "" }]
	},
	{
		question: "Lodging and meals",
		values: [{ lodgingAndMeals: "" }]
	},
	{
		question: "Travel",
		values: [{ travel: "" }]
	},
	{
		question: "Medical mileage (number of miles)",
		values: [{ medicalMileage: "" }]
	},
	{
		question: "Long-term care expenses*",
		values: [{ longTermCareExpenses: "" }]
	},
	{
		question: "What are your other unreimbursed medical expenses not already submitted above?",
		values: [{ unreimbursedMedicalExpenses: "" }]
	}
]
const HealthAndMedicalStyles_Long = [
	{
		valData: [
			{ placeholder: "Name of Expense", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount of Expense", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date", mask: "999999999" },
			{ placeholder: "% Used for Business", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date", mask: "999999999" },
		]
	},
	{
		question: "Family medical insurance premiums",
		valData: [{ placeholder: "Family medical insurance premiums", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Family medical out-of-pocket expenses",
		valData: [{ placeholder: "Family medical out-of-pocket expenses", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Family medical copays",
		valData: [{ placeholder: "Family medical copays", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Family life insurance premiums",
		valData: [{ placeholder: "Family life insurance premiums", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Family disability insurance premiums",
		valData: [{ placeholder: "Family disability insurance premiums", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Family long term care premiums",
		valData: [{ placeholder: "Family long term care premiums", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Premiums for health and accident insurance including Medicare, not claimed elsewhere",
		valData: [{ placeholder: "Premiums for health and accident insurance including Medicare, not claimed elsewhere", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Medicine and drugs (prescription only)",
		valData: [{ placeholder: "Medicine and drugs (prescription only)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Over the counter medications",
		valData: [{ placeholder: "Over the counter medications", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Doctors, dentists, nurses",
		valData: [{ placeholder: "Doctors, dentists, nurses", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Hospitals, clinics, laboratories",
		valData: [{ placeholder: "Hospitals, clinics, laboratories", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Ambulance",
		valData: [{ placeholder: "Ambulance", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Medical supplies/equipment",
		valData: [{ placeholder: "Medical supplies/equipment", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Hearing aids",
		valData: [{ placeholder: "Hearing aids", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Eye exams, glass, and contacts",
		valData: [{ placeholder: "Eye exams, glass, and contacts", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Orthodontics",
		valData: [{ placeholder: "Orthodontics", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Lodging and meals",
		valData: [{ placeholder: "Lodging and meals", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Travel",
		valData: [{ placeholder: "Travel", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Medical mileage (number of miles)",
		valData: [{ placeholder: "Medical mileage (number of miles)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Long-term care expenses",
		valData: [{ placeholder: "Long-term care expenses", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "What are your other unreimbursed medical expenses not already submitted above?",
		valData: [{ placeholder: "What are your other unreimbursed medical expenses not already submitted above?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }]
	}
]
// othet deductions summary
const otherDeductionSummaryFields_Long = [
	{
		question: "What are the total educator expenses?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are the total unreimbursed business expenses?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are the total health savings account expenses?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are the total moving expenses?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is the total penalty on early withdrawal of savings?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is the total alimony paid?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is the total IRA deduction?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is the total student loan interest deduction?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are the total tuition and fees NOT already deducted from a business you directly own?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What are the total other adjustments?",
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	}
];

const otherDeductionSummaryStyles_Long = [
	{
		question: "What are the total educator expenses?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total unreimbursed business expenses?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total health savings account expenses?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total moving expenses?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total penalty on early withdrawal of savings?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total alimony paid?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total IRA deduction?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total student loan interest deduction?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total tuition and fees NOT already deducted from a business you directly own?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total other adjustments?",
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	}
]
const otherAdjustmentsDetails_Long = [
	{
		question: "Did you receive any proceeds (including insurance) on property which was taken from you by destruction, theft, seizure or condemnation?",
		bool: null
	},
	{
		question: "Did you receive any distributions from an HSA? Were all distributions made for qualified medical expenses?",
		bool: null
	},
	{
		question: "Did you have any other adjustments? Example attachments includes reforestation expenses, whistleblower fees, rental of personal property.",
		bool: null
	},
	{
		question: "Did you, or do you plan to, contribute money before April 15, 2021 to a health savings account (HSA) for the last calendar year?",
		bool: null,
		values: [
			{ detailsOfPlan: "" },
		]
	},
	{
		question: "Did you incur expenses as an elementary or secondary educator?",
		bool: null,
		values: [
			{ amountDeductible: "" },

		]
	},
	{
		question: "Provide details, including the date of the divorce agreement and the Social Security number of the spouse paying the alimony or whom the alimony was paid.",
		values: [
			{ detailsOfDivorceAggrement: "" },
		]
	}
]
const otherAdjustmentsDetailsStyles_Long = [
	{},
	{},
	{},
	{
		question: "Did you, or do you plan to, contribute money before April 15, 2021 to a health savings account (HSA) for the last calendar year?",
		bool: null,
		valData: [
			{ placeholder: "Provide details", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did you incur expenses as an elementary or secondary educator?",
		bool: null,
		valData: [
			{ placeholder: "If so, how much? The amount deductible is limited to $250 per taxpayer.", styleProp: "col-lg-12 col-md-8 col-sm-12" },

		]
	},
	{
		question: "Provide details, including the date of the divorce agreement and the Social Security number of the spouse paying the alimony or whom the alimony was paid.",
		valData: [
			{ placeholder: "Provide details, including the date of the divorce agreement and the Social Security number of the spouse paying the alimony or whom the alimony was paid.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	}
]
const ItemizedDeductionDetail_Long = [
	{
		question: "Did you have any taxes paid?",
		bool: null,
		values: [
			{ incomeTaxPayments: "" },
			{ salesTaxOnMajorItems: "" },
			{ taxesForPrimaryResidences: "" },
			{ taxesForSecondaryResidences: "" },
			{ otherTaxes: "" },
			{ valoremTaxes: "" },
			{ otherSalesTaxIfApplicable: "" },
		]
	},
]
const ItemizedDeductionDetailStyles_Long = [
	{
		question: "Did you, or do you plan to, contribute money before April 15, 2021 to a health savings account (HSA) for the last calendar year?",
		bool: null,
		valData: [
			{ placeholder: "State and local income tax payments made this year for prior year(s)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Sales tax on major items (auto, boat, home improvements, etc.)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Real estate taxes for primary residence", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Real estate taxes for secondary residence", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Other real estate taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Personal property or ad valorem taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Other sales taxes paid (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
const IntangibleTaxDetail_Long = [
	{
		question: "Foreign tax withheld",
		values: [
			{ descriptionOfTax: "" },
			{ taxAmount: "" },
		]
	},
	{
		question: "Did you have any interest expenses?",
		bool: null,
		values: [
			{ propertyDescription: "" },
			{ Payee: "" },
			{ Amount: "" },
			{ mortgageInsurancePremiums: "" },
		]
	},
	{
		question: "Was the mortgage interest paid to an individual?",
		bool: null,
		values: [
			{ socialSecurityNumber: "" },
			{ individualAddress: "" },
			{ mortgageBalanceBegining: "" },
			{ mortgageBalanceEnd: "" },
		]
	},
	// <><>
	{
		question: "Did you refinance your mortgage and pay points?",
		bool: null,
		values: [
			{ unamortizedPoints: "" },
			{ dateOfRefinance: new Date() },
			{ refinanceLoanTerms: "" },
			{ refinanceTotalPoints: "" }
		]
	},
	{
		question: "Did you have any Investment interest expense not reported elsewhere?",
		bool: null,
		values: [
			{ InvestmentInterestPayee: "" },
			{ investmentPurpose: "" },
			{ investmentInterestAmount: "" }
		]
	},
	{
		question: "Did you make cash contributions for which you have receipts, canceled checks, etc?",
		bool: null,
		values: [
			{ Donee: '' },
			{ Amount: "" }
		]
	},
	{
		question: "Did you incur expenses in performing volunteer work for charitable organizations?",
		bool: null,
		values: [
			{ volunteerWorkParkingFees: "" },
			{ volunteerWorkSupplies: "" },
			{ volunteerWorkMeals: "" },
			{ volunteerWorkOther: "" },
			{ volunteerWorkAutomobileMileage: "" },
		]
	},
	// 7
	{
		question: "Did you make other than cash contributions for which you have receipts?",
		bool: null,
		values: [
			{ OrganizationName: "" },
			{ organizationAddress: "" },
			{ descriptionOfProperty: "" },
			{ dateAcquired: new Date() },
			{ howAcquired: "" },
			{ costOrBasis: "" },
			{ dateContributed: new Date() },
			{ fairMarketValue: "" },
			{ FMVDetermined: "" },
		]
	},
	// 8
	{
		question: "Did you have a casualty or theft loss this year?",
		bool: null,
		values: [
			{ descriptionOfPoperty: "" },
			{ typeOfProperty: "" },
			{ dateAcquired: new Date() },
			{ cost: "" },
			{ dateOfLoss: new Date() },
			{ descriptionOfLoss: "" },
			{ wasInsuranceClaimMade: "" },
			{ fairMarketValueBeforeLoss: "" },
			{ fairMarketValueAfterLoss: "" },
		]
	},
	{
		question: "Did you have any other miscellaneous deductions (may be deductible for state income tax purposes)?",
		bool: null,
	},
]

const IntangibleTaxDetailStyles_Long = [
	{
		valData: [
			{ placeholder: "description of tax", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "tax amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "Property Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Payee", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Mortgage insurance premiums", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "Individual's Social Security Number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Individual's address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Mortgage balance beginning of the year", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Mortgage balance end of the year", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	// <><><>
	{
		question: "Did you refinance your mortgage and pay points?",
		bool: null,
		valData: [
			{ placeholder: "Unamortized points on residence refinancing", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date of refinance", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Refinance Loan terms", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Refinance Total points", styleProp: 'col-lg-6 col-md-8 col-sm-12', mask: "999999999" },
		]
	},
	{
		question: "Did you have any Investment interest expense not reported elsewhere?",
		bool: null,
		valData: [
			{ placeholder: "Investment interest Payee", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Investment purpose (stocks, land, etc.)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Investment interest Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you make cash contributions for which you have receipts, canceled checks, etc?",
		bool: null,
		valData: [
			{ placeholder: "Donee", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Did you incur expenses in performing volunteer work for charitable organizations?",
		bool: null,
		valData: [
			{ placeholder: "Volunteer work parking fees and tolls", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Volunteer work supplies", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Volunteer work meals and entertainment", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Volunteer work other", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Volunteer work automobile mileage", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you make other than cash contributions for which you have receipts?",
		bool: null,
		valData: [
			{ placeholder: "Organization name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Organization address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Description of property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date acquired", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "How acquired", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Cost or basis", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date contributed", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Fair market value (FMV)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "How FMV determined", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did you have a casualty or theft loss this year?",
		bool: null,
		valData: [
			{ placeholder: "Description of property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date acquired", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Cost", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date of loss", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Description of loss", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Was insurance claim made?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Fair market value before loss", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Fair market value after loss", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{},
]
// <><><>*****
const IncomeTaxPreparationFees_Long = [
	{
		question: "Investment advisory fees",
		values: [
			{ Description: "" },
			{ Amount: "" },
		]
	},
	{
		question: "Did you pay an individual or an organization to perform services for the care of a dependent under 13 years old?",
		bool: null,
		values: [
			{ serviceAndAmountPaid: "" },
			{ childAndDependentCare: "" },
		]
	},
	{
		question: "Did you pay an individual to perform in-home health care services for yourself, your spouse or dependents?",
		bool: null,
		values: [
			{ nameOfDependent: "" },
			{ nameOfprovider: "" },
			{ providersAddress: "" },
			{ providersIDNumber: "" },
			{ amount: "" },
		]
	},
	{
		question: "Did you pay an individual or an organization to perform services for the care of a dependent under 13 years old or your spouse or dependent age 13 or over, if physically or mentally incapable of caring for themselves in order to enable you to work or attend school on a full-time basis?",
		bool: null,
	},
	{
		question: "Did you use funds from a cafeteria plan at work to pay for any daycare expenses?",
		bool: null,
	},
]
const IncomeTaxPreparationFeesStyles_Long = [
	{
		question: "Investment advisory fees",
		valData: [
			{ placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you pay an individual or an organization to perform services for the care of a dependent under 13 years old?",
		bool: null,
		valData: [
			{ placeholder: "Please describe the service paid for as well as the total amount paid.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Child and Dependent Care Expenses Detail", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you pay an individual to perform in-home health care services for yourself, your spouse or dependents?",
		bool: null,
		valData: [
			{ placeholder: "Name of dependent for whom services were rendered", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Name of Provider", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Provider's address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Provider's ID number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{},
	{},
]
// edu
const EducationalExpenses_Long = [
	{
		question: "Did you or any other member of your family pay attend a post secondary educational institute this year?",
		bool: null,
		values: [
			{ studentName: "" },
			{ institution: "" },
			{ gradeLevel: "" },
			{ amountPaid: "" },
			{ DatePaid: new Date() },
		]
	},
	{
		question: "Was any of the preceding tuition paid with funds withdrawn from an educational IRA or 529 plan?",
		bool: null,
		values: [
			{ totalPrecedingTuitionPaid: "", placeholder: "Total preceding tuition paid with funds withdrawn from an educational IRA or 529 plan" },
			{ additionalExplanationsRegardingEducationalExpenses: "", placeholder: "Additional explanations regarding educational expenses." },
		]
	},
]
const EducationalExpensesStyles_Long = [
	{
		question: "Did you or any other member of your family pay attend a post secondary educational institute this year?",
		bool: null,
		valData: [
			{ placeholder: "Student name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Institution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Grade/level", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount paid", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Date paid", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Was any of the preceding tuition paid with funds withdrawn from an educational IRA or 529 plan?",
		bool: null,
		valData: [
			{ placeholder: "Total preceding tuition paid with funds withdrawn from an educational IRA or 529 plan", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Additional explanations regarding educational expenses.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]

// salesOfAssets
const SalesOfAssets_Long = [
	{
		question: "Did you sell significant assets for a gain this year (not related to a business you own)?",
		bool: null,
		values: [
			{ nameOfAsset: "" },
			{ expectedSellingPrice: "" },
			{ expectedGainsOnSale: "" },
			{ willingToSell: "" },
			{ howMuchWillingToContribute: "" },
			{ howMuchWillingToExchange: "" },
		]
	},
	{
		question: "Are you transferring this asset before a letter of intent for the sale of the asset has been signed?",
		bool: null,
		values: [
			{ gainOnYourSaleOfAsset: "" },
			{ cashKeepForPersonalUse: "" },
			{ expectedLimitedPartnerPercentage: "" },
			{ calculatedIndependentAsset: "" },
			{ additionalCashToContribute: "" },
			{ totalAppriciatedAsset: "" },
		]
	},
]
const SalesOfAssetsStyles_Long = [
	{
		valData: [
			{ placeholder: "Name of asset", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Expected selling price of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Expected gain on sale of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If willing to sell asset as an installment sale, how many years would you be willing to hold the loan?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much of the gain on the sale would you be willing to contribute to an Opportunity Zone Investment?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If this is real estate, how much would you be willing to exchange into another real estate asset?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "What is the total gain on your sale of assets?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much cash from the sale would you like to keep for personal use?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What is the expected limited partner percentage (interest allocated to charity)?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What is the calculated independent asset valuation percentage?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much additional cash do you want to contribute to the Family Endowment (not included the gain on sale of asset)?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What is the total appreciated asset amount you wish to contribution to the Family Endowment (not included the gain on sale of asset; this may include appreciated stock, or real estate)?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// purchaseOfAsset
const PurchaseOfAsset_Long = [
	{
		question: "Did you purchase an asset in the current year?",
		bool: null,
		values: [
			{ assetDescription: "" },
			{ loanLeasePayments: "" },
			{ insurance: "" },
			{ otherAssetExpenses: "" },
			{ percentUsedForBusiness: "" },
		]
	},
]
const PurchaseOfAssetStyles_Long = [
	{
		valData: [
			{ placeholder: 'Asset description', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Loan/Lease payments", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Insurance (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Other asset expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "% used for business (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// Charity
const Charity_Long = [
	{
		question: "What is the total value of your non productive land not owned by your business?",
		values: [
			{ nonProductiveLandTotalValue: "" },
		]
	},
	{
		question: `What is the total gift amount you would be willing to give to charity in ${new Date().getFullYear()} ?`,
		values: [
			{ totalGiftAmount: "" },
		]
	},
	{
		question: "What is your expected charitable AGI limitation?",
		values: [
			{ expectedCharitableAGI: "" },
		]
	},
]
const CharityStyles_Long = [
	{
		question: "What is the total value of your non productive land not owned by your business?",
		valData: [
			{ placeholder: "What is the total value of your non productive land not owned by your business?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: `What is the total gift amount you would be willing to give to charity in ${new Date().getFullYear()} ?`,
		valData: [
			{ placeholder: `What is the total gift amount you would be willing to give to charity in ${new Date().getFullYear()}?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is your expected charitable AGI limitation?",
		valData: [
			{ placeholder: "What is your expected charitable AGI limitation?", styleProp: 'col-lg-12 col-md-8 col-sm-12', mask: "999999999" },
		]
	},
]

// OtherCredits
// {
// 	question: "What is your expected charitable AGI limitation?",
// 	values: [
// 		{ expectedCharitableAGI:""},
// 	]
// },
const OtherCredits_Long = [
	{
		question: "Did you purchase gasoline, oil or special fuels for non-highway use vehicles?",
		bool: null,
	},
	{
		question: "Did you purchase an energy efficient or other new vehicle?",
		bool: null,
	},
	{
		question: "Did you pay sales tax on any large purchases including home improvements?",
		bool: null,
	},
	{
		question: "Did you make any energy-efficient improvements (remodel or new construction) to your home?",
		bool: null,
	},
	{
		question: "Did you purchase and place in service any solar water heating, solar electric, fuel cells, small wind energy or geothermal heat pump to any property you own (not just your home)?",
		bool: null,
	},
	// {
	// 	question: "Did you incur adoption expenses or adopt a U.S. child that the state has determined to have special needs?",
	// 	bool: null,
	// },
	{
		question: "Other Taxes, Tax Payments and Refunds",
		bool: null,
	},
	{
		question: "Did you pay any household employee over age 18 wages of $2,200 or more?",
		bool: null,
	},
	{
		question: "Did you pay total wages of $1,000 or more in any calendar quarter to all household employees?",
		bool: null,
	},
	{
		question: "Do you want any overpayment of taxes applied to next year’s estimated taxes?",
		bool: null,
	},
	{
		question: "Do you want any federal or state refund deposited directly into your bank account?",
		bool: null,
	},
	{
		question: "Do you want any balance due directly withdrawn from this same bank account on the due date?",
		bool: null,
	},
	{
		question: "Do you want next year’s estimated taxes withdrawn from this same bank account on the due dates?",
		bool: null,
	},
	// new 0-11 above bool
	// 0-12 above bool
	{
		question: "Do you expect a large fluctuation in your income, deductions or withholding? This will help us calculate possible changes to estimated tax payments.",
		bool: null,
		values: [
			{ largeFluctuationIncome: "" },
		]
	},
	{
		question: "If you owe federal or state tax upon completion of your return are you able to pay the balance due?",
		bool: null,
		values: [
			{ ableToPayTheDue: "", placeholder: "Please provide further information." },
			{ federalPriorYearOverpayment: "" },
		]
	},
	{
		question: "Did you have any state prior year overpayment applied?",
		bool: null,
		values: [
			{ overpaymentState: "" },
			{ overpaymentAmount: "" },
		]
	},
	// 15
	{
		question: "Did you make any federal estimated tax payments last year?",
		bool: null,
		values: [
			{ federalTaxPaymentsDate: new Date() },
			{ federalTaxPaymentsAmount: "" },
		]
	},
	// 16
	{
		question: "Did you make any state estimated tax payments last year?",
		bool: null,
		values: [
			{ stateEstimatedTaxPaymentsState: "" },
			{ stateEstimatedTaxPaymentsDate: new Date() },
			{ stateEstimatedTaxPaymentsAmount: "" },
		]
	},
	{
		question: "Did you incur adoption expenses or adopt a U.S. child that the state has determined to have special needs?",
		bool: null,
		values: [
			{ otherTaxesTaxPayments: "", placeholder: "Other Taxes, Tax Payments and Refunds" },
		]
	},
];

const OtherCreditsStyles_Long = [
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	// 
	{
		question: "Do you expect a large fluctuation in your income, deductions or withholding? This will help us calculate possible changes to estimated tax payments.",
		bool: null,
		valData: [
			{ placeholder: "Provide details.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "If you owe federal or state tax upon completion of your return are you able to pay the balance due?",
		bool: null,
		valData: [
			{ placeholder: "Please provide further information.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Federal prior year overpayment applied", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did you have any state prior year overpayment applied?",
		bool: null,
		valData: [
			{ placeholder: "Overpayment State", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Overpayment Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you make any federal estimated tax payments last year?",
		bool: null,
		valData: [
			{ placeholder: "Federal estimated tax payments Date", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Federal estimated tax payments amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you make any state estimated tax payments last year?",
		bool: null,
		valData: [
			{ placeholder: "State estimated tax payments state", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "State estimated tax payments date", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "State estimated tax payments amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you incur adoption expenses or adopt a U.S. child that the state has determined to have special needs?",
		bool: null,
		valData: [
			{ placeholder: "Other Taxes, Tax Payments and Refunds", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]

// QBID__________
const QBID_Long = [
	{
		question: "What are your expected net capital gains for the current year, excluding dividends paid from businesses you own?",
		values: [
			{ expectedNetCapitalGain: "" },
		]
	},
	{
		question: "What are your expected total Section 199A REIT dividends and publicly traded partnerships (PTP) income or loss for the current year (if applicable)?",
		values: [
			{ expectedTotalSection199A: "" },
		]
	},
	{
		question: "What are your Section 199A total carryover losses from REITs and PTPs from prior years?",
		values: [
			{ section199ATotalCarryoverLosses: "" },
		]
	},
	{
		question: "What are your Domestic Production Activity Deductions Under Section 199A(g), for the current year?",
		values: [
			{ domesticProductionActivityDeductions: "" },
		]
	},
];

const QBIDStyles_Long = [
	{
		question: "What are your expected net capital gains for the current year, excluding dividends paid from businesses you own?",
		valData: [
			{ placeholder: 'What are your expected net capital gains for the current year, excluding dividends paid from businesses you own?', styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What are your expected total Section 199A REIT dividends and publicly traded partnerships (PTP) income or loss for the current year (if applicable)?",
		valData: [
			{ placeholder: "What are your expected total Section 199A REIT dividends and publicly traded partnerships (PTP) income or loss for the current year (if applicable)?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What are your Section 199A total carryover losses from REITs and PTPs from prior years (if applicable)?",
		valData: [
			{ placeholder: "What are your Section 199A total carryover losses from REITs and PTPs from prior years (if applicable)?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What are your Domestic Production Activity Deductions Under Section 199A(g), for the current year (if applicable)?",
		valData: [
			{ placeholder: "What are your Domestic Production Activity Deductions Under Section 199A(g), for the current year (if applicable)?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]

// Oil and Gas
const OilAndGas_Long = [
	{
		question: "Are you interested in investing in oil and gas?",
		bool: null,
		values: [
			{ totalCapitalInvestmentAmount: "", placeholder: `What is the total capital investment amount you would be willing to invest in an oil & gas company in ${new Date().getFullYear()}?` },
			{ assumedPercentageOfInitialCapitalInvestmentIntangible: "", placeholder: "What the assumed percentage of initial capital investment will be allocated towards intangible drilling costs (IDCs)?" },
			{ assumedPercentageOfInitialCapitalInvestmentTangible: "", placeholder: "What is the assumed percentage of initial capital investment will be allocated towards tangible depreciable expenses?" },
		]
	},
];

const OilAndGasStyles_Long = [
	{
		valData: [
			{ placeholder: `What is the total capital investment amount you would be willing to invest in an oil & gas company in ${new Date().getFullYear()}?`, styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "What the assumed percentage of initial capital investment will be allocated towards intangible drilling costs (IDCs)?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "What is the assumed percentage of initial capital investment will be allocated towards tangible depreciable expenses?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]

// International
const International_Long = [
	{
		question: "Would you be willing to move to Puerto Rico or the U.S. Virgin Islands if that move resulted in substantial tax savings?",
		bool: null,
	},
];

const InternationalStyles_Long = [
	{},
]
// NetOperatingLosses
const NetOperatingLosses_Long = [
	{
		question: `Filing status in prior year 1`,
		values: [
			{ fillingStatus: "" }
		],
	},
	{
		question: `Taxable income in prior year 1`,
		values: [
			{ taxableIncome: "" }
		],
	},
	{
		question: `Tax in prior year 1`,
		values: [
			{ tax: "" }
		],
	},
	{
		question: `Filing status in prior year 2}`,
		values: [
			{ fillingStatusOne: "" }
		],
	},
	{
		question: `Taxable income in prior year 2}`,
		values: [
			{ taxableIncomeOne: "" }
		],
	},
	{
		question: `Tax in prior year 2}`,
		values: [
			{ taxOne: "" }
		],
	},
	{
		question: `Filing status in prior year 3`,
		values: [
			{ fillingStatusTwo: "" }
		],
	},
	{
		question: `Taxable income in prior year 3`,
		values: [
			{ taxableIncomeTwo: "" }
		],
	},
	{
		question: `Tax in prior year 3`,
		values: [
			{ taxTwo: "" }
		],
	},
	{
		question: `Filing status in prior year 4`,
		values: [
			{ fillingStatusThree: "" }
		],
	},
	{
		question: `Taxable income in prior year 4`,
		values: [
			{ taxableIncomeThree: "" }
		],
	},
	{
		question: `Tax in prior year 4`,
		values: [
			{ taxThree: "" }
		],
	},
	{
		question: `Filing status in prior year 5`,
		values: [
			{ fillingStatusFour: "" }
		],
	},
	{
		question: `Taxable income in prior year 5`,
		values: [
			{ taxableIncomeFour: "" }
		],
	},
	{
		question: `Tax in prior year 5`,
		values: [
			{ taxFour: "" }
		],
	},
];
const NetOperatingLossesStyles_Long = [
	{
		question: `Filing status in prior year 1`,
		valData: [
			{ placeholder: `Filing status in prior year 1`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in prior year 1`,
		valData: [
			{ placeholder: `Taxable income in prior year 1`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in prior year 1`,
		valData: [
			{ placeholder: `Tax in prior year 1`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Filing status in prior year 2`,
		valData: [
			{ placeholder: `Filing status in prior year 2`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in prior year 2`,
		valData: [
			{ placeholder: `Taxable income in prior year 2`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in prior year 2`,
		valData: [
			{ placeholder: `Tax in prior year 2`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Filing status in prior year 3`,
		valData: [
			{ placeholder: `Filing status in prior year 3`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in prior year 3`,
		valData: [
			{ placeholder: `Taxable income in prior year 3`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in prior year 3`,
		valData: [
			{ placeholder: `Tax in prior year 3`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Filing status in prior year 4`,
		valData: [
			{ placeholder: `Filing status in prior year 4`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in prior year 4`,
		valData: [
			{ placeholder: `Taxable income in prior year 4`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in prior year 4`,
		valData: [
			{ placeholder: `Tax in prior year 4`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Filing status in prior year 5`,
		valData: [
			{ placeholder: `Filing status in prior year 5`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in prior year 5`,
		valData: [
			{ placeholder: `Taxable income in prior year 5`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in prior year 5`,
		valData: [
			{ placeholder: `Tax in prior year 5`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
]

// AssetProtection
const AssetProtection_Long = [
	{
		question: "Do you have a will?",
		bool: null,
	},
	{
		question: "Have you set up any trusts?",
		bool: null,
	},
	{
		question: "Have you done any succession planning?",
		bool: null,
	},
	{
		question: "Do you have adequate assets protection?",
		bool: null,
	},
	{
		question: "Are your heirs adequately provided for?",
		bool: null,
	},
	{
		question: "Do you have a gifting plan in place?",
		bool: null,
	},
	{
		question: "Do you have life insurance?",
		bool: null,
		values: [
			{ typeOfAccount: "", placeholder: "Type of Account" },
			{ custodian: "", placeholder: "Custodian" },
			{ currentValue: "", placeholder: "Current Value" },
			{ currentYearContribution: "", placeholder: "Current Year Contribution" },
		]
	}
];

const AssetProtectionStyles_Long = [
	{},
	{},
	{},
	{},
	{},
	{},
	{
		valData: [
			{ placeholder: "Type of Account", styleProp: "col-lg-6 col-md-8 col-sm-12", },
			{ placeholder: "Custodian", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Current Value", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Current Year Contribution", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	}
]
// AdditionalQuestions
const AdditionalQuestions_Long = [
	{
		question: "Do you want to designate $3 to the Presidential Election Campaign Fund?",
		bool: null
	},
	{
		question: "Does your spouse want to designate $3 to the Presidential Election Campaign Fund?",
		bool: null
	},
	{
		question: "Has the IRS, or any state or local taxing agency, notified you of changes to a prior year’s tax return in which you have not already notified us (including a partnership or LLC in which you have an investment)?",
		bool: null
	},
	{
		question: "Did you acquire, use, dispose of or hold any virtual currency/cryptocurrency (such as bitcoin)?",
		bool: null
	},
	{
		question: "Did you make gift(s) to any person that total more than $15,000 this year?",
		bool: null
	},
	{
		question: "Did you make any discounted gifts or gifts of future interest to any person or trust?",
		bool: null
	},
	{
		question: "Did you and all members of your household maintain minimum essential health coverage for all months of 2020? Minimum essential coverage includes employer-sponsored health insurance coverage, Medicare, Medicaid or Tricare.",
		bool: null
	},
	{
		question: "Did you purchase or convert property you already owned to rental property?",
		bool: null
	},
	{
		question: "Did you acquire or dispose of any interests in partnerships, LLCs, S corporations, estates or trusts this year?",
		bool: null
	},
	{
		question: "Did you participate in any bartering transactions (including the use of virtual currency)?",
		bool: null
	},
	{
		question: "Can the IRS and state tax authority discuss questions about this return with the preparer?",
		bool: null
	},
	{
		question: "Did you or any of your dependents receive an identity protection personal identification number (IP PIN) from the IRS or have you been a victim of identity theft, either in 2020 or in prior years?",
		bool: null
	},
	{
		question: "Did you receive an economic stimulus payment in the prior year?",
		bool: null,
		values: [
			{ nameOfRecipient: "" },
			{ paymentReceivedOn: new Date() },
			{ totalAmountOfPaymentReceived: "" },
		]
	},
	{
		question: "Did you receive any income from any legal proceedings, cancelation of student loans or other indebtedness during the year? Provide details.",
		bool: null,
		values: [
			{ ifReceiveAnyIncomeDetails: "" },
		]
	},
	// 
	{
		question: "Do you have any unpaid sales/use tax for tax year 2020 (such as from goods you purchased online or from a catalog)?",
		bool: null,
		values: [
			{ State: "" },
			{ Description: "" },
			{ Amount: "" },
		]
	},
	{
		question: "Did you start a business?",
		bool: null,
		values: [
			{ businessName: "" },
			{ purpose: "" },
			{ startedDate: new Date() },
			{ mission: "" },
		]
	},
]

const AdditionalQuestionsStyles_Long = [
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	{},
	// the first val is Date
	{
		valData: [
			{ placeholder: "Name of recipient", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Payment received on", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total amount of payment received", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "provide details", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	// 
	{
		valData: [
			{ placeholder: "State", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	// {
	// 	valData:[
	// 		{placeholder:"Provide details including name of business, purpose, date started, mission.", styleProp:"col-lg-12 col-md-8 col-sm-12"},
	// 	]
	// },
	{
		question: "Did you start a business?",
		bool: null,
		valData: [
			{ placeholder: "Name Of Business", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Purpose", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date Started", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "mission", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]

// <><><>
const PersonalInformation_individualNewClientShort = [
	{
		question: "Were you married on the last day of the tax year?",
		bool: null
	},
	{
		question: "Was there a change in address?",
		bool: null
	},
	{
		question: "Did any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return?",
		bool: null,
		values: [
			{ describeAnyBirthAdoptions: "" },
			{ priorYearTaxReturn: "" },
		]
	},
	{
		question: "Are SSNs censored on the prior year tax return?",
		bool: null,
		values: [
			{ SSN: "" }
		]
	},
	// 4
	{
		question: "Your date of birth",
		values: [{ dateOfBirth: new Date() }]
	},
	{
		question: "Preferred phone number",
		values: [{ preferredPhoneNumber: "" }]
	},
	{
		question: "Preferred email address",
		values: [{ preferredEmailAddress: "" }]
	},
	// 7
	{
		question: "Spouse's date of birth",
		values: [{ spouseDateOfBirth: new Date() }]
	},
	{
		question: "Spouse's mobile phone number",
		values: [{ spouseMobilePhoneNumber: "" }]
	},
	{
		question: "Spouse's email address",
		values: [{ spouseEmailAddress: "" }]
	}
]
const PersonalInformation_individualNewClientShort_Styles = [
	{},
	{},
	{
		question: "Did any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return?",
		bool: null,
		valData: [
			{ placeholder: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Prior Year Tax Returns", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Are SSNs censored on the prior year tax return?",
		bool: null,
		valData: [
			{ placeholder: "Please include your SSN here.", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Your date of birth",
		valData: [{ placeholder: "Your date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Preferred phone number",
		valData: [{ placeholder: "Preferred phone number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Preferred email address",
		valData: [{ placeholder: "Preferred email address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" }]
	},
	{
		question: "Spouse's date of birth",
		valData: [{ placeholder: "Spouse's date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's mobile phone number",
		valData: [{ placeholder: "Spouse's mobile phone number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Spouse's email address",
		valData: [{ placeholder: "Spouse's email address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" }]
	}
]
// *********
const Dependent_individualNewClientShort = [
	{
		question: "Do you have any dependents?",
		bool: null,
		values: [
			{ name: "" },
			{ dateOfBirth: new Date() },
			{ isThisStudent: "" },
			{ monthsLiveInYourHome: "" },
			{ disbaled: "" },
			{ taxReturn: "" },
			{ priorYearTaxReturn: "" },
		]
	},
]
const Dependent_individualNewClientShort_Styles = [
	{
		question: "Do you have any dependents?",
		bool: null,
		valData: [
			{ placeholder: "Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Is this dependent a student in college full-time?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How many months did this dependent live in your home?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Is this dependent totally and permanently disabled?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Do you want us to prepare your dependent’s tax return?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Was this dependent on the prior year's tax return?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]
// <>>>>>>>>>>>>
const PrimaryResidence_individualNewClientShort = [
	{
		question: "Did you change your address?",
		bool: null,
		values: [
			{ address: "" },
			{ dateFrom: new Date() },
			{ dateTo: new Date() },
		]
	},
	{
		question: "Did you sell or purchase a personal residence?",
		bool: null,
		values: [
			{ purchasePrice: "", placeholder: "What was the purchase price?", mask: "999999999" },
			{ dateOfPurchase: new Date(), placeholder: "What was the date of purchase?" },
		]
	},
	{
		question: "Do you plan to perform work-related tasks at home?",
		bool: null,
		values: [
			{ homeOfficeSquareFoot: "", placeholder: "Home office square footage" },
			{ homwSquareFootage: new Date(), placeholder: "Home square footage" },
		]
	},
]
const PrimaryResidence_individualNewClientShort_Styles = [
	{
		question: "Did you change your address?",
		bool: null,
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date From", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date To", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did you sell or purchase a personal residence?",
		bool: null,
		valData: [
			{ placeholder: "What was the purchase price?", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What was the date of purchase?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Do you plan to perform work-related tasks at home?",
		bool: null,
		valData: [
			{ placeholder: "Home office square footage", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Home square footage", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// <>secondary
const SecondaryResidence_individualNewClientShort = [
	{
		question: "Do you own a vacation property or second home for personal use?",
		bool: null,
		values: [
			{ address: "" },
			{ typeOfProperty: "" },
			{ Mortgage: "" },
			{ totalAnnualMortgageAmount: "" },
		]
	},
	{
		question: "Have you purchased or acquired an interest in any rental real estate since your last tax return?",
		bool: null,
		values: [
			{ address: "" },
			{ typeOfProperty: "" },
			{ purchasePrice: "" },
			{ ownership: "" },

		]
	},
]
const SecondaryResidence_individualNewClientShort_Styles = [
	{
		question: "Do you own a vacation property or second home for personal use?",
		bool: null,
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Mortgage?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total annual mortgage amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Have you purchased or acquired an interest in any rental real estate since your last tax return?",
		bool: null,
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "% Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" },

		]
	},
]
// income details
const IncomeDetails_individualNewClientShort = [
	{
		question: "Did you receive any wages, salaries and other employee compensation?",
		bool: null,
	},
	{
		question: "Did you receive any pension, IRA and annuity income?",
		bool: null,
	},
	{
		question: "What was the total social security benefits you may have received in the past year?",
		bool: null,
		values: [
			{ socialSecurityBenefits: "", placeholder: "What was the total social security benefits you may have received in the past year?" },

		]
	},
]
const IncomeDetails_individualNewClientShort_Styles = [
	{},
	{},
	{
		question: "Have you purchased or acquired an interest in any rental real estate since your last tax return?",
		bool: null,
		valData: [
			{ placeholder: "What was the total social security benefits you may have received in the past year?" },

		]
	}
]
// InterestIncomeDetailsNewClientShort
const InterestDetails_individualNewClientShort = [
	{
		question: "Did you have any interest income in the past year?",
		bool: null,
		values: [
			{ interestIncomeOwnership: "" },
			{ nameOfPayerForInterestIncome: "" },
			{ banksSavigAndLoan: "" },
			{ USbondsTbills: "" },
			{ taxExemptInterestIncome: "" },
			{ inStateInterestIncome: "" },
			{ outOfStateInterestIncome: "" },
			{ earlyWithDrawlPenalties: "" },

		]
	},
]
const InterestDetails_individualNewClientShort_Styles = [
	{
		question: "Did you have any interest income in the past year?",
		bool: null,
		valData: [
			{ placeholder: "Interest income Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Name of payer for Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Banks, savings and loan (S&L), etc.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "U.S. bonds, T-bills", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Tax-exempt Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "In-state Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Out-of-state Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Early-withdrawal penalties for Interest income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// DividendIncomeDetailsNewClientShort
const DividendIncomeDetails_individualNewClientShort = [
	{
		question: "Did you have dividend income in the past year?",
		bool: null,
		values: [
			{ dividendIncomeOwnership: "", placeholder: "Dividend income ownership" },
			{ nameOfPayerForIndividualIncome: "", placeholder: "Name of payer for dividend income" },
			{ ordinaryDividends: "", placeholder: "Ordinary dividends" },
			{ qualifiedDividends: "", placeholder: "Qualified dividends" },
			{ capitalGainDistributions: "", placeholder: "Capital gain distributions" },
			{ nonTaxableDividendIncome: "", placeholder: "Non-taxable dividend income" },
			{ federalTaxWithHeld: "", placeholder: "Federal tax withheld for dividend income" },
			{ foreignTaxWithHeld: "", placeholder: "Foreign tax withheld for dividend income" },
		]
	},
]
const DividendIncomeDetails_individualNewClientShort_Styles = [
	{
		question: "Did you have dividend income in the past year?",
		bool: null,
		valData: [
			{ placeholder: "Dividend income ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Name of payer for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Ordinary dividends", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Qualified dividends", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Capital gain distributions", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Non-taxable dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Federal tax withheld for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Foreign tax withheld for dividend income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// Foreign
const ForeignAccountDetails_individualNewClientShort = [
	{
		question: "Did you have any interest in, or signature or other authority over, a bank, securities or other financial account in a foreign country?",
		bool: null,
		values: [
			{ nameOfFinancialInstitution: "", placeholder: "Name of financial institution" },
			{ addressOfFinancialInstitution: "", placeholder: "Address of financial institution" },
			{ accountType: "", placeholder: "Account type (bank securities/ other)" },
			{ accountNumber: "", placeholder: "Account number" },
			{ maximumValueDuringTheYear: "", placeholder: "Maximum value during the year (in the foreign currency)" },
			{ howTheseAssetsHeld: "", placeholder: "How were these assets held?" },
			{ jointOwnerName: "", placeholder: "If Jointly, Joint owner’s name" },
			{ jointOwnerAddress: "", placeholder: "If Jointly, Joint owner’s address" },
			{ jointOwnersUSTaxPayerIDNumber: "", placeholder: "If Jointly, Joint owner’s US taxpayer ID number" },
		]
	},
]
const ForeignAccountDetails_individualNewClientShort_Styles = [
	{
		question: "Did you have any interest in, or signature or other authority over, a bank, securities or other financial account in a foreign country?",
		bool: null,
		valData: [
			{ placeholder: "Name of financial institution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Address of financial institution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Account type (bank securities/ other)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Account number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Maximum value during the year (in the foreign currency)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How were these assets held?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "If Jointly, Joint owner’s name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "If Jointly, Joint owner’s address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "If Jointly, Joint owner’s US taxpayer ID number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// Other income details
const OtherIncomeDetails_individualNewClientShort = [
	{
		question: "Did you receive any income or expenses from a K-1s from an entity that we did not prepare this year?",
		bool: null,
	},
	{
		question: "Income from Partnerships, Estates, LLCs, Trusts and S corporations",
		values: [{ IncomeFromPartnerships: "" }]
	},
	{
		question: "Capital Gains (or Losses)",
		values: [{ capitalGains: "" }]
	},
]
const OtherIncomeDetails_individualNewClientShort_Styles = [
	{},
	{
		question: "Income from Partnerships, Estates, LLCs, Trusts and S corporations",
		valData: [{ placeholder: "Income from Partnerships, Estates, LLCs, Trusts and S corporations", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Capital Gains (or Losses)",
		valData: [{ placeholder: "Capital Gains (or Losses)", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
// retirement plans
const RetirementPlans_individualNewClientShort = [
	{
		question: "Did you convert IRA funds or any other qualified retirement plan funds into a Roth IRA?",
		bool: null,
	},
]
// healthAndMedical
const healthAndMedical_individualNewClientShort = [
	{
		question: "Family medical insurance premiums",
		values: [{ familyMedicalInsurancePremiums: "" }]
	},
	{
		question: "Premiums for health and accident insurance including Medicare, not claimed elsewhere",
		values: [{ healthAccidentInsurancePremiums: "" }]
	},
	{
		question: "Other medical and dental expenses",
		values: [{ otherMedicalDentalExpenses: "" }]
	},
	{
		question: "What are your other unreimbursed medical expenses not already submitted above?",
		values: [{ unreimbursedMedicalExpenses: "" }]
	}
];

const healthAndMedical_individualNewClientShort_Styles = [
	{
		question: "Family medical insurance premiums",
		valData: [{ placeholder: "Family medical insurance premiums", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Other medical and dental expenses",
		valData: [{ placeholder: "Other medical and dental expenses", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Premiums for health and accident insurance including Medicare, not claimed elsewhere",
		valData: [{ placeholder: "Premiums for health and accident insurance including Medicare, not claimed elsewhere", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},

	{
		question: "What are your other unreimbursed medical expenses not already submitted above?",
		valData: [{ placeholder: "What are your other unreimbursed medical expenses not already submitted above?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }]
	}
]
// OtherDeductionsSummary
const OtherDeductionsSummary_individualNewClientShort = [
	{
		question: "What are the total unreimbursed business expenses?",
		// bool:null,
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "What is the total student loan interest deduction?",
		// bool:null,
		values: [
			{ twentyNinteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
];

const OtherDeductionsSummary_individualNewClientShort_Styles = [
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// 
const OtherAdjustmentDetail_individualNewClientShort = [
	{
		question: "Did you receive any distributions from an HSA? Were all distributions made for qualified medical expenses?",
		bool: null,
	},
]
// ItemizedDeduction
const ItemizedDeduction_individualNewClientShort = [
	{
		question: "Did you pay mortgages interest for primary residence?",
		bool: null
	},
	{
		question: "Did you make charitable contributions?",
		bool: null
	},
	{
		question: "Did you have any taxes paid?",
		bool: null,
		values: [{ realEstateTaxes: "", placeholder: "Real estate taxes for primary residence" }]
	},
	{
		question: "Did you incur expenses in performing volunteer work for charitable organizations?",
		bool: null,
		values: [
			{ volunteerWorkOtherExpenses: "", placeholder: "Volunteer work other expenses" },
			{ volunteerWorkAutomobileMileage: "", placeholder: "Volunteer work automobile mileage" },
		]
	},
	{
		question: "Did you pay an individual or an organization to perform services for the care of a dependent under 13 years old?",
		bool: null,
		values: [
			{ serviceAndAmountPaid: "", placeholder: "Please describe the service paid for as well as the total amount paid." },
		]
	},
	{
		question: "Sales tax on major items (auto, boat, home improvements, etc.)",
		values: [
			{ descriptionOfTax: "", placeholder: "Description Of Tax" },
			{ taxAmount: "", placeholder: "Tax amount" },
		]
	},
];
const ItemizedDeduction_individualNewClientShort_Styles = [
	{},
	{},
	{
		question: "Did you have any taxes paid?",
		bool: null,
		valData: [{ placeholder: "Real estate taxes for primary residence", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Did you incur expenses in performing volunteer work for charitable organizations?",
		bool: null,
		valData: [
			{ placeholder: "Volunteer work other expenses", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Volunteer work automobile mileage", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did you pay an individual or an organization to perform services for the care of a dependent under 13 years old?",
		bool: null,
		valData: [
			{ placeholder: "Please describe the service paid for as well as the total amount paid.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Sales tax on major items (auto, boat, home improvements, etc.)",
		valData: [
			{ placeholder: "Description Of Tax", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Tax amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// EducationalExpenses
const EducationalExpenses_individualNewClientShort = [
	{
		question: "Did you or any other member of your family pay attend a post secondary educational institute this year?",
		bool: null,
	},
]
// OtherCredits
const OtherCredits_individualNewClientShort = [
	{
		question: "Did you purchase an energy efficient or other new vehicle?",
		bool: null,
	},
	{
		question: "Did you make any energy-efficient improvements (remodel or new construction) to your home?",
		bool: null,
	},
	{
		question: "Did you purchase and place in service any solar water heating, solar electric, fuel cells, small wind energy or geothermal heat pump to any property you own (not just your home)?",
		bool: null,
	},
	{
		question: "Do you want any overpayment of taxes applied to next year’s estimated taxes?",
		bool: null,
	},
	{
		question: "Do you want any federal or state refund deposited directly into your bank account?",
		bool: null,
	},
	{
		question: "Do you want any balance due directly withdrawn from this same bank account on the due date?",
		bool: null,
	},
	// 6
	{
		question: "Did you incur adoption expenses or adopt a U.S. child that the state has determined to have special needs?",
		bool: null,
		values: [
			{ otherTaxes: "", placeholder: "Other Taxes, Tax Payments and Refunds" },
		]
	},
	// 7
	{
		question: "Do you want next year’s estimated taxes withdrawn from this same bank account on the due dates?",
		bool: null,
		values: [
			{ federalPriorYearOverpayment: "", placeholder: "Federal prior year overpayment applied" },
		]
	},
	// 8
	{
		question: "Did you have any state prior year overpayment applied?",
		bool: null,
		values: [
			{ overpaymentState: "" },
			{ overpaymentAmount: "" },
		]
	},
	// 9
	{
		question: "Did you make any federal estimated tax payments last year?",
		bool: null,
		values: [
			{ federalEstimatedTaxDate: new Date() },
			{ federalTaxPaymentsAmount: "" },
		]
	},
	// 10
	{
		question: "Did you make any state estimated tax payments last year?",
		bool: null,
		values: [
			{ stateEstimatedTaxPaymentsState: "" },
			{ stateEstimatedTaxPaymentsDate: new Date() },
			{ stateEstimatedTaxPaymentsAmount: "" },
		]
	},
]
const OtherCredits_individualNewClientShort_Styles = [
	{},
	{},
	{},
	{},
	{},
	{},
	// 6
	{
		question: "Did you incur adoption expenses or adopt a U.S. child that the state has determined to have special needs?",
		bool: null,
		valData: [
			{ placeholder: "Other Taxes, Tax Payments and Refunds", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// 7
	{
		question: "Do you want next year’s estimated taxes withdrawn from this same bank account on the due dates?",
		bool: null,
		valData: [
			{ placeholder: "Federal prior year overpayment applied", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// 8
	{
		question: "Did you have any state prior year overpayment applied?",
		bool: null,
		valData: [
			{ placeholder: "Overpayment State", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Overpayment Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	// 9
	{
		question: "Did you make any federal estimated tax payments last year?",
		bool: null,
		valData: [
			{ placeholder: "Federal estimated tax payments Date", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Federal estimated tax payments amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	// 10
	{
		question: "Did you make any state estimated tax payments last year?",
		bool: null,
		valData: [
			{ placeholder: "State estimated tax payments state", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "State estimated tax payments date", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "State estimated tax payments amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// AdditionalQuestions
const AdditionalQuestions_individualNewClientShort = [
	{
		question: "Do you want to designate $3 to the Presidential Election Campaign Fund?",
		bool: null
	},
	{
		question: "Does your spouse want to designate $3 to the Presidential Election Campaign Fund?",
		bool: null
	},
	{
		question: "Did you acquire, use, dispose of or hold any virtual currency/cryptocurrency (such as bitcoin)?",
		bool: null
	},
	{
		question: "Did you make gift(s) to any person that total more than $15,000 this year?",
		bool: null
	},
	{
		question: "Did you and all members of your household maintain minimum essential health coverage for all months of 2021? Minimum essential coverage includes employer-sponsored health insurance coverage, Medicare, Medicaid or Tricare.",
		bool: null
	},
	{
		question: "Did you or any of your dependents receive an identity protection personal identification number (IP PIN) from the IRS or have you been a victim of identity theft, either in 2020 or in prior years?",
		bool: null
	},
	// 6
	{
		question: "Did you receive an economic stimulus payment in the prior year?",
		bool: null,
		values: [
			{ nameOfRecipient: "", placeholder: "Name of recipient" },
			{ paymentReceivedOn: new Date(), placeholder: "Payment received on" },
			{ totalAmountOfPaymentReceived: "", placeholder: "Total amount of payment received" },
		]
	},
	// 7
	{
		question: "Did you receive any income from any legal proceedings, cancelation of student loans or other indebtedness during the year?",
		bool: null,
		values: [
			{ details: "", placeholder: "Provide details." },
		]
	},

];
// ********************************//
// Inividual New Client Long
// ********************************//
const PersonalInformationAnswers_newClientLong = [
	{
		question: "Were you married on the last day of the tax year?",
		bool: null
	},
	{
		question: "Are you blind?",
		bool: null
	},
	{
		question: "Is spouse blind?",
		bool: null
	},
	{
		question: "Are you entitled to a dependency exemption due to a divorce decree?",
		bool: null
	},
	{
		question: "Was there a change in address?",
		bool: null
	},
	{
		question: "Did any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return?",
		bool: null
	},
	{
		question: "Your first name",
		values: [{ firstName: "" }]
	},
	{
		question: "Your last name",
		values: [{ lastName: "" }]
	},
	{
		question: "What is your current filing status?",
		values: [{ currentFiliingStatus: "" }]
	},
	// 9
	{
		question: "Your date of birth",
		values: [{ dob: new Date() }]
	},
	{
		question: "Your Social Security number",
		values: [{ socialSecurityNumber: "" }]
	},
	{
		question: "Your occupation",
		values: [{ occupation: "" }]
	},
	{
		question: "Preferred phone number",
		values: [{ phneNumber: "" }]
	},
	{
		question: "Preferred email address",
		values: [{ email: "" }]
	},
	{
		question: "Your citizenship or visa status",
		values: [{ citizenshipStatus: "" }]
	},
	{
		question: "Spouse's first name",
		values: [{ spouseFirstName: "" }]
	},
	{
		question: "Spouse's last name",
		values: [{ spouseLastName: "" }]
	},
	{
		question: "Spouse's Social Security number",
		values: [{ spouseSocialSecurityNumber: "" }]
	},
	// 18
	{
		question: "Spouse's date of birth",
		values: [{ spouseDOB: new Date() }]
	},
	{
		question: "Spouse's occupation",
		values: [{ spouseOccupation: "" }]
	},
	{
		question: "Spouse's mobile phone number",
		values: [{ spouseMobileNumber: "" }]
	},
	{
		question: "Spouse's email address",
		values: [{ spouseEmailAddress: "" }]
	},
	{
		question: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.",
		values: [{ detailsAboutBithAdoptions: "" }]
	},
	{
		question: "Spouse's citizenship or visa status",
		values: [{ spouseCitizenship: "" }]
	},

]
const PersonalInformationAnswersStyles_newClientLong = [
	{},
	{},
	{},
	{},
	{},
	{},
	{
		question: "Your first name",
		valData: [{ placeholder: "Your first name", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Your last name",
		valData: [{ placeholder: "Your last name", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "What is your current filing status?",
		valData: [{ placeholder: "What is your current filing status?", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Your date of birth",
		valData: [{ placeholder: "Your date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Your Social Security number",
		valData: [{ placeholder: "Your Social Security number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Your occupation",
		valData: [{ placeholder: "Your occupation", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Preferred phone number",
		valData: [{ placeholder: "Preferred phone number", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Preferred email address",
		valData: [{ placeholder: "Preferred email address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" }]
	},
	{
		question: "Your citizenship or visa status",
		valData: [{ placeholder: "Your citizenship or visa status", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's first name",
		valData: [{ placeholder: "Spouse's first name", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's last name",
		valData: [{ placeholder: "Spouse's last name", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's Social Security number",
		valData: [{ placeholder: "Spouse's Social Security number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Spouse's date of birth",
		valData: [{ placeholder: "Spouse's date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's occupation",
		valData: [{ placeholder: "Spouse's occupation", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's mobile phone number",
		valData: [{ placeholder: "Spouse's mobile phone number", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's email address",
		valData: [{ placeholder: "Spouse's email address", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "email" }]
	},
	{
		question: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.",
		valData: [{ placeholder: "Please describe any births, adoptions, marriages, separations, divorces or deaths occur related to you, your spouse or any of your dependents since your last tax return.", styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "Spouse's citizenship or visa status",
		valData: [{ placeholder: "Spouse's citizenship or visa status", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
]
const AdditionalQuestions_individualNewClientShort_Styles = [
	{},
	{},
	{},
	{},
	{},
	{},
	// 6
	{
		question: "Did you receive an economic stimulus payment in the prior year?",
		bool: null,
		valData: [
			{ placeholder: "Name of recipient", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Payment received on", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total amount of payment received", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	// 7
	{
		question: "Did you receive any income from any legal proceedings, cancelation of student loans or other indebtedness during the year?",
		bool: null,
		valData: [
			{ placeholder: "Provide details.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// priorYearTaxReturn
const PriorYearTaxReturnAnswers_newClientLong = [
	{
		question: "Are SSNs censored on the prior year tax return?",
		bool: null,
		values: [{ placeholder: "Please include your SSN here." }]
	}
]
const PriorYearTaxReturnStyles_newClientLong = [
	{
		question: "Are SSNs censored on the prior year tax return?",
		bool: null,
		valData: [{ placeholder: "Please include your SSN here.", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	}
]
// dependets new client long
const DependentsNewClient_Long = [
	{
		question: "Do you have any dependents?",
		bool: null,
		values: [
			{ name: "" },
			{ dateOfBirth: new Date() },
			{ socialSecurityNumber: "" },
			{ Relationship: "" },
			{ dependentEarnLastYear: "" },
			{ dependentProjectingToEarn: "" },
			{ unearnedIncomeWasAllocated: "" },
			{ dependentStudentInCollege: "" },
			{ dependentLiveInYourHome: "" },
			{ totallyAndPermanentlyDisabled: "" },
			{ marriedAndFillingAJoint: "" },
			{ relevantInformationAboutDependent: "" },
			{ dependentTaxReturn: "" },
			{ priorYearTaxReturn: "" },
		]
	}
]
const DependentsNewClientStyles_Long = [
	{
		valData: [
			{ placeholder: "Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date of Birth", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Social Security Number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Relationship", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "How much did this dependent earn last year?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: `How much is this dependent projecting to earn as income in ${new Date().getFullYear()} (not from businesses you directly own)?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much unearned income was allocated to this dependent?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Is this dependent a student in college full-time?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How many months did this dependent live in your home?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Is this dependent totally and permanently disabled?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Is this dependent married and filing a joint return with their spouse?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Provide any other relevant information about the dependent", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Do you want us to prepare your dependent’s tax return?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Was this dependent on the prior year's tax return?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]
// OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort
const GeneralInformationBCCShort = [
	{
		question: "Were there any changes in ownership?",
		bool: null,
		values: [
			{ newOwnerName: "", placeholder: "New owner name" },
			{ ownershipPercentageOfNewOwner: "", placeholder: "Ownership percentage of new owner" },
		]
	},
	{
		question: "Did you have a change of address?",
		bool: null,
		values: [
			{ address: "", placeholder: "Business address" },
			{ businessCity: "", placeholder: "Business city" },
			{ businessState: "", placeholder: "Business state" },
			{ businessZipCode: "", placeholder: "Business zip code" },
		]
	},
	{
		question: "Was a new owner added?",
		bool: null,
	},
	{
		question: "Who is the representative for the entity?",
		values: [
			{ ownershipPercentageOfNewOwner: "", placeholder: "Who is the representative for the entity?" },
		]
	},
	{
		question: "Please describe the change in ownership.",
		values: [
			{ ownershipPercentageOfNewOwner: "", placeholder: "Please describe the change in ownership." },
		]
	},
]
const GeneralInformationBCCShortStyles = [
	{
		question: "Were there any changes in ownership?",
		bool: null,
		valData: [
			{ placeholder: "New owner name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Ownership percentage of new owner", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did you have a change of address?",
		bool: null,
		valData: [
			{ placeholder: "Business address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business city", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business state", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business zip code", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{},
	{
		question: "Who is the representative for the entity?",
		valData: [
			{ placeholder: "Who is the representative for the entity?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Please describe the change in ownership.",
		valData: [
			{ placeholder: "Please describe the change in ownership.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// <><><>
const BusinessFinancialsBCCShort = [
	{
		question: "Do we have access to your accounting software for your business's financials?",
		bool: null,
	},
	{
		question: "Do you have your own P&L or Balance Sheet for this business?",
		bool: null,
	},
	{
		question: "W-2 Income",
		values: [
			{ w2Income: "" },
		]
	},
]
const BusinessFinancialsBCCShortStyles = [
	{},
	{},
	{
		question: "W-2 Income",
		valData: [
			{ placeholder: "W-2 Income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// -----
const SaleOfAssetBCCShort = [
	{
		question: "Did you sell significant business assets for a gain this year?",
		bool: null,
		values: [
			{ nameOfAsset: "" },
			{ expectedSellingPrice: "" },
			{ expectedGainOnSaleOfAsset: "" },
			{ willingToSell: "" },
			{ howMuchWillingToContribute: "" },
			{ howMuchWillingToExchange: "" },
		]
	},
]
const SaleOfAssetBCCShortStyles = [
	{
		valData: [
			{ placeholder: "Name of asset", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Expected selling price of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Expected gain on sale of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "99999999" },
			{ placeholder: "If willing to sell asset as an installment sale, how many years would you be willing to hold the loan?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much of the gain on the sale would you be willing to contribute to an Opportunity Zone Investment?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If this is real estate, how much would you be willing to exchange into another real estate asset?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// !!@@
const PurchaseOfAssetBCCShort = [
	{
		question: "Did you purchase an asset in the current year (non real estate)?",
		bool: null,
		values: [
			{ assetDescription: "" },
			{ loanLeasePayments: "" },
			{ InsuranceIfApplicable: "" },
			{ otherAssetExpenses: "" },
			{ percentUsedForBusiness: "" },
		]
	},
]
const PurchaseOfAssetBCCShortStyles = [
	{
		valData: [
			{ placeholder: "Asset description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Insurance (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Other asset expenses", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "% used for business (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// 
const MiscellaneousBCCShort = [
	{
		question: "Is this the final year of filing?",
		bool: null,
	},
	{
		question: "Did you receive a PPP loan?",
		bool: null,
	},
	{
		question: "Was your PPP loan forgiven?",
		bool: null,
	},
]
// 
const PriorYearTaxReturnAnswers_BusinessNewClientShort = [
	{
		question: "Are SSN and EIN censored on the prior year tax return?",
		bool: null,
		values: [
			{ EIN: "" },
			{ SSN: "" },
		]
	}
]
const PriorYearTaxReturnStyles_BusinessNewClientShort = [
	{
		question: "Are SSNs censored on the prior year tax return?",
		bool: null,
		valData: [
			{ placeholder: "Please include the EIN of this business.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Please include your SSN.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	}
]
// BusinessFinancials
const BusinessFinancialsBNCShort = [
	{
		question: "Do we have access to your accounting software for your business's financials?",
		bool: null,
		values: [
			{ accountingSoftware: "" }
		]
	},
	{
		question: "Do you have your own P&L or Balance Sheet for this business?",
		bool: null,
	},
	{
		question: "Do you need help creating a P&L and Balance Sheet?",
		bool: null,
	},
	{
		question: "W-2 Income",
		values: [
			{ w2Income: "" },
		]
	},
]
const BusinessFinancialsBNCShortStyles = [
	{
		question: "Do we have access to your accounting software for your business's financials?",
		bool: null,
		valData: [
			{ placeholder: "What accounting software do you use?", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{},
	{},
	{
		question: "W-2 Income",
		valData: [
			{ placeholder: "W-2 income", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// >..........
const RentalEstateBNCShort = [
	{
		question: "Does this business own any rental or royalty property last year?",
		bool: null,
		values: [
			{ address: "" },
			{ typesOfPropertyy: "" },
			{ purchasePrice: "" },
			{ ownership: "" },
			{ numberOfDays: "" },
			{ daysPropertyNotOccupied: "" },
			{ ifNotOccupiedAvailable: "" },
			{ daysPropertyRented: "" },
		]
	},
	{
		question: "Do you intend to sell any rental property in the current year?",
		bool: null,
		values: [
			{ expectedSellingPrice: "" },
			{ CostBasisProperty: "" },
			{ TotalDepreciation: "" },
			{ typesOfProperty: "" },
		]
	},
	{
		question: "Do you intend to purchase or acquire interest in any rental real estate in the next 24 months?",
		bool: null,
		values: [
			{ addressOfRentalProperty: "" },
			{ ExpectedPurchasePrice: "" },
			{ mortgagePayments: "" },
			{ OwnershipProperty: "" },
			{ typeOfProperty: "" },
		]
	},
	{
		question: "Is this property eligible for the Qualified Business Income Deduction (Section 199A)?",
		bool: null,
	},
	{
		question: "Did you, or your spouse, spend more than 50% of your time performing real estate related activities?",
		bool: null,
	},
	{
		question: "Did you, or your spouse, spend more than 750 hours performing real estate related activities?",
		bool: null,
	},
	// 6
	{
		question: "Did you maintain separate books and records with respect to each property?",
		bool: null,
	},
	// 7 inputs
	{
		question: "Do you have prior suspended losses on your real estate property and if so, how much is the total prior suspended loss amount? Enter as a positive number.",
		values: [
			{ priorSuspendedLossesNumber: "" },
		]
	},
	{
		question: "Rents received",
		values: [
			{ rentsReceived: "" },
		]
	},
	{
		question: "Royalties received",
		values: [
			{ royaltiesReceived: "" },
		]
	},
	{
		question: "Mortgage interest",
		values: [
			{ mortgageInterest: "" },
		]
	},
	{
		question: "Cleaning and maintenance of property",
		values: [
			{ cleaningMaintenance: "" },
		]
	},
	{
		question: "Real estate commissions",
		values: [
			{ realEstateCommissions: "" },
		]
	},
	{
		question: "Real estate management fees",
		values: [
			{ discription: "" },
			{ datePlacedInService: new Date() },
			{ cost: "" },
		]
	},
]
const RentalEstateBNCShortStyles = [
	{
		question: "Does this business own any rental or royalty property last year?",
		bool: null,
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of Property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "% Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Number of days the property was occupied by you, a member of your family or any individual not paying rent at the fair market value.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Number of days the property was not occupied.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If not occupied, was it available for rent during this time?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How many days was the property rented during the year?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Do you intend to sell any rental property in the current year?",
		bool: null,
		valData: [
			{ placeholder: "Expected selling price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Cost basis in the property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total depreciation on the property prior to sale", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of Property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Do you intend to purchase or acquire interest in any rental real estate in the next 24 months?",
		bool: null,
		valData: [
			{ placeholder: "Address of Rental Property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Expected purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Mortgage payments annually", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "% ownership of property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Is this property eligible for the Qualified Business Income Deduction (Section 199A)?",
		bool: null,
	},
	{
		question: "Did you, or your spouse, spend more than 50% of your time performing real estate related activities?",
		bool: null,
	},
	{
		question: "Did you, or your spouse, spend more than 750 hours performing real estate related activities?",
		bool: null,
	},
	// 6
	{
		question: "Did you maintain separate books and records with respect to each property?",
		bool: null,
	},
	// 7 inputs
	{
		question: "Do you have prior suspended losses on your real estate property and if so, how much is the total prior suspended loss amount? Enter as a positive number.",
		valData: [
			{ placeholder: "Do you have prior suspended losses on your real estate property and if so, how much is the total prior suspended loss amount? Enter as a positive number.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Rents received",
		valData: [
			{ placeholder: "Rents received", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: '999999999' },
		]
	},
	{
		question: "Royalties received",
		valData: [
			{ placeholder: "Royalties received", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Mortgage interest",
		valData: [
			{ placeholder: "Mortgage interest", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Cleaning and maintenance of property",
		valData: [
			{ placeholder: "Cleaning and maintenance of property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Real estate commissions",
		valData: [
			{ placeholder: "Real estate commissions", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Real estate management fees",
		valData: [
			{ placeholder: "Discription", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date Placed in Service", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Cost", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// <<<<<<<<<<>>>>>>>
const GeneralInformationBCCLQuestions = [
	{
		question: "Were there any changes in ownership?",
		bool: null,
		values: [
			{ newOwnerName: "" },
			{ ownershipPercentageOfNewOwner: "" },
		]
	},
	{
		question: "Did you have a change of address?",
		bool: null,
		values: [
			{ address: "" },
			{ businessCity: "" },
			{ businessState: "" },
			{ businessZipCode: "" },
			{ faxNumber: "" },
			{ corporateWebsite: "" },
			{ businessRepresentativeName: "" },
			{ businessRepresentativeEmail: "" },
			{ businessRepresentativeTelephoneNumber: "" },
		]
	},
	{
		question: "Did the business engage in any new activities during the year?",
		bool: null,
		values: [
			{ newBusinessActivities: "" },
		]
	},
	{
		question: "Did the business discontinue operations this year? ",
		bool: null,
		values: [
			{ discontinueOperationsDetail: "" },
		]
	},
	// <>
	{
		question: "Did the business pay or incur any expenses, including settlements, other payouts or attorney fees, related to a sexual abuse or sexual harassment claim if the payments are subject to a nondisclosure agreement?",
		bool: null,
		values: [
			{ listAmount: "" },
		]
	},
	{
		question: "Does the business have inventory?",
		bool: null,
		values: [
			{ closingInventoryMethod: "" },
		]
	},
	{
		question: "Do you expect to sell the business in the next two years?",
		bool: null,
		values: [
			{ expectedSellingPrice: "" },
		]
	},
	{
		question: "Did the business acquire, use, dispose of or hold any virtual currency/cryptocurrency (such as bitcoin)?",
		bool: null,
		values: [
			{ virtualCurrency: "" },
		]
	},
	{
		question: "Was the business the grantor or transferor to a foreign trust during the year?",
		bool: null,
		values: [
			{ businessGrantorDetails: "" },
		]
	},
	// expand if no
	{
		question: "What is the expected selling price of the business?",
		bool: null,
		values: [
			{ unpaidAmounts: "" },
		]
	},
	// missing one
	{
		question: "Will all compensation-related accruals (including vacation pay) be paid within 2½ months of year end?",
		bool: null,
		values: [
			{compensationRelatedUnpaidAmounts:"" },
		]
	},
	// 10
	{
		question: "Was a new owner added?",
		bool: null,
	},
	{
		question: "Does this business use a fiscal year?",
		bool: null,
	},
	{
		question: "Has the business been notified of any changes to previous returns by any taxing authority?",
		bool: null,
	},
	{
		question: "Does the entity do business in more than one state?",
		bool: null,
	},
	{
		question: "Did the business change any accounting methods during the year?",
		bool: null
	},
	{
		question: "Has an application for a change in accounting method (Form 3115) been filed?",
		bool: null
	},
	{
		question: "Did the business make any payments during the year that would require you to file Forms 1099?",
		bool: null
	},
	{
		question: "If yes, did you file Forms 1099?",
		bool: null
	},
	{
		question: "Can the IRS or other tax authorities discuss questions about this return with the preparer?",
		bool: null
	},
	{
		question: "Does the business file use tax returns in any states?",
		bool: null
	},
	{
		question: "Does the business have any unpaid use tax?",
		bool: null
	},
	{
		question: "If required, do you agree to have your business return filed electronically?",
		bool: null
	},
	{
		question: "Did the business own securities that became worthless or have loans that became uncollectible during the year?",
		bool: null
	},
	{
		question: "Did the business make any sales qualifying for the installment method of reporting?",
		bool: null
	},
	{
		question: "Did the business receive any contribution in aid or construction or any other contribution from a customer or potential customer or any contribution from any governmental entity or civic group (other than contributions made by a shareholder in its capacity as a shareholder)?",
		bool: null
	},
	{
		question: "Did the business make political contributions during this tax year?",
		bool: null
	},
	// 26
	{
		question: "Did the business incur any expenses to influence legislation (lobbying)?",
		bool: null
	},
	{
		question: "Did the business have loans with owners or other related parties during the tax year?",
		bool: null
	},
	{
		question: "Was there any change in determining quantities, costs or valuations between the opening and closing inventory?",
		bool: null
	},
	{
		question: "Does the business own an interest in any other entity including but not limited to a partnership, C corporation, LLC, S corporation, trust or disregarded entity?",
		bool: null
	},
	{
		question: "Did the business pay penalties or fines?",
		bool: null
	},
	// 31
	{
		question: "Did the business make payment(s) to foreign person(s) that would require it to file an annual withholding tax return (Forms 1042 and 1042-S)?",
		bool: null
	},

	// 32
	{
		question: "What is the legal entity name?",
		values: [
			{ entityName: "" },
		]
	},
	{
		question: "What is the legal entity type?",
		values: [
			{ entityType: "" },
		]
	},
	{
		question: "What is the business's principal product or service?",
		values: [
			{ principalProductService: "" },
		]
	},
	// 35
	{
		question: "What percentage of the business does your spouse own?",
		values: [
			{ businessSpouseOwn: "", },
		]
	},
	{
		question: "What percentage of the business do you own?",
		values: [
			{ businessYouOwn: "" },
		]
	},
	{
		question: "Please describe the change in ownership.",
		values: [
			{ changeInOwnership: "" },
		]
	},
	{
		question: "Who is the representative for the entity?",
		values: [
			{ representativeForEntity: "" },
		]
	},
	{
		question: "What is the employer identification number (EIN), if any?",
		values: [
			{ EIN: "" },
		]
	},
	{
		question: "State identification number",
		values: [
			{ satteIdentificationNumber: "" },
		]
	},
	// 41
	{
		question: "When did the business start?",
		values: [
			{ businessStart: new Date() },
		]
	},
	{
		question: "Tax period beginning",
		values: [
			{ taxBegining: new Date() },
		]
	},
	// 43
	{
		question: "Tax period ending",
		values: [
			{ taxEnding: new Date() },
		]
	},
]
const GeneralInformationBCCLStyles = [
	{
		question: "Were there any changes in ownership?",
		bool: null,
		valData: [
			{ placeholder: "New owner name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Ownership percentage of new owner", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did you have a change of address?",
		bool: null,
		valData: [
			{ placeholder: "Business address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business city", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business state", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business zip code", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business fax number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Corporate website", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business representative name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business representative email", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business representative telephone number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did the business engage in any new activities during the year?",
		bool: null,
		valData: [
			{ placeholder: "describe the new business activities.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did the business discontinue operations this year? ",
		bool: null,
		valData: [
			{ placeholder: "provide details.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// <>
	{
		question: "Did the business pay or incur any expenses, including settlements, other payouts or attorney fees, related to a sexual abuse or sexual harassment claim if the payments are subject to a nondisclosure agreement?",
		bool: null,
		valData: [
			{ placeholder: "If yes, list amount(s) and indicate the reason for the penalty, fine or other expense and which accounts these expenses were posted.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Does the business have inventory?",
		bool: null,
		valData: [
			{ placeholder: "Method used to value closing inventory", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Do you expect to sell the business in the next two years?",
		bool: null,
		valData: [
			{ placeholder: "What is the expected selling price of the business?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did the business acquire, use, dispose of or hold any virtual currency/cryptocurrency (such as bitcoin)?",
		bool: null,
		valData: [
			{ placeholder: "If yes, provide details.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Was the business the grantor or transferor to a foreign trust during the year?",
		bool: null,
		valData: [
			{ placeholder: "Provide details", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	// expand if no
	{
		question: "What is the expected selling price of the business?",
		bool: null,
		valData: [
			{ placeholder: "If no, provide details of unpaid amounts.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	// missing one
	{
		question: "Will all compensation-related accruals (including vacation pay) be paid within 2½ months of year end?",
		bool: null,
		valData: [
			{ placeholder: "If no, provide details of unpaid amounts.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	// 10
	{
		question: "Was a new owner added?",
		bool: null,
	},
	{
		question: "Does this business use a fiscal year?",
		bool: null,
	},
	{
		question: "Has the business been notified of any changes to previous returns by any taxing authority?",
		bool: null,
	},
	// 6
	{
		question: "Does the entity do business in more than one state?",
		bool: null,
	},
	// 7 inputs
	{
		question: "Did the business change any accounting methods during the year?",
		bool: null
	},
	{
		question: "Has an application for a change in accounting method (Form 3115) been filed?",
		bool: null
	},
	{
		question: "Did the business make any payments during the year that would require you to file Forms 1099?",
		bool: null
	},
	{
		question: "If yes, did you file Forms 1099?",
		bool: null
	},
	{
		question: "Can the IRS or other tax authorities discuss questions about this return with the preparer?",
		bool: null
	},
	{
		question: "Does the business file use tax returns in any states?",
		bool: null
	},
	{
		question: "Does the business have any unpaid use tax?",
		bool: null
	},
	{
		question: "If required, do you agree to have your business return filed electronically?",
		bool: null
	},
	{
		question: "Did the business own securities that became worthless or have loans that became uncollectible during the year?",
		bool: null
	},
	{
		question: "Did the business make any sales qualifying for the installment method of reporting?",
		bool: null
	},
	{
		question: "Did the business receive any contribution in aid or construction or any other contribution from a customer or potential customer or any contribution from any governmental entity or civic group (other than contributions made by a shareholder in its capacity as a shareholder)?",
		bool: null
	},
	{
		question: "Did the business make political contributions during this tax year?",
		bool: null
	},
	// 26
	{
		question: "Did the business incur any expenses to influence legislation (lobbying)?",
		bool: null
	},
	{
		question: "Did the business have loans with owners or other related parties during the tax year?",
		bool: null
	},
	{
		question: "Was there any change in determining quantities, costs or valuations between the opening and closing inventory?",
		bool: null
	},
	{
		question: "Does the business own an interest in any other entity including but not limited to a partnership, C corporation, LLC, S corporation, trust or disregarded entity?",
		bool: null
	},
	{
		question: "Did the business pay penalties or fines?",
		bool: null
	},
	{
		question: "Did the business make payment(s) to foreign person(s) that would require it to file an annual withholding tax return (Forms 1042 and 1042-S)?",
		bool: null
	},

	// 32
	{
		question: "What is the legal entity name?",
		valData: [
			{ placeholder: "What is the legal entity name?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What is the legal entity type?",
		valData: [
			{ placeholder: "What is the legal entity Type?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What is the business's principal product or service?",
		valData: [
			{ placeholder: "What is the business's principal product or service?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	// 
	{
		question: "What percentage of the business does your spouse own?",
		valData: [
			{ placeholder: "What percentage of the business does your spouse own?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What percentage of the business do you own?",
		valData: [
			{ placeholder: "What percentage of the business do you own?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Please describe the change in ownership.",
		valData: [
			{ placeholder: "Please describe the change in ownership.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Who is the representative for the entity?",
		valData: [
			{ placeholder: "Who is the representative for the entity?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What is the employer identification number (EIN), if any?",
		valData: [
			{ placeholder: "What is the employer identification number (EIN), if any?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "State identification number",
		valData: [
			{ placeholder: "State identification number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "When did the business start?",
		valData: [
			{ placeholder: "When did the business start?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Tax period beginning",
		valData: [
			{ placeholder: "Tax period beginning", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// 43
	{
		question: "Tax period ending",
		valData: [
			{ placeholder: "Tax period ending", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// <<<<<<<<<<>>>>>>>
const BusinessIncomeBCCLQuestions = [
	{
		question: "Do we have access to your accounting software for your business's financials?",
		bool: null,
	},
	{
		question: "Do you have your own P&L or Balance Sheet for this business?",
		bool: null,
	},
	{
		question: "Gross receipts or sales",
		values: [
			{ grossReceipts: "", placeholder: "Gross receipts or sales" },
		]
	},
	{
		question: "Returns and allowances",
		values: [
			{ Description: "", placeholder: "Description" },
			{ amount: "", placeholder: "amount" },
		]
	},
]
const BusinessIncomeBCCLStyles = [
	{},
	{},
	{
		question: "Gross receipts or sales",
		valData: [
			{ grossReceipts: "", placeholder: "Gross receipts or sales" },
		]
	},
	{
		question: "Returns and allowances",
		valData: [
			{ Description: "", placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ amount: "", placeholder: "amount", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// ***&^%$%
const BusinessExpensesBCCLQuestions = [
	{
		question: "Did you pay any state income tax?",
		bool: null,
		values: [
			{ state: "" },
			{ Description: "" },
			{ amount: "" },
		]
	},
	{
		question: "Materials and supplies",
		values: [
			{ Descriptionn: "" },
			{ amountt: "" }
		]
	},
	// inputs
	{
		question: "Inventory at beginning of year",
		values: [
			{ inventoryAtTheBeginning: "" },
		]
	},
	{
		question: "Purchases less cost of items withdrawn for personal use",
		values: [
			{ purchasesLessCostOfItemsWithdrawn: "" },
		]
	},
	{
		question: "Cost of labor (do not include salary paid to yourself)",
		values: [
			{ costOfLabor: "" },
		]
	},
	{
		question: "Inventory at end of year",
		values: [
			{ inventoryAtTheEnd: "" },
		]
	},
	{
		question: "Advertising",
		values: [
			{ advertising: "" },
		]
	},
	{
		question: "Bad debts from sales or services",
		values: [
			{ badDebts: "" },
		]
	},
	{
		question: "Commissions and fees",
		values: [
			{ commissionsAndFees: "" },
		]
	},
	{
		question: "Depletion",
		values: [
			{ depletion: "" },
		]
	},
	{
		question: "Depreciation and Sec 179 expense deduction",
		values: [
			{ depreciationSec179: "" },
		]
	},
	{
		question: "Employee health insurance and other benefit programs (excluding retirement plans)",
		values: [
			{ employeeHealthInsurance: "" },
		]
	},
	{
		question: "Employee retirement contribution (other than owner)",
		values: [
			{ employeeRetirementContribution: "" },
		]
	},
	{
		question: "Car and truck expenses (complete the vehicle expense schedule)",
		values: [
			{ carAndTruckExpenses: "" },
		]
	},
	{
		question: "Self-employed owner: Health insurance premiums",
		values: [
			{ selfEmployedHealthInsurance: "" },
		]
	},
	{
		question: "Self-employed owner: Retirement contributions",
		values: [
			{ selfEmployedRetirementContributions: "" },
		]
	},
	{
		question: "Insurance (other than health)",
		values: [
			{ insuranceOtherThanHealth: "" },
		]
	},
	{
		question: "Mortgage interest paid to banks, etc.",
		values: [
			{ mortgageInterestPaid: "" },
		]
	}
]
const BusinessExpensesBCCLStyles = [
	{
		question: "Did you pay any state income tax?",
		bool: null,
		valData: [
			{ placeholder: "state", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "amount", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Materials and supplies",
		valData: [
			{ placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	// inputs
	{
		question: "Inventory at beginning of year",
		valData: [
			{ placeholder: "Inventory at beginning of year", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Purchases less cost of items withdrawn for personal use",
		valData: [
			{ placeholder: "Purchases less cost of items withdrawn for personal use", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Cost of labor (do not include salary paid to yourself)",
		valData: [
			{ placeholder: "Cost of labor (do not include salary paid to yourself)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Inventory at end of year",
		valData: [
			{ placeholder: "Inventory at end of year", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Advertising",
		valData: [
			{ placeholder: "Advertising", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Bad debts from sales or services",
		valData: [
			{ placeholder: "Bad debts from sales or services", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Commissions and fees",
		valData: [
			{ placeholder: "Commissions and fees", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Depletion",
		valData: [
			{ placeholder: "Depletion", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Depreciation and Sec 179 expense deduction",
		valData: [
			{ placeholder: "Depreciation and Sec 179 expense deduction", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Employee health insurance and other benefit programs (excluding retirement plans)",
		valData: [
			{ placeholder: "Employee health insurance and other benefit programs (excluding retirement plans)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Employee retirement contribution (other than owner)",
		valData: [
			{ placeholder: "Employee retirement contribution (other than owner)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Car and truck expenses (complete the vehicle expense schedule)",
		valData: [
			{ placeholder: "Car and truck expenses (complete the vehicle expense schedule)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Self-employed owner: Health insurance premiums",
		valData: [
			{ placeholder: "Self-employed owner: Health insurance premiums", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Self-employed owner: Retirement contributions",
		valData: [
			{ placeholder: "Self-employed owner: Retirement contributions" },
		]
	},
	{
		question: "Insurance (other than health)",
		valData: [
			{ placeholder: "Insurance (other than health)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Mortgage interest paid to banks, etc.",
		valData: [
			{ placeholder: "Mortgage interest paid to banks, etc.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	}
]
// 
const OtherInterestBCCLQuestions = [
	{
		question: "Legal and professional services?",
		values: [
			{ services: "", placeholder: "Legal and professional services" },
		]
	},
	{
		question: "Repairs and maintenance",
		values: [
			{ repairsAndMaintenance: "", placeholder: "Repairs and maintenance" },
		]
	},
	{
		question: "Rent or lease: Vehicles, machinery and equipment",
		values: [
			{ rentOrLeaseVehicles: "", placeholder: "Rent or lease: Vehicles, machinery and equipment" },
		]
	},
	{
		question: "Rent or lease: Real estate or other business property",
		values: [
			{ rentOrLeaseRental: "", placeholder: "Rent or lease: Real estate or other business property" },
		]
	},
]
const OtherInterestBCCLStyles = [
	{
		question: "Legal and professional services?",
		valData: [
			{ placeholder: "Legal and professional services", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Repairs and maintenance",
		valData: [
			{ placeholder: "Repairs and maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Rent or lease: Vehicles, machinery and equipment",
		valData: [
			{ placeholder: "Rent or lease: Vehicles, machinery and equipment", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},

	{
		question: "Rent or lease: Real estate or other business property",
		valData: [
			{ placeholder: "Rent or lease: Real estate or other business property", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]
// supplies
const suppliesBCCLQuestions = [
	{
		question: "Have you traveled or are you planning on traveling for business?",
		bool: null,
		values: [
			{ autoMobileMilesTraveled: "" },
			{ hotalAndLodgingCost: "" },
			{ travelMealsRestaurents: "" },
			{ travelMealsNonRestaurents: "" },
			{ otherTravelCosts: "" },
			{ travelTransportation: "" },
		]
	},
	{
		question: "Does the business have an accountable plan in place (for expenses)?",
		bool: null
	},
	// single inputs
	{
		question: "Taxes and licenses (do not include state income tax)",
		values: [
			{ taxesAndLicenses: "" },
		]
	},
	// {
	// 	question: "Other travel costs",
	// 	values: [
	// 		{ otherTravelCosts: "" },
	// 	]
	// },
	{
		question: "What are the total meal expenses incurred or planning to incur related to business meals in restaurants?",
		values: [
			{ businessMealsInRestaurants: "" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur in {{CURRENT_YEAR}} related to promotional activities that are made available to the general public, employer-provided social/recreational expenses or business gifts?",
		values: [
			{ promotionalActivitiesMeals: "" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur in {{CURRENT_YEAR}} provided on the employer’s premises for the employer’s convenience?",
		values: [
			{ mealsOnEmployerPremises: "" },
		]
	},
	{
		question: "What are the total other business meal expenses incurred or planning to incur in {{CURRENT_YEAR}}?",
		values: [
			{ otherBusinessMeals: "" },
		]
	},
	{
		question: "Entertainment",
		values: [
			{ entertainment: "" },
		]
	},
	{
		question: "Utilities",
		values: [
			{ utilities: "" },
		]
	},
	{
		question: "Wages",
		values: [
			{ wages: "" },
		]
	},
	{
		question: "Lobbying expenses",
		values: [
			{ lobbyingExpenses: "" },
		]
	},
	{
		question: "Club dues",
		values: [
			{ clubDues: "" },
		]
	},
	{
		question: "Social or entertainment club dues",
		values: [
			{ Description: "" },
			{ amount: "" },
		]
	},
]
const suppliesBCCLStyles = [
	{
		question: "Have you traveled or are you planning on traveling for business?",
		bool: null,
		valData: [
			{ placeholder: "Automobile miles traveled", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Hotel and lodging costs", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Travel meals (Restaurants only)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Travel meals (Non restaurants)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Other travel costs", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Travel transportation costs (plane tickets, tolls, etc)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Does the business have an accountable plan in place (for expenses)?",
		bool: null
	},
	// single inputs
	{
		question: "Taxes and licenses (do not include state income tax)",
		valData: [
			{ placeholder: "Taxes and licenses (do not include state income tax)", styleProp: "col-lg-7 col-md-8 col-sm-12" },
		]
	},
	// {
	// 	question: "Other travel costs",
	// 	valData: [
	// 		{ placeholder: "Other travel costs", styleProp: "col-lg-5 col-md-8 col-sm-12" },
	// 	]
	// },
	{
		question: "What are the total meal expenses incurred or planning to incur related to business meals in restaurants?",
		valData: [
			{ placeholder: "What are the total meal expenses incurred or planning to incur related to business meals in restaurants?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur in {{CURRENT_YEAR}} related to promotional activities that are made available to the general public, employer-provided social/recreational expenses or business gifts?",
		valData: [
			{ placeholder: `What are the total meal expenses incurred or planning to incur in ${new Date().getFullYear()} related to promotional activities that are made available to the general public, employer-provided social/recreational expenses or business gifts?`, styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur in {{CURRENT_YEAR}} provided on the employer’s premises for the employer’s convenience?",
		valData: [
			{ placeholder: `What are the total meal expenses incurred or planning to incur in ${new Date().getFullYear()} provided on the employer’s premises for the employer’s convenience?`, styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What are the total other business meal expenses incurred or planning to incur in {{CURRENT_YEAR}}?",
		valData: [
			{ placeholder: `What are the total other business meal expenses incurred or planning to incur in ${new Date().getFullYear()}?`, styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Entertainment",
		valData: [
			{ placeholder: "Entertainment", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Utilities",
		valData: [
			{ placeholder: "Utilities", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Wages",
		valData: [
			{ placeholder: "Wages", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Lobbying expenses",
		valData: [
			{ placeholder: "Lobbying expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Club dues",
		valData: [
			{ placeholder: "Club dues", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Social or entertainment club dues",
		valData: [
			{ placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	}
]
// BusinessVehicles
const BusinessVehiclesBCCLQuestions = [
	{
		question: "Is there a vehicle used for business purposes?",
		bool: null,
		values: [
			{ vehicleOwnedByTheBusiness: "" },
		]
	},
	{
		question: "Was the vehicle used primarily by a more than five-percent owner or related person?",
		bool: null,
		values: [
			{ vehicleDescription: "" },
			{ datePlacedInService: new Date() },
			{ totalBusinessMiles: "" },
			{ totalCommutingMiles: "" },
			{ totalOtherPersonalMiles: "" },
			{ otherVehicleAvailable: "" },
			{ evidenceToSupportDeduction: "" },
			{ evidenceWritten: "" },
			{ percentOfTimeUsedForBusiness: "" },
			{ parking: "" },
			{ tolls: "" },
			{ vehicleTaxes: "" },
			{ loanLeasePayments: "" },
			{ vehicleInsurance: "" },
			{ repairsMaintenance: "" },
			{ inspectionsRegistration: "" },
			{ otherAnnualVehicleExpenses: "" },
			{ gasOil: "" },
			{ vehicleLoanInterest: "" },
			{ tiresOtherSupplies: "" },
			{ costFairMarketValue: "" },
			{ leaseTerm: "" }
		]
	},
	{
		question: "Was the vehicle available for personal use during off-duty hours?",
		bool: null
	},
	{
		question: "Does the business maintain a written policy that prohibits all personal use of vehicles, including commuting, by employees?",
		bool: null
	},
	{
		question: "Does the business maintain a written policy that prohibits personal use of vehicles, excluding commuting, by employees?",
		bool: null
	},
	{
		question: "Does the business treat all use of vehicles by employees as personal use??",
		bool: null
	},
	{
		question: "Does the business provide more than five vehicles to employees and retain the information received from employees concerning the use of the vehicles?",
		bool: null
	},
	{
		question: "Does the business require or maintain copies of vehicle logs?",
		bool: null
	},
]
const BusinessVehiclesBCCLStyles = [
	{
		question: "Is there a vehicle used for business purposes?",
		bool: null,
		valData: [
			{ placeholder: "Is this vehicle owned by the business of an individual?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Was the vehicle used primarily by a more than five-percent owner or related person?",
		bool: null,
		valData: [
			{ placeholder: "Vehicle Description (make, model, and year).", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Date placed in service", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total business miles", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total commuting miles", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total other personal miles", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Do you have another vehicle available for personal purposes?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Do you have evidence to support your deduction?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Is the evidence written?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Percent of time vehicle used for business", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Parking", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Tolls", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Vehicle taxes", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Loan / Lease Payments", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Vehicle Insurance", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Repairs & Maintenance", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Inspections & Registration", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Other Annual Vehicle Expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Gas & Oil", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Vehicle loan interest", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Tires and other vehicle supplies", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Cost/fair market value", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Lease term, if applicable", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Was the vehicle available for personal use during off-duty hours?",
		bool: null
	},
	{
		question: "Does the business maintain a written policy that prohibits all personal use of vehicles, including commuting, by employees?",
		bool: null
	},
	{
		question: "Does the business maintain a written policy that prohibits personal use of vehicles, excluding commuting, by employees?",
		bool: null
	},
	{
		question: "Does the business treat all use of vehicles by employees as personal use??",
		bool: null
	},
	{
		question: "Does the business provide more than five vehicles to employees and retain the information received from employees concerning the use of the vehicles?",
		bool: null
	},
	{
		question: "Does the business require or maintain copies of vehicle logs?",
		bool: null
	},
]
// ShareHolderIncome
const ShareHolderIncomeBCCLQuestions = [
	{
		question: "What is the entity's expected gross revenue?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What is the entity's expected net profit or loss?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected W-2 wages (from this business)? Note: If you did not receive W-2 wages as a Schedule C entity, enter $0.?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected dividends on form 1099-DIV (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected guaranteed payments on Form K-1 (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "How much of your cash compensation (wages, distributions, dividends, etc) do you need (from this business) annually in order to maintain your lifestyle?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected W-2 wages (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected dividends on form 1099-DIV (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected guaranteed payments on Form K-1 (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What is the total expected owners compensation including taxes for all OTHER owners (not including you or your spouse)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "W-2 Income",
		values: [
			{ w2Income: "" },
		]
	}
];


const ShareHolderIncomeBCCLStyles = [
	{
		question: "What is the entity's expected gross revenue?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What is the entity's expected net profit or loss?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected W-2 wages (from this business)? Note: If you did not receive W-2 wages as a Schedule C entity, enter $0.?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected dividends on form 1099-DIV (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected guaranteed payments on Form K-1 (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "How much of your cash compensation (wages, distributions, dividends, etc) do you need (from this business) annually in order to maintain your lifestyle?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected W-2 wages (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected dividends on form 1099-DIV (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected guaranteed payments on Form K-1 (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What is the total expected owners compensation including taxes for all OTHER owners (not including you or your spouse)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "W-2 Income",
		valData: [
			{ placeholder: "w-2 Income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	}
];
// QBID
const QBIDBCCLQuestions = [
	{
		question: "Is this a business where the principal asset is the reputation or skill of one or more of its employees or owners, such as businesses providing services in health, law, performing arts, accounting, actuarial science, and consulting?",
		bool: null
	},
	{
		question: "What is the allocated share of W-2 wages for all employees from this trade or business? Include wages paid to you or your spouse from this business plus your employee wages.?",
		values: [
			{ allocatedShareW2Wages: "" }
		]
	},
	{
		question: "What is the allocated share of unadjusted basis immediately (UBIA) after acquisition of all qualified business property from this business? This is generally the purchase price of the asset before any depreciation was taken.?",
		values: [
			{ allocatedShareUBIA: "" }
		]
	},
	{
		question: "What is the patron reduction from horticultural or agricultural cooperatives, for this business?",
		values: [
			{ patronReduction: "" }
		]
	},
	{
		question: "What were the prior year carryover losses for this trade or business?",
		values: [
			{ priorYearCarryoverLosses: "" }
		]
	}
];
const QBIDBCCLQuestionsStyles = [
	{},
	{
		question: "What is the allocated share of W-2 wages for all employees from this trade or business? Include wages paid to you or your spouse from this business plus your employee wages.?",
		valData: [
			{ placeholder: "What is the allocated share of W-2 wages for all employees from this trade or business? Include wages paid to you or your spouse from this business plus your employee wages?" }
		]
	},
	{
		question: "What is the allocated share of unadjusted basis immediately (UBIA) after acquisition of all qualified business property from this business? This is generally the purchase price of the asset before any depreciation was taken?",
		valData: [
			{ placeholder: "What is the allocated share of unadjusted basis immediately (UBIA) after acquisition of all qualified business property from this business? This is generally the purchase price of the asset before any depreciation was taken?" }
		]
	},
	{
		question: "What is the patron reduction from horticultural or agricultural cooperatives, for this business?",
		valData: [
			{ placeholder: "What is the patron reduction from horticultural or agricultural cooperatives, for this business?" }
		]
	},
	{
		question: "What were the prior year carryover losses for this trade or business?",
		valData: [
			{ placeholder: "What were the prior year carryover losses for this trade or business?" }
		]
	}
];
// TaxfreeRental
const TaxfreeRentalBCCLQuestions = [
	{
		question: `Would you be willing to have meetings in your personal residence in ${new Date().getFullYear()} that are business-related?`,
		bool: null,
		values: [
			{ meetingRoomCost: "" },
			{ daysToHoldMeetings: "" },
		]
	}
];
const TaxfreeRentalBCCLStyles = [
	{
		valData: [
			{ placeholder: "How much does a meeting room cost for a day in your local area?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: `How many days in ${new Date().getFullYear()} would you be willing to hold these business-related meetings in your home?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	}
];
// Retirement
const RetirementBCCLQuestions = [
	{
		question: `Does this business currently have a retirement plan in place?`,
		bool: null,
		values: [
			{ retirementPlanType: "", placeholder: "What type of retirement plan?" },
			{ amountContributedToEmployees: "", placeholder: `What is the total amount to be contributed to the employees in ${new Date().getFullYear()}, not including yourself or your spouse (if your spouse owns a % of the business)?` },
			{ amountContributedToBusiness: "", placeholder: "What is the total amount the business will contribute to your business retirement plan?" },
			{ amountContributedToSpouse: "", placeholder: "What is the total amount the business will contribute to your spouse's business retirement plan?" },
		]
	},
	{
		question: "Do you wish to maximize the business' retirement plan contributions?",
		bool: null,
	},
	{
		question: "Do you wish to contribute 3% of each employee's salary to an employee retirement plan?",
		bool: null,
	},
];
const RetirementBCCLStyles = [
	{
		question: `Does this business currently have a retirement plan in place?`,
		bool: null,
		valData: [
			{ placeholder: "What type of retirement plan?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: `What is the total amount to be contributed to the employees in ${new Date().getFullYear()}, not including yourself or your spouse (if your spouse owns a % of the business)?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What is the total amount the business will contribute to your business retirement plan?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What is the total amount the business will contribute to your spouse's business retirement plan?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{},
	{},
];
// Employees
const EmployeesBCCLQuestions = [
	{
		question: "Did the business have any employees?",
		bool: null,
		values: [
			{ totalEmployeesDoYouHave: "" },
		]
	},
	{
		question: "Do you want to provide employee achievement awards for your staff if there are tax benefits?",
		bool: null,
		values: [
			{ maxAmountYouProvide: "" },
			{ totalEducationExpenses: "" },
		]
	},
];
const EmployeesBCCLStyles = [
	{
		question: "Did the business have any employees?",
		bool: null,
		valData: [
			{ placeholder: "How many total employees do you have, not including yourself or your spouse (if your spouse owns a % of the business)?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Do you want to provide employee achievement awards for your staff if there are tax benefits?",
		bool: null,
		valData: [
			{ placeholder: "What is the maximum amount you would provide annually for the employee achievement award program? Include total amount for all employees?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: `What are the total education expenses expected to be incurred in ${new Date().getFullYear()}, (you can deduct a maximum of $5,250 for each employee)?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
];
// Payroll
const currentYear = new Date().getFullYear();

const PayrollBCCLQuestions = [
	{
		question: "Did the business provide paid medical and family leave to employees pursuant to a written policy?",
		bool: null,
	},
	{
		question: `What are the expected total wages to be paid to your employees in ${currentYear}, not including yourself or your spouse (if your spouse owns a percentage of the business)?`,
		values: [
			{ expectedTotalWages: "" }
		]
	},
	{
		question: `Total wages paid in Q1 ${currentYear}`,
		values: [
			{ wagesPaidQ1: "" }
		]
	},
	{
		question: `Total wages paid in Q2 ${currentYear}`,
		values: [
			{ wagesPaidQ2: "" }
		]
	},
	{
		question: `Total wages expected to be paid in Q3 ${currentYear}`,
		values: [
			{ expectedWagesQ3: "" }
		]
	},
	{
		question: `Total wages expected to be paid in Q4 ${currentYear}`,
		values: [
			{ expectedWagesQ4: "" }
		]
	},
	{
		question: `What is the total payroll costs of all employees projected to make less than $10,000 in ${currentYear}?`,
		values: [
			{ totalPayrollCostsLess10K: "" }
		]
	},
	{
		question: `How many total employees are projected to make over $10,000 in ${currentYear}?`,
		values: [
			{ totalEmployeesOver10K: "" }
		]
	},
	// field with questions
	// checkBox
	// 8
	{
		question: "Did you experience a government shutdown?",
		values: [
			{ quarter_I: "" },
			// { quarter_II: "" },
			// { quarter_III: "", },
			// { quarter_IV: "" },
		]
	},
	{
		question: "2019 Gross Receipts",
		values: [
			{ quarter_I: "" },
			{ quarter_II: "" },
			{ quarter_III: "" },
			{ quarter_IV: "" },
		]
	},
	{
		question: "2020 Gross Receipts",
		values: [
			{ quarter_I: "" },
			{ quarter_II: "" },
			{ quarter_III: "" },
			{ quarter_IV: "" },
		]
	},
	{
		question: "Total Eligible Wages Per Quarter for Test 2 (Maximum of $10,000 Per Employee Per Year for ERTC)",
		values: [
			{ quarter_I: "" },
			{ quarter_II: "" },
			{ quarter_III: "" },
			{ quarter_IV: "" },
		]
	},
	{
		question: "Wages Paid While Under Government Shutdown (Wages for Section 206 Test 1 Calculation)",
		values: [
			{ quarter_I: "" },
			{ quarter_II: "" },
			{ quarter_III: "" },
			{ quarter_IV: "" },
		]
	},
	// 13
	// {
	//     question: "Did you experience a government shutdown?",
	//     values: [
	//         { quarter_I: "" },
	//         { quarter_II: "" },
	//         { quarter_III: "" },
	//         { quarter_IV: "" },
	//     ]
	// },
	{
		question: "2019 Gross Receipts or Elected Alternative Quarter's Gross Receipts",
		values: [
			{ quarter_I: "" },
			{ quarter_II: "" },
			{ quarter_III: "" },
			{ quarter_IV: "" },
		]
	},
	{
		question: "2021 Gross Receipts",
		values: [
			{ quarter_I: "" },
			{ quarter_II: "" },
			{ quarter_III: "" },
			{ quarter_IV: "" },
		]
	},
	{
		question: "Total Eligible Wages Per Quarter (Maximum of $10,000 Per Employee Per Year for Non-Severely Financially Distressed Employers)",
		values: [
			{ quarter_I: "" },
			{ quarter_II: "" },
			{ quarter_III: "" },
			{ quarter_IV: "" },
		]
	},
	{
		question: "Wages Paid While Under Government Shutdown (Wages for Section 207 Test 1 Calculation)",
		values: [
			{ quarter_I: "" },
			{ quarter_II: "" },
			{ quarter_III: "" },
			{ quarter_IV: "" },
		]
	},
];
const PayrollBCCLStyles = [
	{},
	{
		question: `What are the expected total wages to be paid to your employees in ${currentYear}, not including yourself or your spouse (if your spouse owns a percentage of the business)?`,
		valData: [
			{ placeholder: `What are the expected total wages to be paid to your employees in ${currentYear}, not including yourself or your spouse (if your spouse owns a percentage of the business)?`, styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		question: `Total wages paid in Q1 ${currentYear}`,
		valData: [
			{ placeholder: `Total wages paid in Q1 ${currentYear}`, styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: `Total wages paid in Q2 ${currentYear}`,
		valData: [
			{ placeholder: `Total wages paid in Q2 ${currentYear}`, styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: `Total wages expected to be paid in Q3 ${currentYear}`,
		valData: [
			{ placeholder: `Total wages expected to be paid in Q3 ${currentYear}`, styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		question: `Total wages expected to be paid in Q4 ${currentYear}`,
		valData: [
			{ placeholder: `Total wages expected to be paid in Q4 ${currentYear}`, styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		question: `What is the total payroll costs of all employees projected to make less than $10,000 in ${currentYear}?`,
		valData: [
			{ placeholder: `What is the total payroll costs of all employees projected to make less than $10,000 in ${currentYear}?`, styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		question: `How many total employees are projected to make over $10,000 in ${currentYear}?`,
		valData: [
			{ placeholder: `How many total employees are projected to make over $10,000 in ${currentYear}?`, styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	// field with questions
	// checkBox
	// 8
	{
		question: "Did you experience a government shutdown?",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "2019 Gross Receipts",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "2020 Gross Receipts",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Total Eligible Wages Per Quarter for Test 2 (Maximum of $10,000 Per Employee Per Year for ERTC)",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Wages Paid While Under Government Shutdown (Wages for Section 206 Test 1 Calculation)",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// 13
	{
		question: "Did you experience a government shutdown?",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "2019 Gross Receipts or Elected Alternative Quarter's Gross Receipts",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "2021 Gross Receipts",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Total Eligible Wages Per Quarter (Maximum of $10,000 Per Employee Per Year for Non-Severely Financially Distressed Employers)",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Wages Paid While Under Government Shutdown (Wages for Section 207 Test 1 Calculation)",
		valData: [
			{ placeholder: "Quarter 1", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 2", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 3", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Quarter 4", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
];
// 
const Covid19BCCLQuestions = [
	{
		question: `Do you have any employees located in a disaster zone in ${new Date().getFullYear()}?`,
		bool: null,
		values: [
			{ disasterRelatedExpenses: "" },
		]
	},
	{
		question: "Were there any employees that were on family and/or medical leave due to COVID-19?",
		bool: null,
		values: [
			{ employeesMissedWork: "" },
			{ sickAndQuarantinedEmployees: "" },
			{ employeesMissedWorkForCaringSomeone: "" },
			{ daysToCaringSomeOne: "" },
			{ totalEmployerPortion: "" },
			{ totalWagesPaidOut: "" },
		]
	},
	{
		question: "Did you receive EIDL funding?",
		bool: null,
		values: [
			{ EIDLAdvanceAmount: "" },
			{ totalEIDLAmount: "" },
			{ loanOriginationDate: new Date() },
		]
	},
	{
		question: "Did you receive PPP funding?",
		bool: null,
		values: [
			{ PPPLoanAmount: "" },
			{ PPPLoanOriginationDate: new Date() },
			{ loanAmountSpentOnPayrollCosts: "" },
			{ loanFundsNotYetSpent: "" },
			{ loanAmountSpentOnPayrollEligible: "" },
		]
	},
	{
		question: "Did you receive PPP forgiveness?",
		bool: null,
		values: [
			{ totalForgivenessAmountGranted: "" },
		]
	},
	{
		question: "Did the business receive any other funds/loans/grants (local, state, federal or other) related to the COVID-19 pandemic (besides PPP or EIDL)?",
		bool: null,
	},
	{
		question: "Did the business claim the employee retention credit and/or credits for qualified leave wages paid to employees due to paid sick leave or expanded family and medical leave for reasons related to COVID-19?",
		bool: null,
	},
]
// .st
const Covid19BCCLStyles = [
	{
		question: `Do you have any employees located in a disaster zone in ${new Date().getFullYear()}?`,
		bool: null,
		valData: [
			{ placeholder: "What are the total disaster-related expenses incurred or plan to incur this year for affected employees?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Were there any employees that were on family and/or medical leave due to COVID-19?",
		bool: null,
		valData: [
			{ placeholder: "How many employees missed work due to being sick and/or under quarantine due to COVID-19?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How many days total did these sick and quarantined employees miss (maximum 10 days per employee)?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How many employees missed work due to caring for someone who was sick and under quarantine due to COVID-19?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How many days total did these employees who were caring for someone sick due to COVID-19 miss (maximum 10 days per employee)?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "What was the total employer portion of the health care premiums incurred while employees were covered under the Emergency Paid Sick Leave or Emergency Family & Medical Leave?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "What were the total wages paid out due to employees being on FMLA and Sick Leave?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did you receive EIDL funding?",
		bool: null,
		valData: [
			{ placeholder: "Total EIDL Advance Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Total EIDL Amount (Less Advance)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Loan Origination Date", styleProp: "col-lg-6 col-md-8 col-sm-12 py-3" },
		]
	},
	// <<<i3||index1
	{
		question: "Did you receive PPP funding?",
		bool: null,
		valData: [
			{ placeholder: "PPP loan amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "PPP Loan origination date", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "PPP Loan amount spent on payroll costs", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Remaining PPP loan funds not yet spent", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "PPP Loan amount spent on non payroll eligible costs", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you receive PPP forgiveness?",
		bool: null,
		valData: [
			{ placeholder: "Total forgiveness amount granted", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{},
	{},
]
// FringeBenefits
const FringeBenefitsBCCLQuestions = [
	{
		question: "Qualified Retirement Plan",
		values: [
			{ qualifiedRetirementPlan: "" }
		]
	},
	{
		question: "Simplified Employee Pension (SEP)",
		values: [
			{ simplifiedEmployeePension: "" }
		]
	},
	{
		question: "Savings Incentive Match Plan for Employees (SIMPLE)",
		values: [
			{ savingsIncentiveMatchPlan: "" }
		]
	},
	{
		question: "Cafeteria plan",
		values: [
			{ cafeteriaPlan: "" }
		]
	},
	{
		question: "Non-qualified deferred compensation plan(s) or agreement(s)",
		values: [
			{ nonQualifiedDeferredCompensationPlan: "" }
		]
	},
	// <<<<<<<<
	{
		question: "Disability insurance",
		values: [
			{ disabilityInsuranceAmount: "" }
		]
	},
	{
		question: "Group term life insurance",
		values: [
			{ groupTermLifeInsurance: "" }
		]
	},
	{
		question: "Qualified transportation costs",
		values: [
			{ qualifiedTransportationCosts: "" }
		]
	},
	{
		question: "Qualified dependent care",
		values: [
			{ qualifiedDependentCare: "" }
		]
	},
	{
		question: "Working conditions benefits",
		values: [
			{ workingConditionsBenefits: "" }
		]
	},
	{
		question: "De minimus benefits",
		values: [
			{ deMinimusBenefits: "" }
		]
	},
	{
		question: "Qualified employee discount programs",
		values: [
			{ qualifiedEmployeeDiscountPrograms: "" }
		]
	},
	{
		question: "Other fringe benefits costs",
		values: [
			{ otherFringeBenefitsCostsAmount: "" }
		]
	},
	{
		question: "What are the total annual out-of-pocket business expenses not previously listed (such as copying, mailing, office supplies, etc)?",
		values: [
			{ totalAnnualOutOfPocketExpenses: "" }
		]
	}
];
// ...
const FringeBenefitsBCCLStyles = [
	{
		question: "Qualified Retirement Plan",
		valData: [
			{ placeholder: "Qualified Retirement Plan", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Simplified Employee Pension (SEP)",
		valData: [
			{ placeholder: "Simplified Employee Pension (SEP)", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Savings Incentive Match Plan for Employees (SIMPLE)",
		valData: [
			{ placeholder: "Savings Incentive Match Plan for Employees (SIMPLE)", styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Cafeteria plan",
		valData: [
			{ placeholder: "Cafeteria plan", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Non-qualified deferred compensation plan(s) or agreement(s)",
		valData: [
			{ placeholder: "Non-qualified deferred compensation plan(s) or agreement(s)", styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	// <<<<<<<<
	{
		question: "Disability insurance",
		valData: [
			{ placeholder: "Disability insurance amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Group term life insurance",
		valData: [
			{ placeholder: "Group term life insurance amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Qualified transportation costs",
		valData: [
			{ placeholder: "Qualified transportation costs amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Qualified dependent care",
		valData: [
			{ placeholder: "Qualified dependent care amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Working conditions benefits",
		valData: [
			{ placeholder: "Working conditions benefits amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "De minimus benefits",
		valData: [
			{ placeholder: "De minimus benefits amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Qualified employee discount programs",
		valData: [
			{ placeholder: "Qualified employee discount programs amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Other fringe benefits costs",
		valData: [
			{ placeholder: "Other fringe benefits costs amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are the total annual out-of-pocket business expenses not previously listed (such as copying, mailing, office supplies, etc)?",
		valData: [
			{ placeholder: "What are the total annual out-of-pocket business expenses not previously listed (such as copying, mailing, office supplies, etc)?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	}
];
// Insurance
const InsuranceBCCLQuestions = [
	{
		question: "Does the business pay a portion of the health insurance premium for your employees?",
		bool: null,
		values: [
			{ employeesHealthInsurance: "" }
		]
	},
	{
		question: "Do you pay at least half of the employees’ health insurance premiums?",
		bool: null,
		values: [
			{ descriptionOfRiskItem: "" },
			{ potentialLiability: "" },
		]
	},
	{
		question: "Do you have a health reimbursement arrangement or otherwise reimburse your employees for medical expenses or health insurance premiums?",
		bool: null,
	},
	{
		question: "Do you pay an average wage of less than $50,000?",
		bool: null,
	},
	{
		question: "What is the average wage of all full time equivalent employees (combined) including yourself and your spouse?",
		values: [
			{ avarageWage: "" }
		]
	},
	{
		question: "What percentage of gross revenue would you like to fund towards your reinsurance company?",
		values: [
			{ percentageOfGrossrevenue: "" }
		]
	},
	{
		question: "What is the potential liability amount to be covered by captive insurance? Enter as a positive number?",
		values: [
			{ potentialLiabilityAmount: "" }
		]
	}
]
// .st
const InsuranceBCCLStyles = [
	{
		question: "Does the business pay a portion of the health insurance premium for your employees?",
		bool: null,
		valData: [
			{ placeholder: "How much does the business pay for employee health insurance annually?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Do you pay at least half of the employees’ health insurance premiums?",
		bool: null,
		valData: [
			{ placeholder: "Description Of Risk Item", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Potential Liability", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Do you have a health reimbursement arrangement or otherwise reimburse your employees for medical expenses or health insurance premiums?",
		bool: null,
	},
	{
		question: "Do you pay an average wage of less than $50,000?",
		bool: null,
	},
	{
		question: "What is the average wage of all full time equivalent employees (combined) including yourself and your spouse?",
		valData: [
			{ placeholder: "What is the average wage of all full time equivalent employees (combined) including yourself and your spouse?", styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		question: "What percentage of gross revenue would you like to fund towards your reinsurance company?",
		valData: [
			{ placeholder: "What percentage of gross revenue would you like to fund towards your reinsurance company?", styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		question: "What is the potential liability amount to be covered by captive insurance? Enter as a positive number?",
		valData: [
			{ placeholder: "What is the potential liability amount to be covered by captive insurance? Enter as a positive number?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	}
]
// saleOfAssets
const SalesOfAssetsBCCLQuestions = [
	{
		question: "Did you sell significant business assets for a gain this year?",
		bool: null,
		values: [
			{ nameOfAsset: "" },
			{ expectedSellingPrice: "" },
			{ expectedGainsOnSale: "" },
			{ willingToSell: "" },
			{ howMuchWillingToContribute: "" },
			{ howMuchWillingToExchange: "" },
		]
	},
]
const SalesOfAssetsBCCLStyles = [
	{
		valData: [
			{ placeholder: "Name of asset", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Expected selling price of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Expected gain on sale of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If willing to sell asset as an installment sale, how many years would you be willing to hold the loan?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much of the gain on the sale would you be willing to contribute to an Opportunity Zone Investment?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If this is real estate, how much would you be willing to exchange into another real estate asset?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// corporate
const CorporateBCCLQuestions = [
	{
		question: "At year end, did the corporation own, directly or indirectly, 50% or more of the voting stock of a domestic corporation?",
		bool: null,
		values: [
			{ corporationName: "" },
			{ percentageOwned: "" }
		]
	},
	// 1
	{
		question: "At year end, did any corporation, individual, partnership, trust or estate own, directly or indirectly, 50% or more of the corporation’s voting stock?",
		bool: null,
		values: [
			{ name: "" },
			{ address: "" },
			{ identificationNumber: "" },
			{ ownershipPercentage: "" },
			{ USCitizen: "" },
		]
	},
	{
		question: "Is this corporation a shareholder of any foreign corporation?",
		bool: null,
		values: [
			{ corporation: "" },
		]
	},
	{
		question: "Is this corporation a partner in any foreign partnership?",
		bool: null,
		values: [
			{ partnership: "" },
		]
	},
	{
		question: "Did this corporation own a disregarded entity for tax purposes at any time during the year?",
		bool: null,
		values: [
			{ details: "" },
		]
	},
	// changed the position----5
	{
		question: "Does an individual own (directly, indirectly or constructively) at least 80% of the voting stock of the corporation and does the corporation have at least 50% of its assets produce or held for the production of passive income?",
		bool: null,
	},
	// i6 - index2
	{
		question: "If yes, does the corporation have an interest in specified foreign financial assets valued at more than $50,000 on the last day of the tax year, or more than $75,000 at any time during the year for assets not previously listed for FinCEN 114 reporting?",
		bool: null,
		values: [
			{ DescriptionOfAsset: "" },
			{ identificationNumber: "" },
			{ dateAcquired: new Date() },
			{ maxValueDuringYear: "" },
			{ rateUsed: "" },
			{ assetStock: "" },
			{ assetNotStock: "" },
		]
	},
	// i7
	{
		question: "Did one foreign person, at any time during the tax year, own directly or indirectly, 25% or more of the total voting power or value of all classes of stock of the corporation?",
		bool: null,
		values: [
			{ name: "" },
			{ percentageOwned: "" },
			{ dateAcquired: "" },
		]
	},
	// bools 7
	{
		question: "Does the corporation compensate employees or directors using restricted property, including options to purchase stock or restricted stock?",
		bool: null,
	},
	{
		question: "Does the corporation pay life insurance premiums (other than group-term life) for officers of the corporation?",
		bool: null,
	},
	{
		question: "Did the corporation purchase life insurance on any employee after Aug. 17, 2006?",
		bool: null,
	},
	{
		question: "If yes, have employees been notified?",
		bool: null,
	},
	{
		question: "Did the corporation include taxable fringe or welfare benefits, such as health insurance, group-term life insurance, educational assistance, non-accountable expense allowances and personal use of corporate vehicles in compensation on employees’ Forms W-2 and, if applicable, subject such amounts to payroll taxes?",
		bool: null,
	},
	{
		question: "Do the shareholders owning 80% or more of this corporation own 80% or more of any other corporation?",
		bool: null,
	},
	// from this
	{
		question: "During this taxable year did the corporation pay dividends?",
		bool: null,
	},
	// inputs 15
	{
		question: "Corporate (C or S Corp)",
		values: [
			{ name: "" },
			{ title: "" },
			{ SocialSecurityNumber: "" },
			{ percentageOfTimeDevoted: "" },
			{ percentageCommonStockOwned: "" },
			{ percentagePrefferedStockOwned: "" },
			{ Compensation: "" },
		]
	},
]
// .st
const CorporateBCCLStyles = [
	{
		question: "At year end, did the corporation own, directly or indirectly, 50% or more of the voting stock of a domestic corporation?",
		bool: null,
		valData: [
			{ placeholder: "Corporation name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Percentage owned", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	// 1
	{
		question: "At year end, did any corporation, individual, partnership, trust or estate own, directly or indirectly, 50% or more of the corporation’s voting stock?",
		bool: null,
		valData: [
			{ placeholder: "Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Identification number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Ownership percentage", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "US Citizen", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Is this corporation a shareholder of any foreign corporation?",
		bool: null,
		valData: [
			{ placeholder: "If yes, identify each corporation.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Is this corporation a partner in any foreign partnership?",
		bool: null,
		valData: [
			{ placeholder: " If yes, identify each partnership.", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did this corporation own a disregarded entity for tax purposes at any time during the year?",
		bool: null,
		valData: [
			{ placeholder: "If yes, provide details", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
		// changed
	{
			question: "Does an individual own (directly, indirectly or constructively) at least 80% of the voting stock of the corporation and does the corporation have at least 50% of its assets produce or held for the production of passive income?",
			bool: null,
	},
	{
		question: "If yes, does the corporation have an interest in specified foreign financial assets valued at more than $50,000 on the last day of the tax year, or more than $75,000 at any time during the year for assets not previously listed for FinCEN 114 reporting?",
		bool: null,
		valData: [
			{ placeholder: "Description of asset", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Identifying number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date acquired or disposed of during the year", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Maximum value during the year (in the foreign currency)", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Currency and exchange rate used", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "If asset is a stock of a foreign entity provide name, type, and mailing address", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "If asset is NOT a stock of a foreign entity provide name of issuer, type, and mailing address", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did one foreign person, at any time during the tax year, own directly or indirectly, 25% or more of the total voting power or value of all classes of stock of the corporation?",
		bool: null,
		valData: [
			{ placeholder: "Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Percentage owned", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Owner's country", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// bools
	{
		question: "Does the corporation compensate employees or directors using restricted property, including options to purchase stock or restricted stock?",
		bool: null,
	},
	{
		question: "Does the corporation pay life insurance premiums (other than group-term life) for officers of the corporation?",
		bool: null,
	},
	{
		question: "Did the corporation purchase life insurance on any employee after Aug. 17, 2006?",
		bool: null,
	},
	{
		question: "If yes, have employees been notified?",
		bool: null,
	},
	{
		question: "Did the corporation include taxable fringe or welfare benefits, such as health insurance, group-term life insurance, educational assistance, non-accountable expense allowances and personal use of corporate vehicles in compensation on employees’ Forms W-2 and, if applicable, subject such amounts to payroll taxes?",
		bool: null,
	},
	{
		question: "Do the shareholders owning 80% or more of this corporation own 80% or more of any other corporation?",
		bool: null,
	},
	{
		question: "During this taxable year did the corporation pay dividends?",
		bool: null,
	},
	// inputs
	{
		question: "Corporate (C or S Corp)",
		valData: [
			{ placeholder: "Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Title", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Social Security Number", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Percentage of time devoted to business", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Percentage common stock owned", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Percentage preferred stock owned", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Compensation", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// SCORP
const SCORPBCCLQuestions = [
	{
		question: "Have fringe benefits paid on behalf of more than two-percent shareholders (including, but not limited to medical, life insurance, disability, housing, etc.) been included in the shareholder’s compensation and subjected to payroll taxes, if applicable?",
		bool: null,
		values: [
			{ indicateAccounts: "" },
		]
	},
]
const SCORPBCCLStyles = [
	{
		valData: [
			{ placeholder: "Indicate to which accounts these amounts have been posted. These rules also apply to relatives of more than two-percent shareholders.", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]
// Partnership
const PartnershipBCCLQuestions = [
	{
		question: "Does an individual own (directly, indirectly or constructively) at least 80% of the capital or profit interest in the partnership and does the partnership have at least 50% of its gross income from passive income?",
		bool: null,
		values: [
			{ descriptionOfAsset: "" },
			{ identificationNumber: "" },
			{ dateAcquired: new Date() },
			{ currencyExchangeRate: "" },
			{ maxValueDuringYear: "" },
			{ assetStockOfForign: "" },
			{ assetNotStockOfForign: "" },
		]
	},
	{
		question: "Did the partnership or LLC acquire any “qualified small business stock?”",
		bool: null,
		values: [
			{ smallBusinessStockDetails: "" },
		]
	},
	{
		question: "Did the partnership or LLC invest any gain proceeds in a qualified opportunity fund?",
		bool: null,
		values: [
			{ investAnyGain: "" },
		]
	},
	// 3
	{
		question: "Was there a distribution of property or a transfer (for example, by sale or death) of a partnership or LLC interest during this tax year?",
		bool: null,
	},
	{
		question: "Has the partnership or LLC ever elected to “step up” the basis of any assets in connection with the death of a partner/member or a change in ownership (Sec. 754 election)?",
		bool: null,
	},
	{
		question: "Were there any payments to partners or members during the year for services or for the use of capital determined without regard to income?",
		bool: null,
	},
	{
		question: "Did any partner or member contribute any assets to the partnership or LLC during the year?",
		bool: null,
	},
	// inputs questionnaire_I...7
	{
		question: "questionnaire_I",
		values: [
			{ name: "" },
			{ taxpayerIdentification: "" },
			{ contactInformation: "" },
		]
	},
	{
		question: "questionnaire_II",
		values: [
			{ transferredFrom: new Date() },
			{ transferredTo: new Date() },
			{ dateOftransfer: new Date() },
			{ typeOfTransfer: "" },
			{ FMVOfPartnership: "" },
		]
	},
]
const PartnershipBCCLStyles = [
	{
		question: "Does an individual own (directly, indirectly or constructively) at least 80% of the capital or profit interest in the partnership and does the partnership have at least 50% of its gross income from passive income?",
		bool: null,
		valData: [
			{ placeholder: "Description of asset", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Identifying number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Date acquired or disposed of during the year", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Currency and exchange rate used", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Maximum value during the year (in the foreign currency)", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If asset is a stock of a foreign entity provide name, type, and mailing address", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "If asset is NOT a stock of a foreign entity provide name of issuer, type, and mailing address", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did the partnership or LLC acquire any “qualified small business stock?”",
		bool: null,
		valData: [
			{ placeholder: " If yes, provide details", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Did the partnership or LLC invest any gain proceeds in a qualified opportunity fund?",
		bool: null,
		valData: [
			{ placeholder: " If yes, provide details", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Was there a distribution of property or a transfer (for example, by sale or death) of a partnership or LLC interest during this tax year?",
		bool: null,
	},
	{
		question: "Has the partnership or LLC ever elected to “step up” the basis of any assets in connection with the death of a partner/member or a change in ownership (Sec. 754 election)?",
		bool: null,
	},
	{
		question: "Were there any payments to partners or members during the year for services or for the use of capital determined without regard to income?",
		bool: null,
	},
	{
		question: "Did any partner or member contribute any assets to the partnership or LLC during the year?",
		bool: null,
	},
	// inputs questionnaire_I
	{
		question: "questionnaire_I",
		valData: [
			{ placeholder: " Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Taxpayer Identification", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Contact information", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "questionnaire_I",
		valData: [
			{ placeholder: " Transferred from", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Transferred to", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date of transfer", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of transfer", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Sale price or fair market value (FMV) of partnership interest transferred", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]
// sole
const SoleProprietorshipQuestions = [
	{
		question: "Were any assets sold, retired or converted to personal use during the year?",
		bool: null,
		values: [
			{ descriptionOfAsset: "" },
			{ dateSold: new Date() },
			{ dateAcquired: new Date() },
			{ salesPrice: "" },
			{ originalCost: "" },
		]
	},
	{
		question: "Did you conduct business outside of your home state?",
		bool: null,
		values: [
			{ state: "" },
			{ businessIncomeInThatState: "" },
			{ businessExpensesInThatState: "" },
		]
	},
	{
		question: "Did you materially participate in the operation of the business during the year?",
		bool: null,
	},
	{
		question: "Was all your investment in this activity at risk?",
		bool: null,
	},
]
// .st
const SoleProprietorshipStyles = [
	{
		valData: [
			{ placeholder: "Description of asset", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date Sold", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date acquired", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Sales price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "99999999" },
			{ placeholder: "Original cost", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "99999999" },
		]
	},
	{
		valData: [
			{ placeholder: "State", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Business Income in that state", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Business expenses in that state", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Did you materially participate in the operation of the business during the year?",
		bool: null,
	},
	{
		question: "Was all your investment in this activity at risk?",
		bool: null,
	},
]
// future
const FuturePartnersAndShareholdersBCCLQuestions = [
	{
		question: "If you are, or were to convert to a S Corporation, how many shareholders are in the S Corporation?",
		bool: null,
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "If you are, or were to convert to a Partnership, how many partners are in the Partnership?",
		bool: null,
		values: [
			{ twentyNineteen: "" },
			{ twentyTwenty: "" },
			{ twentyTwentyOne: "" },
		]
	},
	{
		question: "If you are, or were to convert to a Partnership, are you a general or a limited partner? A general partner is assumed.",
		values: [
			{ generalPartner: "" },
		]
	},
]
// .st
const FuturePartnersAndShareholdersBCCLStyles = [
	{
		question: "If you are, or were to convert to a S Corporation, how many shareholders are in the S Corporation?",
		bool: null,
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "If you are, or were to convert to a Partnership, how many partners are in the Partnership?",
		bool: null,
		valData: [
			{ placeholder: "2019", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2020", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2021", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "If you are, or were to convert to a Partnership, are you a general or a limited partner? A general partner is assumed.",
		valData: [
			{ placeholder: "General Partner", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// Rental Questions
const RentalRealEstateAndRoyaltyIncomeBCCLQuestions = [
	{
		question: "Does this business own any rental or royalty property last year?",
		bool: null,
		values: [
			{ address: "", placeholder: "Address" },
			{ typeOfProperty: "", placeholder: "Type of Property" },
			{ purchasePrice: "", placeholder: "Purchase Price" },
			{ ownership: "", placeholder: "% Ownership" },
			{ DaysPropertOccupiedByYou: "", placeholder: "Number of days the property was occupied by you, a member of your family or any individual not paying rent at the fair market value." },
			{ DaysPropertNotOccupied: "", placeholder: "Number of days the property was not occupied." },
			{ WasAvailableForRent: "", placeholder: "If not occupied, was it available for rent during this time?" },
			{ rentedDuringTheYear: "", placeholder: "How many days was the property rented during the year?" },
		]
	},
	{
		question: "Do you have prior suspended losses on your real estate property.",
		bool: null,
		values: [
			{ priorSuspendedLossesNumber: "", placeholder: "if so, how much is the total prior suspended loss amount? Enter as a positive number." },
		]
	},
	{
		question: "Do you intend to sell any rental property in the current year?",
		bool: null,
		values: [
			{ expectedSellingPrice: "", placeholder: "Expected selling price" },
			{ CostBasisProperty: "", placeholder: "Cost basis in the property" },
			{ TotalDepreciation: "", placeholder: "Total depreciation on the property prior to sale" },
			{ typeOfProperty: "", placeholder: "Type of Property" },
		]
	},
	{
		question: "Do you intend to purchase or acquire interest in any rental real estate in the next 24 months?",
		bool: null,
		values: [
			{ addressOfRentalProperty: "", placeholder: "Address of Rental Property" },
			{ expectedPurchasePrice: "", placeholder: "Expected purchase price" },
			{ mortgagePaymentsAnually: "", placeholder: "Mortgage payments annually" },
			{ OwnershipOfProperty: "", placeholder: "% ownership of property" },
			{ typeOfProperty: "", placeholder: "Type of Property" },
		]
	},
	// simple bools 4
	{
		question: "Is this property eligible for the Qualified Business Income Deduction (Section 199A)?",
		bool: null,
	},
	{
		question: "Did you, or your spouse, spend more than 50% of your time performing real estate related activities?",
		bool: null,
	},
	{
		question: "Did you, or your spouse, spend more than 750 hours performing real estate related activities?",
		bool: null,
	},
	{
		question: "Did you maintain separate books and records with respect to each property?",
		bool: null,
	},
	// inputs 8
	{
		question: "Rents received",
		values: [
			{ rentsReceived: "", placeholder: "Rents received" },
		]
	},
	{
		question: "Royalties received",
		values: [
			{ royaltiesReceived: "", placeholder: "Royalties received" },
		]
	},
	{
		question: "Mortgage interest",
		values: [
			{ mortgageInterest: "", placeholder: "Mortgage interest" },
		]
	},
	{
		question: "Cleaning and maintenance of property",
		values: [
			{ cleaningMaintenance: "", placeholder: "Cleaning and maintenance of property" },
		]
	},
	{
		question: "Real estate commissions",
		values: [
			{ realEstateCommissions: "", placeholder: "Real estate commissions" },
		]
	},
	// 13
	{
		question: "Real estate management fees",
		values: [
			{ description: "", placeholder: "Description" },
			{ datePlacedInService: new Date(), placeholder: "Date placed in service" },
			{ cost: "", placeholder: "cost" },
		]
	},
]
// .st
const RentalRealEstateAndRoyaltyIncomeBCCLStyles = [
	{
		question: "Does this business own any rental or royalty property last year?",
		bool: null,
		valData: [
			{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Type of Property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "% Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Number of days the property was occupied by you, a member of your family or any individual not paying rent at the fair market value.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Number of days the property was not occupied.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If not occupied, was it available for rent during this time?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How many days was the property rented during the year?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Do you have prior suspended losses on your real estate property.",
		bool: null,
		valData: [
			{ placeholder: "if so, how much is the total prior suspended loss amount? Enter as a positive number.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Do you intend to sell any rental property in the current year?",
		bool: null,
		valData: [
			{ placeholder: "Expected selling price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Cost basis in the property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Total depreciation on the property prior to sale", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Type of Property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Do you intend to purchase or acquire interest in any rental real estate in the next 24 months?",
		bool: null,
		valData: [
			{ placeholder: "Address of Rental Property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Expected purchase price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Mortgage payments annually", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "% ownership of property", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Type of Property", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// simple bools
	{
		question: "Is this property eligible for the Qualified Business Income Deduction (Section 199A)?",
		bool: null,
	},
	{
		question: "Did you, or your spouse, spend more than 50% of your time performing real estate related activities?",
		bool: null,
	},
	{
		question: "Did you, or your spouse, spend more than 750 hours performing real estate related activities?",
		bool: null,
	},
	{
		question: "Did you maintain separate books and records with respect to each property?",
		bool: null,
	},
	// inputs
	{
		question: "Rents received",
		valData: [
			{ placeholder: "Rents received", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Royalties received",
		valData: [
			{ placeholder: "Royalties received", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Mortgage interest",
		valData: [
			{ placeholder: "Mortgage interest", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Cleaning and maintenance of property",
		valData: [
			{ placeholder: "Cleaning and maintenance of property", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Real estate commissions",
		valData: [
			{ placeholder: "Real estate commissions", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Real estate management fees",
		valData: [
			{ placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date placed in service", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "cost", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// Farm
const FarmBCCLQuestions = [
	{
		question: "Does the taxpayer's farm currently have a conservation easement in place?",
		bool: null,
	},
	{
		question: "Farm location",
		values: [
			{ farmLocation: "" },
		]
	},
	{
		question: "What is the total value of your non productive land owned by this business?",
		values: [
			{ valueOfLand: "" },
		]
	},
]
const FarmBCCLStyles = [
	{},
	{
		question: "Farm location",
		valData: [
			{ placeholder: "Farm location", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What is the total value of your non productive land owned by this business?",
		valData: [
			{ placeholder: "What is the total value of your non productive land owned by this business?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// FarmRental
const FarmRentalBCCLQuestions = [
	{
		question: "Does the farm rental currently have a conservation easement in place?",
		bool: null,
	},
	{
		question: "Farm location",
		values: [
			{ farmRentalLocation: "" },
		]
	}
]
const FarmRentalBCCLStyles = [
	{},
	{
		valData: [
			{ placeholder: "Location of the farm rental", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	}
]
// Depriciation
const DepriciationBCCLQuestions = [
	{
		question: "Did the business participate in a cost segregation study this year?",
		bool: null,
		values: [
			{ expectedDepriciation: "" },
		]
	},
	{
		question: "Has the taxpayer purchased or is planning to purchase tangible, non-real estate assets?",
		bool: null,
		values: [
			{ purchasePrice: "" },
			{ assetType: "" },
			{ depreciableYears: "" },
			{ maximumAllowableDepriciation: "" },
		]
	},
	{
		question: "Do you have any qualified improvement property?",
		bool: null,
	},
	// inputs
	{
		question: "What is the approximate value of all real property owned or expected to purchase since the last tax return?",
		values: [
			{ maximumValue: "" },
		]
	},
	{
		question: "What is the expected depreciation (without a cost segregation study)?",
		values: [
			{ expectedDepriciation: "" },
		]
	},
	{
		question: `What was the qualified investment property purchase amount in prior year 1?`,
		values: [
			{ qualifiedInvestmentProperty: "" },
		]
	},
	{
		question: `What depreciation was taken on the qualified investment property in prior year 1?`,
		values: [
			{ depriciationONQualifiedInvestment: "" },
		]
	},
	{
		question: `What was the qualified investment property purchase amount in prior year 2?`,
		values: [
			{ purchaseAmount: "" },
		]
	},
	{
		question: `What depreciation was taken on the qualified investment property in prior year 2?`,
		values: [
			{ depriciationWasTaken: "" },
		]
	},
]
// .st
const DepriciationBCCLStyles = [
	{
		question: "Did the business participate in a cost segregation study this year?",
		bool: null,
		valData: [
			{ placeholder: "What is the expected depreciation after a cost segregation study?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Has the taxpayer purchased or is planning to purchase tangible, non-real estate assets?",
		bool: null,
		valData: [
			{ placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Asset Type", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Asset Total Depreciable Years", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Do you want to take the maximum allowable depreciation in the year you purchased the asset?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Do you have any qualified improvement property?",
		bool: null,
	},
	// inputs
	{
		question: "What is the approximate value of all real property owned or expected to purchase since the last tax return?",
		valData: [
			{ placeholder: "What is the approximate value of all real property owned or expected to purchase since the last tax return?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the expected depreciation (without a cost segregation study)?",
		valData: [
			{ placeholder: "What is the expected depreciation (without a cost segregation study)?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: `What was the qualified investment property purchase amount in prior year 1?`,
		valData: [
			{ placeholder: `What was the qualified investment property purchase amount in prior year 1?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: `What depreciation was taken on the qualified investment property in prior year 1?`,
		valData: [
			{ placeholder: `What depreciation was taken on the qualified investment property in prior year 1?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: `What was the qualified investment property purchase amount in prior year 2?`,
		valData: [
			{ placeholder: `What was the qualified investment property purchase amount in prior year 2?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: `What depreciation was taken on the qualified investment property in prior year 2?`,
		valData: [
			{ placeholder: `What depreciation was taken on the qualified investment property in prior year 2?`, styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
]
// <<<<<>>>>>
const RAndDBCCLQuestions = [
	{
		question: "Did the business participate in any research and development (R&D) activities or perform an R&D tax credit study?",
		bool: null,
		values: [
			{ developmentCosts: "" },
			{ developmentCreditPercentage: "" },
		]
	},
]
const RAndDBCCLStyles = [
	{
		valData: [
			{ placeholder: "What is the projected research and development costs?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What is the estimated research and development credit percentage?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// FICATipCredit
const FICATipCreditBCCLQuestions = [
	{
		question: "Does the business have tipped employees?",
		bool: null,
		values: [
			{ paidPlan: "" },
			{ totalWages: "" },
			{ totalAdjustments: "" },
		]
	},
]
const FICATipCreditBCCLStyles = [
	{
		valData: [
			{ placeholder: "What is the total tips paid or plan to be incurred and paid to employees?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What is the total wages (excluding tips) paid or plan to be incurred and paid to employees that make less than $5.15/hour?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "What is the total adjustment for tipped employees earning over the FICA Income limit?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// work opportunity credit
const WorkOpportunityCreditBCCLQuestions = [
	{
		question: "Are there any employees that would qualify for the work opportunity tax credit?",
		bool: null,
		values: [
			{ group1: "" },
			{ group2: "" },
			{ group3: "" },
			{ group4: "" },
			{ group5: "" },
			{ group6: "" },
		]
	},
]
const WorkOpportunityCreditBCCLStyles = [
	{
		valData: [
			{ placeholder: "Total number of employees that fall under the following qualifications (Group 1): Qualified veteran certified as being either (a) a member of a family receiving SNAP assistance (food stamps) for at least a 3-month period during the 15-month period ending on the hiring date, or (b) unemployed for a period or periods totaling at least 4 weeks (whether or not consecutive) but less than 6 months in the 1-year period ending on the hiring date; OR an employee certified as a member of any other targeted group that is not already listed below.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Total number of employees that fall under the following qualifications (Group 2): Qualified veteran certified as being entitled to compensation for a service-connected disability and hired not more than 1 year after being discharged or released from active duty in the U.S. Armed Forces.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Total number of employees that fall under the following qualifications (Group 3): Qualified veteran certified as being unemployed for a period or periods totaling at least 6 months (whether or not consecutive) in the 1-year period ending on the hiring date.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Total number of employees that fall under the following qualifications (Group 4): Qualified veteran certified as being entitled to compensation for a service-connected disability, and unemployed for a period or periods totaling at least 6 months (whether or not consecutive), in the 1-year period ending on the hiring date.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Total number of employees that fall under the following qualifications (Group 5): The amount of qualified first-year wages that may be taken into account for any employee certified as a summer youth employee.", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Total number of employees that fall under the following qualifications (Group 6): Long-Term Family Assistance recipients who are members of a family that has received TANF benefits for at least 18 consecutive months", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// International
const InternationalBCCLQuestions = [
	{
		question: "Do you want any overpayment of taxes applied to next year’s estimated taxes?",
		bool: null,
	},
	{
		question: "Do you want any federal or state refund deposited directly into your bank account?",
		bool: null,
	},
	{
		question: "Do you want any balance due directly withdrawn from this same bank account on the due date?",
		bool: null,
	},
	{
		question: "Do you want next year’s estimated taxes withdrawn from this same bank account on the due dates?",
		bool: null,
	},
	{
		question: "If you owe federal or state tax upon completion of your return, are you able to pay the balance due?",
		bool: null,
	},
	// inputs 5
	{
		question: `What is the entity's expected net profit or loss in ${new Date().getFullYear()} from export property exclusively?`,
		values: [
			{ expectedProfitOrLoss: "" }
		]
	},
	{
		question: `What is the entity's expected gross revenue in ${new Date().getFullYear()} from export property exclusively?`,
		values: [
			{ expectedGrossRevenue: "" }
		]
	},
	{
		question: "Tax Payments and Refunds",
		values: [
			{ paymentsAndRefunds: "" }
		]
	},
	// 8
	{
		question: "Federal prior year overpayment applied",
		values: [
			{ state: "", placeholder: "state" },
			{ date: new Date(), placeholder: "Date" },
			{ amount: "", placeholder: "Amount" },
		]
	},
]
// .st
const InternationalBCCLStyles = [
	{},
	{},
	{},
	{},
	{},
	// inputs 5
	{
		valData: [
			{ placeholder: `What is the entity's expected net profit or loss in ${new Date().getFullYear()} from export property exclusively?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		valData: [
			{ placeholder: `What is the entity's expected gross revenue in ${new Date().getFullYear()} from export property exclusively?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		valData: [
			{ placeholder: "Tax Payments and Refunds", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		valData: [
			{ placeholder: "state", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// ffff
const ForeignAccountsBCCLQuestions = [
	{
		question: "Did the business, at any time during the year, have an interest or signature authority in a foreign bank or securities account or control a foreign entity with a foreign bank or securities account where the the aggregate value of all the accounts exceeded U.S. $10,000 at any time during the year?",
		bool: null,
		values: [
			{ nameOfFinancialInstitution: "" },
			{ addressOfFinancialInstitution: "" },
			{ accountType: "" },
			{ accountNumber: "" },
			{ maximumValueDuringTheYear: "" },
			{ currencyExchangeRate: "" },
			{ ownershipPercentage: "" },
			{ jointOwnerName: "" },
			{ jointOwnersAddress: "" },
			{ jointOwnersUSTaxPayerIDNumber: "" },
		]
	},
]
const ForeignAccountsBCCLStyles = [
	{
		valData: [
			{ placeholder: "Name of financial institution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Address of financial institution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Account type (bank, securities, other)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Account number", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Maximum value during the year (in the foreign currency)", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Currency and exchange rate used", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Ownership percentage", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Joint owner's name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Joint owner's address", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Joint owner's US taxpayer identification number, if any", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// mm
const MiscellaneousBCCLQuestions = [
	{
		question: "Is this the final year of filing?",
		bool: null
	},
	{
		question: "Did you receive a PPP loan?",
		bool: null
	},
	{
		question: "Was your PPP loan forgiven?",
		bool: null
	},
	{
		question: "Any other significant business changes that occurred?",
		bool: null,
		values: [
			{ significantBusinessChange: "" },
		]
	},
]
const MiscellaneousBCCLStyles = [
	{},
	{},
	{},
	{
		valData: [
			{ placeholder: "Please describe the significant business change." },
		]
	},
]
let Options1040 = [
	{
		name: 'Personal',
		completed: false,
		open: true,
		SubOption: [
			{
				open: true,
				completed: false,
				name: 'Taxpayer',
				parent: 'Personal',
				component: <TaxPayer />,
			},
			{
				open: false,
				completed: false,
				parent: 'Personal',
				name: 'Filling status',
				component: <FilliingStatus />,
			},
			{
				open: false,
				completed: false,
				parent: 'Personal',
				name: 'Dependencies',
				component: <Dependent />,
			},
			{
				open: false,
				completed: false,
				parent: 'Personal',
				name: 'Address',
				component: <Address />,
			},
		],
	},
	{
		name: 'Questionnaire',
		completed: false,

		open: false,
		SubOption: [
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Life events',
				completed: false,
				component: <LifeEvent />,
			},
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Financial events',
				completed: false,
				component: <FinancialEvents />,
			},
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Other questions',
				completed: false,
				component: <OthersQuestions />,
			},
		],
	},
	{
		name: 'Income',
		completed: false,
		open: false,
		SubOption: [
			{
				parent: 'Income',
				open: false,
				name: 'Income sources',
				completed: false,
				component: <IncomeSource />,
			},
		],
	},
	{
		name: 'Expenses',
		completed: false,
		open: false,
		SubOption: [
			{
				completed: false,
				parent: 'Expenses',
				name: 'Expenses summary',
				open: false,
				component: <ExpensesSummary />,
			},
			{
				completed: false,
				parent: 'Expenses',
				name: 'Deductions',
				open: false,
				component: <Deduction />,
			},
		],
	},
	{
		name: 'Additional information',
		completed: false,
		open: false,
		SubOption: [
			{
				parent: 'Additional information',
				name: 'Estimated taxes',
				completed: false,
				open: false,
				component: <EstimateTaxes />,
			},
			{
				parent: 'Additional information',
				name: 'Refund and payment',
				completed: false,
				open: false,
				component: <RefundAndPayment />,
			},
		],
	},
];

// added tax planning individual
let OptionsTaxPlanningIndividual = [
	{
		name: 'Tax Planning Individual',
		completed: false,
		open: true,
		SubOption: [
			// 0
			{
				open: true,
				completed: false,
				name: 'New Client Intake',
				parent: 'Tax Planning Individual',
				component: <ClientIntake />,
			},
			// 1
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'General Information',
				component: <GeneralInformation />,
			},
			// 2
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Business General Finances',
				component: <BusinessGeneralFinances />,
			},
			// 3
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Business Income',
				component: <BusinessIncome />,
			},
			// 4
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Business Expenses',
				component: <BusinessExpenses />,
			},
			// 5
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Business Vehicles',
				component: <BusinessVehicles />,
			},
			// 6
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Income',
				component: <BIncome />,
			},
			// 7
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Qbid',
				component: <Qbid />,
			},
			// 8
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Tax Free Rental',
				component: <TaxFreeRental />,
			},
			// 9
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Retirement',
				component: <Retirement />,
			},
			// 10
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Employees',
				component: <Employees />,
			},
			// 11
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Payroll',
				component: <Payroll />,
			},
			// 12
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'COVID19',
				component: <Covid19 />,
			},
			// 13
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Fringe Benefits',
				component: <FringeBenefits />,
			},
			// 14
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Insurance',
				component: <Insurance />,
			},
			// 15
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Sales Assets',
				component: <SalesAssets />,
			},
			// 16
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Purchase Assets',
				component: <PurchaseAssets />,
			},
			// 17
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Corporate CS Corp',
				component: <CorporateCSCorp />,
			},
			// 18
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'SCORP',
				component: <SCorp />,
			},
			// 19
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Partnership',
				component: <PartnerShip />,
			},
			// 20
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Sole Proprietorship',
				component: <SoleProprietorship />,
			},
			// 21
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Future Partner Shareholders',
				component: <FuturePartnerShareholder />,
			},
			// 22
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Rental Estate Royalty Income ',
				component: <RentalEstateRoyaltyIncome />,
			},
			// 23
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Farm',
				component: <Farm />,
			},
			// 24
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Farm Rental',
				component: <FarmRental />,
			},
			// 25
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Depreciation',
				component: <Depreciation />,
			},
			// 26
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'FICA Tip Credit',
				component: <FICATipCredit />,
			},
			// 27
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'R&D Tax Credits',
				component: <RanDTaxCredits />,
			},
			// 28
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'work oppoutunity',
				component: <WorkOppoutubity />,
			},
			// 29
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'International',
				component: <International />,
			},
			// 30
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Tax Payment and Refund',
				component: <TaxPaymentRefund />,
			},
			// 31
			{
				open: false,
				completed: false,
				parent: 'Tax Planning Individual',
				name: 'Foreign Accounts',
				component: <ForeignAccounts />,
			},
			// {
			// 	open: false,
			// 	completed: false,
			// 	parent: 'Tax Planning Individual',
			// 	name: 'Future Partners',
			// 	component: <FuturePartners />,
			// },
		],
	}
];

let FormNamesTaxPlanningIndividual = {
	ClientIntake: {},
	GeneralInformation: {},
	BusinessGeneralFinances: {},
	BusinessIncome: {},
	BusinessExpenses: {},
	SalesAssets: {},
	PurchaseAssets: {},
	CorporateCSCorp: {},
	PartnerShip: {},
	SoleProprietorship: {},
	FuturePartnerShareholder: {},
	RentalEstateRoyaltyIncome: {},
	BIncome: {},
	Qbid: {},
	TaxFreeRental: {},
	Retirement: {},
	Employees: {},
	Payroll: {},
	Covid19: {},
	FringeBenefits: {},
	Insurance: {},
	BusinessVehicles: {},
	// FuturePartners: {},
	SCorp: {},
	Farm: {},
	FarmRental: {},
	Depreciation: {},
	FICATipCredit: {},
	RanDTaxCredits: {},
	International: {},
	WorkOppoutubity: {},
	TaxPaymentRefund: {},
	ForeignAccounts: {}
}

// added Tax Preparation (Individual, Current Client - Short)
let OptionsTaxPreperationIndividualCurrentClientShort = [
	{
		name: 'Tax Preparation (Individual, Current Client - Short)',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'Personal Information',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <PersonalInformation />,
			},
			{
				open: false,
				completed: false,
				name: 'Dependents',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <Dependents />,
			},
			{
				open: false,
				completed: false,
				name: 'Primary Residence',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <PrimaryResidence />,
			},
			{
				open: false,
				completed: false,
				name: 'Secondary Residence',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <SecondaryResidence />,
			},
			{
				open: false,
				completed: false,
				name: 'Income Details',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <IncomeDetails />,
			},
			{
				open: false,
				completed: false,
				name: 'Interest Income Details',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <InterestIncomeDetails />,
			},
			{
				open: false,
				completed: false,
				name: 'Divident Income Details',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <DividendIncomeDetail />,
			},
			{
				open: false,
				completed: false,
				name: 'Foreign Accounts Detail',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <ForeignAccountsDetail />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Income Detail',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <OtherIncomeDetail />,
			},
			{
				open: false,
				completed: false,
				name: 'Retirement Plans',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <RetirementPlans />,
			},
			{
				open: false,
				completed: false,
				name: 'Health and Medical',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <HealthAndMedical />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Deductions Summary',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <OtherDeductionsSummary />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Adjustment Details',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <OtherAdjustmentDetail />,
			},
			{
				open: false,
				completed: false,
				name: 'Itemized Deductions Detail',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <ItemizedDeductionsDetail />,
			},
			// input field issues
			{
				open: false,
				completed: false,
				name: 'Real Estate Taxes',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <RealEstateTaxes />,
			},
			{
				open: false,
				completed: false,
				name: 'Educational Expenses',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <EducationalExpenses />,
			},
			{
				open: true,
				completed: false,
				name: 'Additional Questions',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <AdditionalQuestions />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Credits',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <OtherCredits />,
			},
			{
				open: false,
				completed: false,
				name: 'Federal prior year overpayment applied',
				parent: 'Tax Preparation (Individual, Current Client - Short)',
				component: <FederalPrioryear />,
			},
		]
	}
]
let OptionsTaxPreperationIndividualCurrentClientLong = [
	{
		name: 'Tax Preparation (Individual, Current Client - Long)',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'Personal Information',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <PersonalInformationLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Dependents',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <DependentsLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Primary Residence',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <PrimaryResidenceLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Secondary Residence',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <SecondaryResidenceLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Wages Summary',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <WagesSummaryLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Income Details',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <IncomeDetailsLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Income Summary',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <OtherIncomeSummaryLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Interest Income Details',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <InterestIncomeDetailsLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Dividend Income Detail',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <DividendIncomeDetailLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Foreign Accounts Detail',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <ForeignAccountsDetailLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Income Details',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <OtherIncomeDetailsLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Capital Gains (or Losses)',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <CapitalGainLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Income From Partnerships',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <IncomeFromPartnershipsLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Retirement Plans',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <RetirementPlansLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Health And Medical',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <HealthAndMedicalLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Deductions Summary',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <OtherDeductionsSummaryLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Adjustment Details',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <OtherAdjustmentDetailsLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Itemized Deduction Detail',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <ItemizedDeductionDetailLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Intangible Tax',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <IntangibleTaxLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Income Tax Preparation Fees',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <IncomeTaxPreparationFees />,
			},
			{
				open: false,
				completed: false,
				name: 'Educational Expenses',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <EducationalExpensesLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Sales of Assets',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <SalesOfAssets />,
			},
			{
				open: false,
				completed: false,
				name: 'Purchase of Assets',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <PurchaseOfAsset />,
			},
			{
				open: false,
				completed: false,
				name: 'Charity',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <Charity />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Credits',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <OtherCreditsLong />,
			},
			{
				open: false,
				completed: false,
				name: 'QBID',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <QBIDLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Oil and Gas',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <OIlAndGas />,
			},
			{
				open: false,
				completed: false,
				name: 'International',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <InternationalLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Net Operating Losses',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <NetOpeartingLosses />,
			},
			{
				open: false,
				completed: false,
				name: 'Asset Protection',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <AssetProtection />,
			},
			{
				open: true,
				completed: false,
				name: 'Additional Questions',
				parent: 'Tax Preparation (Individual, Current Client - Long)',
				component: <AdditionalQuestionsLong />,
			},
		]
	}
]
// <<<<<<>>>>>>>
let OptionsTaxPreperationIndividualNewClientShort = [
	{
		name: 'Tax Preparation (Individual New Client, Short)',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'Personal Information',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <PersonalInformationNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Dependents',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <DependentsNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Primary Residence',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <PrimaryResidenceNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Secondary Residence',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <SecondaryResidenceNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Income Details',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <IncomeDetailsNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Interest Income Details',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <InterestIncomeDetailsNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Dividend Income Details',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <DividendIncomeDetailsNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Foreign Accounts Details',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <ForeignAccountsDetailsNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Income Details',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <OtherIncomeDetailsNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Retirement Plans',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <RetirementPlansNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Health And Medical',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <HealthAndMedicalNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Deductions Summary',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <OtherDeductionsSummaryNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Adjustment Details',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <OtherAdjustmentDetailsNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Itemized Deductions Details',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <ItemizedDeductionsDetailsNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Educational Expenses',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <EducationalExpensesNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Credits',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <OtherCreditsNewClientShort />,
			},
			{
				open: true,
				completed: false,
				name: 'Additional Questions',
				parent: 'Tax Preparation (Individual New Client, Short)',
				component: <AdditionalQuestionsNewClientShort />,
			},
		]
	}
]
// individual new Client Long
let OptionsTaxPreperationIndividualNewClientLong = [
	{
		name: 'Tax Preparation (Individual New Client, Long)',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'Personal Information',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <PersonalInformationNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Prior Year Tax Return',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <PriorYearTaxReturnNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Dependents',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <DependentsNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Primary Residence',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <PrimaryResidenceNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Secondary Residence',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <SecondaryResidenceNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Wages Summary',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <WagesSummaryNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Income Details',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <IncomeDetailsNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Income Summary',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <OtherIncomeSummaryNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Interest Income Details',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <InterestIncomeDetailsNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Dividend Income Detail',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <DividendIncomeDetailNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Foreign Accounts Detail',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <ForeignAccountsDetailNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Income Details',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <OtherIncomeDetailsNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Capital Gains (or Losses)',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <CapitalGainNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Retirement Plans',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <RetirementPlansNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Health And Medical',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <HealthAndMedicaNewClientlLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Deductions Summary',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <OtherDeductionsSummaryNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Adjustment Details',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <OtherAdjustmentDetailsNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Itemized Deductions Detail',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <ItemizedDeductionDetailNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Intangible Tax',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <IntangibleTaxNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Income Tax Preparation Fees',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <IncomeTaxPreparationFeesNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Educational Expenses',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <EducationalExpensesNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Sale of Assets',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <SalesOfAssetsNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Purchase Of Asset',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <PurchaseOfAssetNewClient />,
			},
			{
				open: false,
				completed: false,
				name: 'Charity',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <CharityNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Credits',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <OtherCreditsNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'QBID',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <QBIDNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Oil And Gas',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <OIlAndGasNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'International',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <InternationalNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Net Operating Losses',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <NetOperatingLossesNewClientLong />,
			},
			{
				open: false,
				completed: false,
				name: 'Asset Protection',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <AssetProtectionNewClientLong />,
			},
			{
				open: true,
				completed: false,
				name: 'Additional Questions',
				parent: 'Tax Preparation (Individual New Client, Long)',
				component: <AdditionalQuestionsNewClientLong />,
			},
		]
	}
]
// 
let OptionsTaxPreperationIndividualNewClientLongFormNames = {
	PersonalInformationNewClientLong: {},
	PriorYearTaxReturnNewClientLong: {},
	DependentsNewClientLong: {},
	PrimaryResidenceNewClientLong: {},
	SecondaryResidenceNewClientLong: {},
	WagesSummaryNewClientLong: {},
	IncomeDetailsNewClientLong: {},
	OtherIncomeSummaryNewClientLong: {},
	InterestIncomeDetailsNewClientLong: {},
	DividendIncomeDetailNewClientLong: {},
	ForeignAccountsDetailNewClientLong: {},
	OtherIncomeDetailsNewClientLong: {},
	CapitalGainNewClientLong: {},
	RetirementPlansNewClientLong: {},
	HealthAndMedicaNewClientlLong: {},
	OtherDeductionsSummaryNewClientLong: {},
	OtherAdjustmentDetailsNewClientLong: {},
	ItemizedDeductionDetailNewClientLong: {},
	IntangibleTaxNewClientLong: {},
	IncomeTaxPreparationFeesNewClientLong: {},
	EducationalExpensesNewClientLong: {},
	SalesOfAssetsNewClientLong: {},
	PurchaseOfAssetNewClient: {},
	CharityNewClientLong: {},
	OtherCreditsNewClientLong: {},
	QBIDNewClientLong: {},
	OIlAndGasNewClientLong: {},
	InternationalNewClientLong: {},
	NetOperatingLossesNewClientLong: {},
	AssetProtectionNewClientLong: {},
	AdditionalQuestionsNewClientLong: {},
}
// ********
let OptionsTaxPreperationIndividualNewClientShortFormNames = {
	PersonalInformationNewClientShort: {},
	DependentsNewClientShort: {},
	PrimaryResidenceNewClientShort: {},
	SecondaryResidenceNewClientShort: {},
	IncomeDetailsNewClientShort: {},
	InterestIncomeDetailsNewClientShort: {},
	DividendIncomeDetailsNewClientShort: {},
	ForeignAccountsDetailsNewClientShort: {},
	OtherIncomeDetailsNewClientShort: {},
	RetirementPlansNewClientShort: {},
	HealthAndMedicalNewClientShort: {},
	OtherDeductionsSummaryNewClientShort: {},
	OtherAdjustmentDetailsNewClientShort: {},
	ItemizedDeductionsDetailsNewClientShort: {},
	EducationalExpensesNewClientShort: {},
	OtherCreditsNewClientShort: {},
	AdditionalQuestionsNewClientShort: {},
}

let OptionsTaxPreperationIndividualCurrentClientShortFormNames = {
	PersonalInformation: {},
	Dependents: {},
	PrimaryResidence: {},
	SecondaryResidence: {},
	IncomeDetails: {},
	InterestIncomeDetails: {},
	DividendIncomeDetail: {},
	ForeignAccountsDetail: {},
	OtherIncomeDetail: {},
	RetirementPlans: {},
	HealthAndMedical: {},
	OtherDeductionsSummary: {},
	OtherAdjustmentDetail: {},
	ItemizedDeductionsDetail: {},
	RealEstateTaxes: {},
	EducationalExpenses: {},
	AdditionalQuestions: {},
	OtherCredits: {},
	FederalPrioryear: {}
};
let OptionsTaxPreperationIndividualCurrentClientLongFormNames = {
	PersonalInformationLong: {},
	DependentsLong: {},
	PrimaryResidenceLong: {},
	SecondaryResidenceLong: {},
	WagesSummaryLong: {},
	IncomeDetailsLong: {},
	OtherIncomeSummaryLong: {},
	InterestIncomeDetailsLong: {},
	DividendIncomeDetailLong: {},
	ForeignAccountsDetailLong: {},
	OtherIncomeDetailsLong: {},
	CapitalGainLong: {},
	IncomeFromPartnershipsLong: {},
	RetirementPlansLong: {},
	HealthAndMedicalLong: {},
	OtherDeductionsSummaryLong: {},
	OtherAdjustmentDetailsLong: {},
	ItemizedDeductionDetailLong: {},
	IntangibleTaxLong: {},
	IncomeTaxPreparationFees: {},
	EducationalExpensesLong: {},
	SalesOfAssets: {},
	PurchaseOfAsset: {},
	Charity: {},
	OtherCreditsLong: {},
	QBIDLong: {},
	OIlAndGas: {},
	InternationalLong: {},
	NetOpeartingLosses: {},
	AssetProtection: {},
	AdditionalQuestionsLong: {},
};
// Options1065

let Options1065 = [
	{
		name: 'General',
		completed: false,
		open: true,
		SubOption: [
			{
				open: true,
				completed: false,
				parent: 'General',
				name: 'Business Information',
				component: (
					<BusinessInformation FormHeading={'Organization'} dateHeading={'business started'} />
				),
			},
			{
				open: false,
				completed: false,
				parent: 'General',
				name: 'Business Address',
				component: <BusinessAddress />,
			},
			{
				open: false,
				completed: false,
				parent: 'General',
				name: 'Business Details',
				component: <BusinessDetails />,
			},
		],
	},
	{
		name: 'Partners',
		completed: false,
		open: true,
		SubOption: [
			{
				open: true,
				completed: false,
				parent: 'Partners',
				name: 'Partner information',
				component: <PartnerInformation />,
			},
		],
	},
	{
		name: 'Questionnaire',
		completed: false,

		open: false,
		SubOption: [
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Part 1',
				completed: false,
				component: (
					<QuestionnairePart1 formName="questionariePart1" questions={Options1065QuestionsPart1} />
				),
			},
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Part 2',
				completed: false,
				component: (
					<QuestionnairePart2
						questions={Options1065QuestionsPart2}
						multipleChoice={accountingPeriods}
					/>
				),
			},
		],
	},
	{
		name: 'Income and Expenses',
		completed: false,
		open: false,
		SubOption: [
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Income',
				completed: false,
				component: <Income modules={incomeInformation} />,
			},
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Cost of good sold',
				completed: false,
				component: <CostOfGoodsSale mode="no" />,
			},
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Expenses',
				completed: false,
				component: <Expenses />,
			},
		],
	},
	{
		name: 'Balance Sheet',
		completed: false,
		open: false,
		SubOption: [
			{
				completed: false,
				parent: 'Balance Sheet',
				name: 'Assets',
				open: false,
				component: <Assets />,
			},
			{
				completed: false,
				parent: 'Balance Sheet',
				name: 'Liabilities and capital',
				open: false,
				component: <LiabilitiesAndCapital LiabilitiesOptions={LiabilitiesOptions} />,
			},
		],
	},
	{
		name: 'Additional information',
		completed: false,
		open: false,
		SubOption: [
			{
				parent: 'Additional information',
				name: 'Fixed Assets',
				completed: false,
				open: false,
				component: <FixedAssets />,
			},
			{
				parent: 'Additional information',
				name: 'Comments',
				completed: false,
				open: false,
				component: <Comments />,
			},
		],
	},
];

const ShareHolderOptions = [
	{
		question:
			'Does the corporation have any additional shareholders who were not listed in the officers section?',
		bool: null,
	},
];

let Options1120C = [
	{
		name: 'General',
		completed: false,
		open: true,
		SubOption: [
			{
				open: true,
				completed: false,
				parent: 'General',
				name: 'Business Information',
				component: (
					<BusinessInformation FormHeading={'Incorporation'} dateHeading={'Incorporation'} />
				),
			},
			{
				open: false,
				completed: false,
				parent: 'General',
				name: 'Business Address',
				component: <BusinessAddress />,
			},
			{
				open: false,
				completed: false,
				parent: 'General',
				name: 'Business Details',
				component: <BusinessDetails type="1120" />,
			},
		],
	},
	{
		name: 'Officers and Shareholders',
		completed: false,
		open: true,
		SubOption: [
			{
				open: true,
				completed: false,
				parent: 'Officers and Shareholders',
				name: 'Officers',
				component: <Officer />,
			},
			{
				open: true,
				completed: false,
				parent: 'Officers and Shareholders',
				name: 'Shareholders',
				component: (
					<QuestionnairePart1
						parentIndex={1}
						myIndex={1}
						formName="OfficersAndShareholders"
						questions={OptionsShareHolders}
					/>
				),
			},
		],
	},
	{
		name: 'Questionnaire',
		completed: false,

		open: false,
		SubOption: [
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Part 1',
				completed: false,
				component: (
					<QuestionnairePart1 formName="questionariePart1" questions={Options1120QuestionsPart1} />
				),
			},
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Part 2',
				completed: false,
				component: (
					<QuestionnairePart2
						questions={Options1120QuestionsPart2}
						multipleChoice={yearEndReport}
					/>
				),
			},
		],
	},
	{
		name: 'Income and Expenses',
		completed: false,
		open: false,
		SubOption: [
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Income',
				completed: false,
				component: <Income modules={incomeInformation1120} />,
			},
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Cost of good sold',
				completed: false,
				component: <CostOfGoodsSale mode={'yes'} />,
			},
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Expenses',
				completed: false,
				component: <Expenses />,
			},
		],
	},
	{
		name: 'Balance Sheet',
		completed: false,
		open: false,
		SubOption: [
			{
				completed: false,
				parent: 'Balance Sheet',
				name: 'Assets',
				open: false,
				component: <Assets />,
			},
			{
				completed: false,
				parent: 'Balance Sheet',
				name: 'Liabilities and capital',
				open: false,
				component: <LiabilitiesAndCapital LiabilitiesOptions={LiabilitiesOptions1120} />,
			},
		],
	},
	{
		name: 'Additional information',
		completed: false,
		open: false,
		SubOption: [
			{
				parent: 'Additional information',
				name: 'Fixed Assets',
				completed: false,
				open: false,
				component: <FixedAssets />,
			},
			{
				parent: 'Additional information',
				name: 'Comments',
				completed: false,
				open: false,
				component: <Comments />,
			},
		],
	},
];

let Options1120S = [
	{
		name: 'General',
		completed: false,
		open: true,
		SubOption: [
			{
				open: true,
				completed: false,
				parent: 'General',
				name: 'Business Information',
				component: (
					<BusinessInformation
						FormHeading={'Incorporation'}
						dateHeading={'Incorporation'}
						extraDateInput="S election effective date"
					/>
				),
			},
			{
				open: false,
				completed: false,
				parent: 'General',
				name: 'Business Address',
				component: <BusinessAddress />,
			},
			{
				open: false,
				completed: false,
				parent: 'General',
				name: 'Business Details',
				component: <BusinessDetails type="1120" />,
			},
		],
	},
	{
		name: 'Officers and Shareholders',
		completed: false,
		open: true,
		SubOption: [
			{
				open: true,
				completed: false,
				parent: 'Officers and Shareholders',
				name: 'Officers',
				component: <Officer />,
			},
			{
				open: true,
				completed: false,
				parent: 'Officers and Shareholders',
				name: 'Shareholders',
				component: <ShareHolder shareholder={true} />,
			},
		],
	},
	{
		name: 'Questionnaire',
		completed: false,

		open: false,
		SubOption: [
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Part 1',
				completed: false,
				component: (
					<QuestionnairePart1 formName="questionariePart1" questions={Options1120SQuestionsPart1} />
				),
			},
			{
				parent: 'Questionnaire',
				open: false,
				name: 'Part 2',
				completed: false,
				component: (
					<QuestionnairePart2
						questions={Options1120SQuestionsPart2}
						multipleChoice={Options1120SQuestionsPart2ThreeOptions}
					/>
				),
			},
		],
	},
	{
		name: 'Income and Expenses',
		completed: false,
		open: false,
		SubOption: [
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Income',
				completed: false,
				component: <Income modules={incomeInformation1120} />,
			},
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Cost of good sold',
				completed: false,
				component: <CostOfGoodsSale mode={'yes'} />,
			},
			{
				parent: 'Income and Expenses',
				open: false,
				name: 'Expenses',
				completed: false,
				component: <Expenses />,
			},
		],
	},
	{
		name: 'Balance Sheet',
		completed: false,
		open: false,
		SubOption: [
			{
				completed: false,
				parent: 'Balance Sheet',
				name: 'Assets',
				open: false,
				component: <Assets />,
			},
			{
				completed: false,
				parent: 'Balance Sheet',
				name: 'Liabilities and equity',
				open: false,
				component: <LiabilitiesAndCapital LiabilitiesOptions={LiabilitiesOptions1120} />,
			},
		],
	},
	{
		name: 'Additional information',
		completed: false,
		open: false,
		SubOption: [
			{
				parent: 'Additional information',
				name: 'Fixed Assets',
				completed: false,
				open: false,
				component: <FixedAssets />,
			},
			{
				parent: 'Additional information',
				name: 'Comments',
				completed: false,
				open: false,
				component: <Comments />,
			},
		],
	},
];
let FormNames1040 = {
	taxPayerForm: {},
	fillingStatus: {},
	dependentForm: {},
	addressForm: {},
	lifeEventForm: {},
	financialEventForm: {},
	otherQuestionsForm: {},
	incomeSourceForm: {},
	expensesSummaryForm: {},
	defuctionForm: {},
	estimateTaxesForm: {},
	refundAndPaymentForm: {},
};

let FormNames1065 = {
	BusinessInformation: {},
	BusinessAddressForm: {},
	BusinessDetailsForm: {},
	PartnerInformationForm: {},
	questionariePart1: {},
	questionariePart2: {},
	BusinessIncomeForm: {},
	CostOfGoodsForm: {},
	ExpensesForm: {},
	AssetsForm: {},
	LiabilitiesAndCapitalForm: {},
	FixedAssetsForm: {},
	CommentsForm: {},
};

let FormNames1120C = {
	BusinessInformation: {},
	BusinessAddressForm: {},
	BusinessDetailsForm: {},
	OfficerForm: {},
	OfficersAndShareholders: {},
	questionariePart1: {},
	questionariePart2: {},
	BusinessIncomeForm: {},
	CostOfGoodsForm: {},
	ExpensesForm: {},
	AssetsForm: {},
	LiabilitiesAndCapitalForm: {},
	FixedAssetsForm: {},
	CommentsForm: {},
};

let FormNames1120S = {
	BusinessInformation: {},
	BusinessAddressForm: {},
	BusinessDetailsForm: {},
	OfficerForm: {},
	ShareHolderForm: {},
	questionariePart1: {},
	questionariePart2: {},
	BusinessIncomeForm: {},
	CostOfGoodsForm: {},
	ExpensesForm: {},
	AssetsForm: {},
	LiabilitiesAndCapitalForm: {},
	FixedAssetsForm: {},
	CommentsForm: {},
};
// ___________________()()()
let OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort = [
	{
		name: 'Tax Preparation Questionnaire (Business, Current Client, Short)',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'General Information',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Short)',
				component: <GeneralInformationBusinessCurrentClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Financials',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Short)',
				component: <BusinessFinancialsBusinessCurrentClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Sale of Asset',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Short)',
				component: <SaleOfAssetBusinessCurrentClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Purchase of Asset',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Short)',
				component: <PurchaseOfAssetBusinessCurrentClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Miscellaneous',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Short)',
				component: <MiscellaneousBusinessCurrentClientShort />,
			},
		]
	}
];
let OptionsTaxPreperationQuestionnaireBusinessCurrentClientShortFormNames = {
	GeneralInformationBusinessCurrentClientShort: {},
	BusinessFinancialsBusinessCurrentClientShort: {},
	SaleOfAssetBusinessCurrentClientShort: {},
	PurchaseOfAssetBusinessCurrentClientShort: {},
	MiscellaneousBusinessCurrentClientShort: {}
}
// 
let OptionsTaxPreperationQuestionnaireBusinessNewClientShort = [
	{
		name: 'Tax Preparation Questionnaire (Business, New Client, Short)',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'Prior Year Tax Returns',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Short)',
				component: <PriorYearTaxReturnBusinessNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'General Information',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Short)',
				component: <GeneralInformationBusinessNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Financials',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Short)',
				component: <BusinessFinancialsBusinessNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Sale of Assets',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Short)',
				component: <SaleOfAssetBusinessNewClientShort />,
			},
			{
				open: false,
				completed: false,
				name: 'Purchase of Assets',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Short)',
				component: <PurchaseOfAssetBusinessNewClientShort />,
			},
			{
				open: true,
				completed: false,
				name: 'Rental Real Estate And Royalty Income',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Short)',
				component: <RentalRealEstateAndRoyaltyOncome />,
			},
			{
				open: false,
				completed: false,
				name: 'Miscellaneous',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Short)',
				component: <MiscellaneousBusinessNewClientShort />,
			},
		]
	}
];
let OptionsTaxPreperationQuestionnaireBusinessNewClientShortFormNames = {
	PriorYearTaxReturnBusinessNewClientShort: {},
	GeneralInformationBusinessNewClientShort: {},
	BusinessFinancialsBusinessNewClientShort: {},
	SaleOfAssetBusinessNewClientShort: {},
	PurchaseOfAssetBusinessNewClientShort: {},
	RentalRealEstateAndRoyaltyOncome: {},
	MiscellaneousBusinessNewClientShort: {},
}
// 
let OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong = [
	{
		name: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
		completed: false,
		open: true,
		SubOption: [
			{
				open: true,
				completed: false,
				name: 'General Information',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <GeneralInformationBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Income',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <BusinessIncomeBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Expenses',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <BusinessExpensesBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Interest',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <OtherInterestBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Supplies',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <SuppliesBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Vehicles',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <BusinessVehiclesBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'ShareHolder Income',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <ShareHolderIncomeBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'QBID',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <QBIDBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Tax-Free Rental',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <TaxFreeRentalBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Retirement',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <RetirementBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Employees',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <EmployeesBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Payroll',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <PayRollBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'COVID 19',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <Covid19BCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Fringe Benefits',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <FringeBenefitsBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Insurance',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <InsuranceBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Sales Of Assets',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <SalesOfAssetsBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Purchase Of Assets',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <PurchaseOfAssetBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Corporate (C or S Corp)',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <CorporateBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'S Corp',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <SCorpBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Partnership',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <PartnershipBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Sole Proprietorship',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <SoleProprietorshipBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Future Partners & Shareholders',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <FuturePartnersAndShareholdersBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Rental Real Estate and Royalty Income',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <RentalRealEstateAndRoyaltyIncomeBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Farm',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <FarmBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Farm Rental',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <FarmRentalBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Depriciation',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <DepriciationBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'FICA Tip Credit',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <FICATipCreditBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'R&D Tax Credits',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <RAndDTaxCreditsBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Work Opportunity Credit',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <WorkOpportunityCreditBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'International',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <InternationalBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Foreign Accounts',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <ForeignAccountsBCCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Miscellaneous',
				parent: 'Tax Preparation Questionnaire (Business, Current Client, Long)',
				component: <MiscellaneousBCCL />,
			},
		]
	}
];
let OptionsTaxPreperationQuestionnaireBusinessCurrentClientLongFormNames = {
	GeneralInformationBCCL: {},
	BusinessIncomeBCCL: {},
	BusinessExpensesBCCL: {},
	OtherInterestBCCL: {},
	SuppliesBCCL: {},
	BusinessVehiclesBCCL: {},
	ShareHolderIncomeBCCL: {},
	QBIDBCCL: {},
	TaxFreeRentalBCCL: {},
	RetirementBCCL: {},
	EmployeesBCCL: {},
	PayRollBCCL: {},
	Covid19BCCL: {},
	FringeBenefitsBCCL: {},
	InsuranceBCCL: {},
	SalesOfAssetsBCCL: {},
	PurchaseOfAssetBCCL: {},
	CorporateBCCL: {},
	SCorpBCCL: {},
	PartnershipBCCL: {},
	SoleProprietorshipBCCL: {},
	FuturePartnersAndShareholdersBCCL: {},
	RentalRealEstateAndRoyaltyIncomeBCCL: {},
	FarmBCCL: {},
	FarmRentalBCCL: {},
	DepriciationBCCL: {},
	FICATipCreditBCCL: {},
	RAndDTaxCreditsBCCL: {},
	WorkOpportunityCreditBCCL: {},
	InternationalBCCL: {},
	ForeignAccountsBCCL: {},
	MiscellaneousBCCL: {},
}
// BNCL
let OptionsTaxPreperationQuestionnaireBusinessNewClientLong = [
	{
		name: 'Tax Preparation Questionnaire (Business, New Client, Long)',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'Prior Year Tax Returns',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <PriorYearTaxReturnBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'General Information',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <GeneralInformationBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Income',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <BusinessIncomeBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Expenses',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <BusinessExpensesBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Interest',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <OtherInterestBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Supplies',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <SuppliesBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Vehicles',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <BusinessVehiclesBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Shareholder Income',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <ShareHolderIncomeBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'QBID',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <QBIDBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Tax-Free Rental',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <TaxFreeRentalBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Retirement',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <RetirementBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Employees',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <EmployeesBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Payroll',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <PayRollBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'COVID-19',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <Covid19BNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Fringe Benefits',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <FringeBenefitsBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Insurance',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <InsuranceBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Sale of Assets',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <SalesOfAssetsBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Purchase of Assets',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <PurchaseOfAssetBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Corporate',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <CorporateBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'S Corp',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <SCorpBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Partnership',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <PartnershipBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Sole Proprietorship',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <SoleProprietorshipBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Future Partners & Shareholders',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <FuturePartnersAndShareholdersBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Rental Real Estate and Royalty Income',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <RentalRealEstateAndRoyaltyIncomeBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Farm',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <FarmBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Farm Rental',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <FarmRentalBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Depriciation',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <DepriciationBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'FICA Tip Credit',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <FICATipCreditBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'R&D Tax Credits',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <RAndDTaxCreditsBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Work Opportunity Credit',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <WorkOpportunityCreditBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'International',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <InternationalBNCL />,
			},
			{
				open: false,
				completed: false,
				name: 'Foreign Accounts',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <ForeignAccountsBNCL />,
			},
			{
				open: true,
				completed: false,
				name: 'Miscellaneous',
				parent: 'Tax Preparation Questionnaire (Business, New Client, Long)',
				component: <MiscellaneousBNCL />,
			},
		]
	}
];
let OptionsTaxPreperationQuestionnaireBusinessNewClientLongFormNames = {
	PriorYearTaxReturnBNCL: {},
	GeneralInformationBNCL: {},
	BusinessIncomeBNCL: {},
	BusinessExpensesBNCL: {},
	OtherInterestBNCL: {},
	SuppliesBNCL: {},
	BusinessVehiclesBNCL: {},
	ShareHolderIncomeBNCL: {},
	QBIDBNCL: {},
	TaxFreeRentalBNCL: {},
	RetirementBNCL: {},
	EmployeesBNCL: {},
	PayRollBNCL: {},
	Covid19BNCL: {},
	FringeBenefitsBNCL: {},
	InsuranceBNCL: {},
}
// TaxPlaningIndivudual
let TaxPlaningIndividual = [
	{
		name: 'Tax Planning Individual',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'New Client Intake',
				parent: 'Tax Planning Individual',
				component: <ClientIntakeTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Personal Information',
				parent: 'Tax Planning Individual',
				component: <PersonalInformationTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Wages',
				parent: 'Tax Planning Individual',
				component: <WagesTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Dependent Children',
				parent: 'Tax Planning Individual',
				component: <DependentChildrenTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Primary Residence',
				parent: 'Tax Planning Individual',
				component: <PrimaryResidenceTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Secondary Residence',
				parent: 'Tax Planning Individual',
				component: <SecondaryResidenceTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Health And Medical',
				parent: 'Tax Planning Individual',
				component: <HealthAndMedicalTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Charity',
				parent: 'Tax Planning Individual',
				component: <CharityTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Retirement Plans',
				parent: 'Tax Planning Individual',
				component: <RetirementPlansTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Sale of Assets',
				parent: 'Tax Planning Individual',
				component: <SaleofAssetsTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Purchase of Assets',
				parent: 'Tax Planning Individual',
				component: <PurchaseofAssetsTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Income',
				parent: 'Tax Planning Individual',
				component: <OtherIncomeTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Capital Gains (or Losses)',
				parent: 'Tax Planning Individual',
				component: <CapitalGainsTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Other Deductions',
				parent: 'Tax Planning Individual',
				component: <OtherDeductionsTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'QBID',
				parent: 'Tax Planning Individual',
				component: <QBIDTPI />,
			},
			{
				open: false,
				completed: false,
				name: 'Oil & Gas',
				parent: 'Tax Planning Individual',
				component: <OilAndGasTPI />,
			},
			{
				open: true,
				completed: false,
				name: 'Asset Protection',
				parent: 'Tax Planning Individual',
				component: <AssetProtectionTPI />,
			},
		]

	}
];
let TaxPlaningIndividualFormNames = {
	ClientIntakeTPI: {},
	PersonalInformationTPI: {},
	WagesTPI: {},
	DependentChildrenTPI: {},
	PrimaryResidenceTPI: {},
	SecondaryResidenceTPI: {},
	HealthAndMedicalTPI: {},
	CharityTPI: {},
	RetirementPlansTPI: {},
	SaleofAssetsTPI: {},
	PurchaseofAssetsTPI: {},
	OtherIncomeTPI: {},
	CapitalGainsTPI: {},
	OtherDeductionsTPI: {},
	QBIDTPI: {},
	OilAndGasTPI: {},
	AssetProtectionTPI: {},
}
// Tax Planning Business Owner
let TaxPlanningBusinessOwner = [
	{
		name: 'Tax Planning Business Owner',
		completed: false,
		open: true,
		SubOption: [
			{
				open: false,
				completed: false,
				name: 'New Client Intake',
				parent: 'Tax Planning Business Owner',
				component: <ClientIntakeTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'General Information',
				parent: 'Tax Planning Business Owner',
				component: <GeneralInformationTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Income',
				parent: 'Tax Planning Business Owner',
				component: <IncomeTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Partners & Shareholders',
				parent: 'Tax Planning Business Owner',
				component: <PartnersAndShareHoldersTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'QBID',
				parent: 'Tax Planning Business Owner',
				component: <QBIDTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Tax-Free Rental',
				parent: 'Tax Planning Business Owner',
				component: <TaxFreeRentalTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Retirement',
				parent: 'Tax Planning Business Owner',
				component: <RetirementTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'COVID19',
				parent: 'Tax Planning Business Owner',
				component: <COVID19TPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Payroll',
				parent: 'Tax Planning Business Owner',
				component: <PayRollTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Business Expenses',
				parent: 'Tax Planning Business Owner',
				component: <BusinessExpensesTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Fringe Benefits',
				parent: 'Tax Planning Business Owner',
				component: <FringeBenefitsTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Insurance',
				parent: 'Tax Planning Business Owner',
				component: <InsuranceTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Employees',
				parent: 'Tax Planning Business Owner',
				component: <EmployeesTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Sale of Assets',
				parent: 'Tax Planning Business Owner',
				component: <SaleofAssetsTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Purchase of Assets',
				parent: 'Tax Planning Business Owner',
				component: <PurchaseofAssetsTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Rental Real Estate',
				parent: 'Tax Planning Business Owner',
				component: <RentalRealEstateTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Farm',
				parent: 'Tax Planning Business Owner',
				component: <FarmTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Farm Rental',
				parent: 'Tax Planning Business Owner',
				component: <FarmRentalTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Depreciation',
				parent: 'Tax Planning Business Owner',
				component: <DepreciationTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'FICA Tip Credit',
				parent: 'Tax Planning Business Owner',
				component: <FICATipCreditTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'R&D Tax Credits',
				parent: 'Tax Planning Business Owner',
				component: <RandDTaxCreditsTPBO />,
			},
			{
				open: false,
				completed: false,
				name: 'Work Opportunity Credit',
				parent: 'Tax Planning Business Owner',
				component: <WorkOpportunityCreditTPBO />,
			},
			{
				open: true,
				completed: false,
				name: 'International',
				parent: 'Tax Planning Business Owner',
				component: <InternationalTPBO />,
			},
		]

	}
];
// Tax Planning Business Owner Form Names
let TaxPlanningBusinessOwnerFormNames = {
	ClientIntakeTPBO: {},
	GeneralInformationTPBO: {},
	IncomeTPBO: {},
	PartnersAndShareHoldersTPBO: {},
	QBIDTPBO: {},
	TaxFreeRentalTPBO: {},
	RetirementTPBO: {},
	COVID19TPBO: {},
	PayRollTPBO: {},
	BusinessExpensesTPBO: {},
	FringeBenefitsTPBO: {},
	InsuranceTPBO: {},
	EmployeesTPBO: {},
	SaleofAssetsTPBO: {},
	PurchaseofAssetsTPBO: {},
	RentalRealEstateTPBO: {},
	FarmTPBO: {},
	FarmRentalTPBO: {},
	DepreciationTPBO: {},
	FICATipCreditTPBO: {},
	RandDTaxCreditsTPBO: {},
	WorkOpportunityCreditTPBO: {},
	InternationalTPBO: {},


}
// TaxPlanningBusinessOwner Questions
const GeneralInformationTPBOQuestions = [
	{
		question: "Do you expect to sell the business in the next two years?",
		bool: null,
		values: [
			{ expectedSellingPrice: "" }
		]
	},
	{
		question: "Do you expect any change in ownership?",
		bool: null,
		values: [
			{ changeInOwnership: "" }
		]
	},
	// 
	{
		question: "What is the legal entity name?",
		values: [
			{
				entityName: "",
			}
		]
	},
	{
		question: "What is the entity type?",
		values: [
			{
				entityType: "",
			}
		]
	},
	{
		question: "What percentage of the business do you own?",
		values: [
			{
				ownerPercentage: "",
			}
		]
	},
	{
		question: "When did the business start?",
		values: [
			{
				businessStartDate: new Date(),
			}
		]
	},
	{
		question: "What percentage of the business does your spouse own?",
		values: [
			{
				spouseOwnershipPercentage: "",
			}
		]
	},

	{
		question: "What is the employer identification number (EIN), if any?",
		values: [
			{
				employerIdentificationNumber: "",
			}
		]
	},
	{
		question: "What is the business's principal product or service?",
		values: [
			{
				principalProductOrService: "",
			}
		]
	}
];
const GeneralInformationTPBOStyles = [
	{
		question: "Do you expect to sell the business in the next two years?",
		bool: null,
		valData: [
			{ placeholder: "What is the expected selling price of the business?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Do you expect any change in ownership?",
		bool: null,
		valData: [
			{ placeholder: "Please describe the change in ownership.", styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	// 
	{
		question: "What is the legal entity name?",
		valData: [
			{
				placeholder: "What is the legal entity name?", styleProp: "col-lg-6 col-md-8 col-sm-12"
			}
		]
	},
	{
		question: "What is the entity type?",
		valData: [
			{
				placeholder: "What is the entity type?", styleProp: "col-lg-6 col-md-8 col-sm-12"
			}
		]
	},
	{
		question: "What percentage of the business do you own?",
		valData: [
			{
				placeholder: "What percentage of the business do you own?", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999"
			}
		]
	},
	{
		question: "When did the business start?",
		valData: [
			{
				placeholder: "When did the business start?", styleProp: "col-lg-6 col-md-8 col-sm-12"
			}
		]
	},
	{
		question: "What percentage of the business does your spouse own?",
		valData: [
			{
				placeholder: "What percentage of the business does your spouse own?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "99999999"
			}
		]
	},
	{
		question: "What is the employer identification number (EIN), if any?",
		valData: [
			{
				placeholder: "What is the employer identification number (EIN), if any?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999"
			}
		]
	},
	{
		question: "What is the business's principal product or service?",
		valData: [
			{
				placeholder: "What is the business's principal product or service?", styleProp: "col-lg-12 col-md-8 col-sm-12"
			}
		]
	}
];
// Income
const IncomeTPBOQuestions = [
	{
		question: "What is the entity's expected gross revenue?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What is the entity's expected net profit or loss?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected W-2 wages (from this business)? Note: If you did not receive W-2 wages as a Schedule C entity, enter $0.",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected dividends on form 1099-DIV (from this business)?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected guaranteed payments on Form K-1 (from this business)?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "How much does your cash compensation (wages, distributions, dividends, etc) do you need from this entity annually in order to maintain your lifestyle (from this business)?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected W-2 wages (from this business)?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected dividends on form 1099-DIV (from this business)?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected guaranteed payments on Form K-1 (from this business)?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What is the total expected owners compensation including taxes for all OTHER owners (not including you or your spouse)?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
];
const IncomeTPBOQStyles = [
	{
		question: "What is the entity's expected gross revenue?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What is the entity's expected net profit or loss?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected W-2 wages (from this business)? Note: If you did not receive W-2 wages as a Schedule C entity, enter $0.",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected dividends on form 1099-DIV (from this business)?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected guaranteed payments on Form K-1 (from this business)?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "How much does your cash compensation (wages, distributions, dividends, etc) do you need from this entity annually in order to maintain your lifestyle (from this business)?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected W-2 wages (from this business)?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected dividends on form 1099-DIV (from this business)?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected guaranteed payments on Form K-1 (from this business)?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What is the total expected owners compensation including taxes for all OTHER owners (not including you or your spouse)?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
];
// PartnersAndShareHolders
const PartnersAndShareHoldersTPBOQuestions = [
	{
		question: "If you are, or were to convert to a S Corporation, how many shareholders are in the S Corporation?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "If you are, or were to convert to a Partnership, how many partners are in the Partnership?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "If you are, or were to convert to a Partnership, are you a general or a limited partner? A general partner is assumed.",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
];
const PartnersAndShareHoldersTPBOStyles = [
	{
		question: "If you are, or were to convert to a S Corporation, how many shareholders are in the S Corporation?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "If you are, or were to convert to a Partnership, how many partners are in the Partnership?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "If you are, or were to convert to a Partnership, are you a general or a limited partner? A general partner is assumed.",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
];

const QBIDTPBOQuestions = [
	{
		question: "Is this a business where the principal asset is the reputation or skill of one or more of its employees or owners, such as businesses providing services in health, law, performing arts, accounting, actuarial science, and consulting?",
		values: [
			{
				principalAssetReputation: "",
			}
		]
	},
	{
		question: "What is your allocated share of W-2 wages from this trade or business? Include wages paid to you or your spouse from this business.",
		values: [
			{
				allocatedShareW2Wages: "",
			}
		]
	},
	{
		question: "What is the allocated share of unadjusted basis immediately (UBIA) after acquisition of all qualified business property from this business? This is generally the purchase price of the asset before any depreciation was taken.",
		values: [
			{
				allocatedShareUBIA: "",
			}
		]
	},
	{
		question: "What is the patron reduction from horticultural or agricultural cooperatives, for this business?",
		values: [
			{
				patronReduction: "",
				placeholder: "What is the patron reduction from horticultural or agricultural cooperatives, for this business?"
			}
		]
	},
	{
		question: "What were the prior year carryover losses for this trade or business?",
		values: [
			{
				priorYearCarryoverLosses: "",
				placeholder: "What were the prior year carryover losses for this trade or business?"
			}
		]
	}
];
const QBIDTPBOQStyles = [
	{
		question: "Is this a business where the principal asset is the reputation or skill of one or more of its employees or owners, such as businesses providing services in health, law, performing arts, accounting, actuarial science, and consulting?",
		valData: [
			{
				placeholder: "Is this a business where the principal asset is the reputation or skill of one or more of its employees or owners, such as businesses providing services in health, law, performing arts, accounting, actuarial science, and consulting?"
			}
		]
	},
	{
		question: "What is your allocated share of W-2 wages from this trade or business? Include wages paid to you or your spouse from this business.",
		valData: [
			{
				placeholder: "What is your allocated share of W-2 wages from this trade or business? Include wages paid to you or your spouse from this business."
			}
		]
	},
	{
		question: "What is the allocated share of unadjusted basis immediately (UBIA) after acquisition of all qualified business property from this business? This is generally the purchase price of the asset before any depreciation was taken.",
		valData: [
			{
				placeholder: "What is the allocated share of unadjusted basis immediately (UBIA) after acquisition of all qualified business property from this business? This is generally the purchase price of the asset before any depreciation was taken."
			}
		]
	},
	{
		question: "What is the patron reduction from horticultural or agricultural cooperatives, for this business?",
		valData: [
			{
				patronReduction: "",
				placeholder: "What is the patron reduction from horticultural or agricultural cooperatives, for this business?"
			}
		]
	},
	{
		question: "What were the prior year carryover losses for this trade or business?",
		valData: [
			{
				priorYearCarryoverLosses: "",
				placeholder: "What were the prior year carryover losses for this trade or business?"
			}
		]
	}
];
// retirement
const RetirementTPBOQuestions = [
	{
		question: `Does this business currently have a retirement plan in place?`,
		bool: null,
		values: [
			{ retirementPlanType: "" },
			{ amountContributedToEmployees: "" },
			{ maximizeRetirementPlan: "" },
			{ wishToContributeThreePercent: "" },
		]
	},
];
const RetirementTPBOStyles = [
	{
		question: `Does this business currently have a retirement plan in place?`,
		bool: null,
		valData: [
			{ placeholder: "What type of retirement plan?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: `What is the total amount to be contributed to the employees in ${new Date().getFullYear() - 1}, not including yourself or your spouse (if your spouse owns a % of the business)?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Do you wish to maximize your retirement plan contributions?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "Do you wish to contribute 3% of each employee's salary to an employee retirement plan?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	}
];
// 
const TaxFreeRentalTPBOQuestions = [
	{
		question: "Would you be willing to have meetings in your personal residence in 2024 that are business-related?",
		bool: null,
		values: [
			{ businessRelatedMeetings: "", placeholder: "How many days in 2021 would you be willing to hold these business-related meetings in your home?" },
			{ meetingRoomCost: "", placeholder: "How much does a meeting room cost for a day in your local area?" }
		]
	},
];
const TaxFreeRentalTPBOStyles = [
	{
		valData: [
			{ placeholder: "How many days in 2021 would you be willing to hold these business-related meetings in your home?", mask: "999999999" },
			{ placeholder: "How much does a meeting room cost for a day in your local area?", mask: "999999999" },
		]
	},
];
// COVID19
const covid19TPBOOptions = [
	{
		question: 'Did you receive EIDL funding?',
		bool: null,
		values: [
			{ EIDLAdvanceAmount: "" },
			{ EIDLloanAmount: "" },
			{ loanOriginationDate: new Date() },
		]
	},
	// 1
	{
		question: 'Did you receive PPP funding?',
		bool: null,
		values: [
			{ PPPLoanAmount: "" },
			{ PPPLoanOriginationDate: new Date() },
			{ PPPLoanFundsNotYetSpent: "" },
			{ loanAmountSpentOnPayrollCosts: "" },
			{ loanAmountSpentOnPayrollEligible: "" },
		]
	},
	// 2
	{
		question: 'Did you receive PPP forgiveness?',
		bool: null,
		values: [
			{ PPPForgivenessAmount: "" },
		]
	},
	// 3
	{
		question: 'Do you have any employees located in a disaster zone in 2021?',
		bool: null,
		values: [
			{ disasterRelatedExpenses: "" },
		]
	},
	// 4
	{
		question: 'Were there any employees that were on family and/or medical leave due to COVID-19?',
		bool: null,
		values: [
			{ employeesMissedWorkDueToCovid: "" },
			{ totalDaysMissedDueToCovid: "" },
			{ employeesMissedWorkToCareForOthers: "" },
			{ totalDaysMissedCaringForOthers: "" },
			{ employerHealthcarePremiumsDuringLeave: "" },
			{ totalWagesPaidForLeave: "" },
		]
	},
];
const covid19TPBOStyles = [
	{
		question: 'Did you receive EIDL funding?',
		bool: null,
		valData: [
			{ placeholder: "Total EIDL advance amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Total EIDL Loan amount (less advance)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "EIDL loan origination date", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// 1
	{
		question: 'Did you receive PPP funding?',
		bool: null,
		valData: [
			{ placeholder: "PPP loan amount", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "PPP Loan origination date", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Remaining PPP loan funds not yet spent", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "PPP loan amount spent on payroll costs", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "PPP loan amount spent on non payroll eligible costs", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	// 2
	{
		question: 'Did you receive PPP forgiveness?',
		bool: null,
		valData: [
			{ placeholder: "Total PPP forgiveness amount granted", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	// 3
	{
		question: 'Do you have any employees located in a disaster zone in 2021?',
		bool: null,
		valData: [
			{ placeholder: "What are the total disaster-related expenses incurred or plan to incur this year for affected employees?", mask: "999999999" },
		]
	},
	// 4
	{
		question: 'Were there any employees that were on family and/or medical leave due to COVID-19?',
		bool: null,
		valData: [
			{ placeholder: "How many employees missed work due to being sick and/or under quarantine due to COVID-19?", mask: "999999999" },
			{ placeholder: "How many days total did these sick and quarantined employees miss (maximum 10 days per employee)?", mask: "999999999" },
			{ placeholder: "How many employees missed work due to caring for someone who was sick and under quarantine due to COVID-19?", mask: "999999999" },
			{ placeholder: "How many days total did these employees who were caring for someone sick due to COVID-19 miss (maximum 10 days per employee)?", mask: "999999999" },
			{ placeholder: "What was the total employer portion of the health care premiums incurred while employees were covered under the Emergency Paid Sick Leave or Emergency Family & Medical Leave?", mask: "999999999" },
			{ placeholder: "What were the total wages paid out due to employees being on FMLA and Sick Leave?", mask: "999999999" },
		]
	},
];
// Payroll
const PayrollTPBOQuestions = [
	{
		question: `What are the expected total wages to be paid to your employees in ${currentYear - 1}, not including yourself or your spouse (if your spouse owns a percentage of the business)?`,
		values: [
			{ expectedTotalWages: "" }
		]
	},
	{
		question: `Total wages paid in Q1 ${currentYear - 1}`,
		values: [
			{ wagesPaidQ1: "" }
		]
	},
	{
		question: `Total wages paid in Q2 ${currentYear - 1}`,
		values: [
			{ wagesPaidQ2: "" }
		]
	},
	{
		question: `Total wages paid in Q3 ${currentYear - 1}`,
		values: [
			{ expectedWagesQ3: "" }
		]
	},
	{
		question: `Total wages expected to be paid in Q4 ${currentYear - 1}`,
		values: [
			{ expectedWagesQ4: "" }
		]
	},
	{
		question: `What is the total payroll costs of all employees projected to make less than $10,000 in ${currentYear - 1}?`,
		values: [
			{ totalPayrollCostsLess10K: "" }
		]
	},
	{
		question: `How many total employees are projected to make over $10,000 in ${currentYear - 1}?`,
		values: [
			{ totalEmployeesOver10K: "" }
		]
	},
];
const PayrollTPBOStyles = [
	{
		question: `What are the expected total wages to be paid to your employees in 2021, not including yourself or your spouse (if your spouse owns a percentage of the business)?`,
		valData: [
			{ placeholder: `What are the expected total wages to be paid to your employees in 2021, not including yourself or your spouse (if your spouse owns a percentage of the business)?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: `Total wages paid in Q1 2020`,
		valData: [
			{ placeholder: `Total wages paid in Q1 2020`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: `Total wages paid in Q2 2021`,
		valData: [
			{ placeholder: `Total wages paid in Q2 2021`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: `Total wages paid in Q3 2021`,
		valData: [
			{ placeholder: `Total wages paid in Q3 2021`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: `Total wages expected to be paid in Q4 2021`,
		valData: [
			{ placeholder: `Total wages expected to be paid in Q4 2021`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: `What is the total payroll costs of all employees projected to make less than $10,000 in 2021?`,
		valData: [
			{ placeholder: `What is the total payroll costs of all employees projected to make less than $10,000 in 2021?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: `How many total employees are projected to make over $10,000 in 2021?`,
		valData: [
			{ placeholder: `How many total employees are projected to make over $10,000 in 2021?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
];
// BE
const BusinessExpensesTPBOQuestions = [
	{
		question: "Does the business have an accountable plan in place (for expenses)?",
		bool: null
	},
	{
		question: "Have you traveled or are you planning on traveling for business?",
		bool: null,
		values: [
			{ autoMobileMilesTraveled: "" },
			{ hotalAndLodgingCost: "" },
			{ travelMealsRestaurents: "" },
			{ travelMealsNonRestaurents: "" },
			{ travelTransportation: "" },
		]
	},
	{
		question: "Other travel costs",
		values: [
			{ otherTravelCosts: "" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur related to business meals in restaurants?",
		values: [
			{ businessMealsInRestaurants: "" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur in 2021 related to promotional activities that are made available to the general public, employer-provided social/recreational expenses or business gifts?",
		values: [
			{ promotionalActivitiesMeals: "" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur in 2021 provided on the employer’s premises for the employer’s convenience?",
		values: [
			{ mealsOnEmployerPremises: "" },
		]
	},
	{
		question: "What are the total other business meal expenses incurred or planning to incur in 2023?",
		values: [
			{ otherBusinessMeals: "" },
		]
	},
]
const BusinessExpensesTPBOStyles = [
	{},
	{
		question: "Have you traveled or are you planning on traveling for business?",
		bool: null,
		valData: [
			{ placeholder: "Automobile miles traveled", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Hotel and lodging costs", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Travel meals (Restaurants only)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Travel meals (Non restaurants)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Travel transportation costs (plane tickets, tolls, etc)", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "Other travel costs",
		valData: [
			{ placeholder: "Other travel costs", styleProp: "col-lg-5 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur related to business meals in restaurants?",
		valData: [
			{ placeholder: "What are the total meal expenses incurred or planning to incur related to business meals in restaurants?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur in {{CURRENT_YEAR}} related to promotional activities that are made available to the general public, employer-provided social/recreational expenses or business gifts?",
		valData: [
			{ placeholder: `What are the total meal expenses incurred or planning to incur in ${new Date().getFullYear() - 3} related to promotional activities that are made available to the general public, employer-provided social/recreational expenses or business gifts?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total meal expenses incurred or planning to incur in {{CURRENT_YEAR}} provided on the employer’s premises for the employer’s convenience?",
		valData: [
			{ placeholder: `What are the total meal expenses incurred or planning to incur in ${new Date().getFullYear() - 3} provided on the employer’s premises for the employer’s convenience?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total other business meal expenses incurred or planning to incur in {{CURRENT_YEAR}}?",
		valData: [
			{ placeholder: `What are the total other business meal expenses incurred or planning to incur in 2021?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// FB
const FringeBenefitsTPBOQuestions = [
	{
		question: "Disability insurance",
		bool: null,
		values: [
			{
				disabilityInsurance: "",
			}
		]
	},
	{
		question: "Group term life insurance",
		bool: null,
		values: [
			{
				groupTermLifeInsurance: "",
			}
		]
	},
	{
		question: "Qualified transportation costs",
		bool: null,
		values: [
			{
				qualifiedTransportationCosts: "",
			}
		]
	},
	{
		question: "Qualified dependent care",
		bool: null,
		values: [
			{
				qualifiedDependentCare: "",
			}
		]
	},
	{
		question: "Working conditions benefits",
		bool: null,
		values: [
			{
				workingConditionsBenefits: "",
			}
		]
	},
	{
		question: "De minimus benefits",
		bool: null,
		values: [
			{
				deMinimusBenefits: "",
			}
		]
	},
	{
		question: "Qualified employee discount programs",
		bool: null,
		values: [
			{
				qualifiedEmployeeDiscountPrograms: "",
			}
		]
	},
	{
		question: "Other fringe benefits costs",
		bool: null,
		values: [
			{
				otherFringeBenefitsCosts: "",
			}
		]
	},
	{
		question: "What are the total annual out-of-pocket business expenses not previously listed (such as copying, mailing, office supplies, etc)?",
		bool: null,
		values: [
			{
				totalAnnualOutOfPocketBusinessExpenses: "",
			}
		]
	}
];
const FringeBenefitsTPBOStyles = [
	{
		question: "Disability insurance",
		bool: null,
		valData: [
			{
				placeholder: "Disability insurance",
				styleProp: "col-lg-6 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	},
	{
		question: "Group term life insurance",
		bool: null,
		valData: [
			{
				placeholder: "Group term life insurance",
				styleProp: "col-lg-6 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	},
	{
		question: "Qualified transportation costs",
		bool: null,
		valData: [
			{
				placeholder: "Qualified transportation costs",
				styleProp: "col-lg-6 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	},
	{
		question: "Qualified dependent care",
		bool: null,
		valData: [
			{
				placeholder: "Qualified dependent care",
				styleProp: "col-lg-6 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	},
	{
		question: "Working conditions benefits",
		bool: null,
		valData: [
			{
				placeholder: "Working conditions benefits",
				styleProp: "col-lg-6 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	},
	{
		question: "De minimus benefits",
		bool: null,
		valData: [
			{
				placeholder: "De minimus benefits",
				styleProp: "col-lg-6 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	},
	{
		question: "Qualified employee discount programs",
		bool: null,
		valData: [
			{
				placeholder: "Qualified employee discount programs",
				styleProp: "col-lg-6 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	},
	{
		question: "Other fringe benefits costs",
		bool: null,
		valData: [
			{
				placeholder: "Other fringe benefits costs",
				styleProp: "col-lg-6 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	},
	{
		question: "What are the total annual out-of-pocket business expenses not previously listed (such as copying, mailing, office supplies, etc)?",
		bool: null,
		valData: [
			{
				placeholder: "What are the total annual out-of-pocket business expenses not previously listed (such as copying, mailing, office supplies, etc)?",
				styleProp: "col-lg-12 col-md-8 col-sm-12",
				mask: "999999999"
			}
		]
	}
];
// Insurance
const InsuranceTPBOQuestions = [
	{
		question: "Does the business pay a portion of the health insurance premium for your employees?",
		bool: null,
		values: [
			{ employeesHealthInsurance: "" }
		]
	},
	{
		question: "What is the average wage of all full time equivalent employees (combined) including yourself and your spouse?",
		values: [
			{ avarageWage: "" }
		]
	},
	{
		question: "What percentage of gross revenue would you like to fund towards your reinsurance company?",
		values: [
			{ percentageOfGrossrevenue: "" },
			{ percentageOfGrossrevenue: "" },
		]
	},
	{
		question: "What is the potential liability amount to be covered by captive insurance? Enter as a positive number?",
		values: [
			{ potentialLiabilityAmount: "" },
			{ potentialLiabilityAmount: "" },
		]
	}
]
// .st
const InsuranceTPBOStyles = [
	{
		question: "Does the business pay a portion of the health insurance premium for your employees?",
		bool: null,
		valData: [
			{ placeholder: "How much does the business pay for employee health insurance annually?", mask: "999999999" }
		]
	},
	{
		question: "What is the average wage of all full time equivalent employees (combined) including yourself and your spouse?",
		valData: [
			{ placeholder: "What is the average wage of all full time equivalent employees (combined) including yourself and your spouse?", mask: "999999999" }
		]
	},
	{
		question: "What percentage of gross revenue would you like to fund towards your reinsurance company?",
		valData: [
			{ placeholder: "Description Of Risk Item", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Potential Liability", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "What is the potential liability amount to be covered by captive insurance? Enter as a positive number?",
		valData: [
			{ placeholder: "Description Of Risk Item", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Potential Liability", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	}
]
// Employees
const EmployeesTPBOQuestions = [
	{
		question: "Do you want to provide employee achievement awards for your staff if there are tax benefits?",
		bool: null,
		values: [
			{ maxAmountYouProvide: "" },
			{ totalEducationExpenses: "" },
		]
	},
	{
		question: "How many total employees do you have, not including yourself or your spouse (if your spouse owns a % of the business)?",
		values: [
			{ totalEmployeesDoYouHave: "" },
		]
	},
];
const EmployeesTPBOStyles = [
	{
		question: "Do you want to provide employee achievement awards for your staff if there are tax benefits?",
		bool: null,
		valData: [
			{ placeholder: "What is the maximum amount you would provide annually for the employee achievement award program? Include total amount for all employees?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: `What are the total education expenses expected to be incurred in ${new Date().getFullYear()}, (you can deduct a maximum of $5,250 for each employee)?`, styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "How many total employees do you have, not including yourself or your spouse (if your spouse owns a % of the business)?",
		valData: [
			{ placeholder: "How many total employees do you have, not including yourself or your spouse (if your spouse owns a % of the business)?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
];
// SaleOfAsset
const SaleofAssetsTPBOQuestions = [
	{
		question: "Do you expect to sell significant business assets for a gain this year?",
		values: [
			{ nameOfAsset: "" },
			{ expectedSellingPrice: "" },
			{ expectedGainsOnSale: "" },
			{ willingToSell: "" },
			{ howMuchWillingToContribute: "" },
			{ howMuchWillingToExchange: "" },
		]
	},
]
const SaleofAssetsTPBOStyles = [
	{
		valData: [
			{ placeholder: "Name of asset", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Expected selling price of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Expected gain on sale of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If willing to sell asset as an installment sale, how many years would you be willing to hold the loan?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much of the gain on the sale would you be willing to contribute to an Opportunity Zone Investment?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If this is real estate, how much would you be willing to exchange into another real estate asset?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
]
// rentalReal
const RentalRealEstateTPBOQuestions = [
	{
		question: "Do you intend to purchase any rental property in the current year (outside of the current property stated in the general section)?",
		bool: null,
		values: [
			{ addressOfRentalProperty: '' },
			{ expectedPurchasePrice: '' },
			{ mortgagePaymentsAnually: '' },
			{ OwnershipOfProperty: '' },
			{ PropertyType: '' },
		]
	},
	{
		question: "Do you intend to sell any rental property in the current year?",
		values: [
			{ expectedSellingPrice: '' },
			{ CostBasisProperty: '' },
			{ TotalDepreciation: '' },
			{ typeOfProperty: '' },
			{ addressOfProperty: "" }
		]
	},
	{
		question: 'Is this property eligible for the Qualified Business Income Deduction (Section 199A)?',
		values: [{ eligibleForTheBusiness: '' }]
	},
	{
		question: "Do you have prior suspended losses on your real estate property and if so, how much is the total prior suspended loss amount? Enter as a positive number.",
		values: [{ suspendedLosses: '' }]

	},
	{
		question: "Did you, or your spouse, spend more than 50% of your time performing real estate related activities?",
		values: [{ spendFiftyPercent: '' }]

	},
	{
		question: "Did you, or your spouse, spend more than 750 hours performing real estate related activities?",
		values: [{ spendSevenFifty: '' }]

	},


]
const RentalRealEstateTPBOStyles = [
	{
		question: "Do you intend to purchase any rental property in the current year (outside of the current property stated in the general section)?",
		valData: [
			{ placeholder: 'Address of Rental Property', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: 'Expected purchase price', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: 'Mortgage payments annually' },
			{ placeholder: '% ownership of property', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: 'Type of property', styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		question: "Do you intend to sell any rental property in the current year?",
		valData: [
			{ placeholder: 'Expected selling price', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: 'Cost basis in the property', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: 'Total depreciation on the property prior to sale', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: 'Type of property', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Address of property" }
		]
	},
	{
		question: 'Is this property eligible for the Qualified Business Income Deduction (Section 199A)?',
		valData: [{ placeholder: 'Is this property eligible for the Qualified Business Income Deduction (Section 199A)?', styleProp: "col-lg-12 col-md-8 col-sm-12" }]
	},
	{
		question: "Do you have prior suspended losses on your real estate property and if so, how much is the total prior suspended loss amount? Enter as a positive number.",
		valData: [{ placeholder: 'Do you have prior suspended losses on your real estate property and if so, how much is the total prior suspended loss amount? Enter as a positive number.', styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }]
	},
	{
		question: "Did you, or your spouse, spend more than 50% of your time performing real estate related activities?",
		valData: [{ placeholder: 'Did you, or your spouse, spend more than 50% of your time performing real estate related activities?', styleProp: "col-lg-12 col-md-8 col-sm-12" }]

	},
	{
		question: "Did you, or your spouse, spend more than 750 hours performing real estate related activities?",
		valData: [{ placeholder: 'Did you, or your spouse, spend more than 750 hours performing real estate related activities?', styleProp: "col-lg-12 col-md-8 col-sm-12" }]

	},
]
// purchaseOfAsset
const PurchaseofAssetsTPBOQuestions = [
	{
		question: 'Do you expect to purchase an asset in the current year?',
		bool: null,
		values: [
			{ assetDescription: '' },
			{ loanLeasePayments: '' },
			{ insurance: '' },
			{ otherAssetExpenses: '' },
			{ usedBusinessPercentage: "" }]
	},
]
const PurchaseofAssetsTPBOStyles = [
	{
		question: 'Do you expect to purchase an asset in the current year?',
		valData: [
			{ placeholder: 'Asset description', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: 'Annual Loan / Lease Payments', styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: 'Annual Insurance (if applicable)', styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: 'Other asset expenses', styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "% used for business (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }]
	},
]
// 
const DepreciationTPBOQuestions = [
	{
		question: "Do you have any qualified improvement property?",
		bool: null,
	},
	{
		question: `Has the taxpayer purchased or is planning to purchase tangible, non-real estate assets in ${new Date().getFullYear()} ?`,
		values: [
			{ purchasePrice: "" },
			{ assetType: "" },
			{ depreciableYears: "" },
			{ maximumAllowableDepriciation: "" },
		]
	},

	// inputs
	{
		question: `What is the approximate value of all real property owned or expected to purchase in ${new Date().getFullYear()}`,
		values: [
			{ approximateValue: "" },
		]
	},
	{
		question: "What is the expected depreciation (without a cost segregation study) in 2023?",
		values: [
			{ expectedDepriciationW: "" },
		]
	},
	{
		question: "What is the expected depreciation after a cost segregation study in 2024?",
		values: [
			{ expectedDepriciation: "" },
		]
	},
	{
		question: `What was the qualified investment property purchase amount in ${new Date().getFullYear() - 4}?`,
		values: [
			{ qualifiedInvestmentProperty: "" },
		]
	},
	{
		question: `What depreciation was taken on the qualified investment property in ${new Date().getFullYear() - 4}?`,
		values: [
			{ depriciationONQualifiedInvestment: "" },
		]
	},
	{
		question: `What was the qualified investment property purchase amount in ${new Date().getFullYear()}?`,
		values: [
			{ purchaseAmount: "" },
		]
	},
	{
		question: `What depreciation was taken on the qualified investment property in ${new Date().getFullYear()}?`,
		values: [
			{ depriciationWasTaken: "" },
		]
	},
]
// .st
const DepreciationTPBOStyles = [
	{},
	{
		question: `Has the taxpayer purchased or is planning to purchase tangible, non-real estate assets in ${new Date().getFullYear()} ?`,
		bool: null,
		valData: [
			{ placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Asset Type", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Asset Total Depreciable Years", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Do you want to take the maximum allowable depreciation in the year you purchased the asset?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	// inputs
	{
		question: `What is the approximate value of all real property owned or expected to purchase in ${new Date().getFullYear()}`,
		valData: [
			{ placeholder: `What is the approximate value of all real property owned or expected to purchase in ${new Date().getFullYear()}`, mask: "999999999" },
		]
	},
	{
		question: "What is the expected depreciation (without a cost segregation study) in 2023?",
		valData: [
			{ placeholder: "What is the expected depreciation (without a cost segregation study) in 2023?" },
		]
	},
	{
		question: "What is the expected depreciation after a cost segregation study in 2024?",
		valData: [
			{ placeholder: "What is the expected depreciation after a cost segregation study in 2024?" },
		]
	},
	{
		question: `What was the qualified investment property purchase amount in ${new Date().getFullYear() - 4}?`,
		valData: [
			{ placeholder: `What was the qualified investment property purchase amount in ${new Date().getFullYear() - 4}?`, mask: "999999999" },
		]
	},
	{
		question: `What depreciation was taken on the qualified investment property in ${new Date().getFullYear() - 4}?`,
		valData: [
			{ placeholder: `What depreciation was taken on the qualified investment property in ${new Date().getFullYear() - 4}?` },
		]
	},
	{
		question: `What was the qualified investment property purchase amount in ${new Date().getFullYear()}?`,
		valData: [
			{ placeholder: `What was the qualified investment property purchase amount in ${new Date().getFullYear()}?`, mask: "999999999" },
		]
	},
	{
		question: `What depreciation was taken on the qualified investment property in ${new Date().getFullYear()}?`,
		valData: [
			{ placeholder: `What depreciation was taken on the qualified investment property in ${new Date().getFullYear()}?` },
		]
	},
]
// International
const InternationalTPBOQuestions = [
	{
		question: `What is the entity's expected net profit or loss in ${new Date().getFullYear()} from export property exclusively?`,
		values: [
			{ expectedNetProfit: "" },
		]
	},
	{
		question: `What is the entity's expected gross revenue in ${new Date().getFullYear()} from export property exclusively?`,
		values: [
			{ expectedGrossRevenue: "" },
		]
	},

]
// .st
const InternationalTPBOStyles = [
	{
		question: `What is the entity's expected net profit or loss in ${new Date().getFullYear()} from export property exclusively?`,
		valData: [
			{ placeholder: `What is the entity's expected net profit or loss in ${new Date().getFullYear()} from export property exclusively?`, mask: "999999999" },
		]
	},
	{
		question: `What is the entity's expected gross revenue in ${new Date().getFullYear()} from export property exclusively?`,
		valData: [
			{ placeholder: `What is the entity's expected gross revenue in ${new Date().getFullYear()} from export property exclusively?`, mask: "999999999" },
		]
	},

]
// TaxPlaningIndividualQuestions
const PersonalInformationTPIQuestions = [
	{
		question: "Are you married?",
		bool: null
	},
	{
		question: "Your first name",
		values: [
			{ firstName: "" }
		]
	},
	{
		question: "Your last name",
		values: [
			{ lastName: "" }
		]
	},

	{
		question: "What is your current filing status?",
		values: [
			{ filingStatus: "" }
		]
	},
	// 4
	{
		question: "Your date of birth",
		values: [
			{ dateOfBirth: new Date() }
		]
	},
	{
		question: "Your Social Security number",
		values: [
			{ ssn: "" }
		]
	},
	{
		question: "Your occupation",
		values: [
			{ occupation: "" }
		]
	},
	{
		question: "Spouse's first name",
		values: [
			{ spouseFirstName: "" }
		]
	},
	{
		question: "Spouse's last name",
		values: [
			{ spouseLastName: "" }
		]
	},
	{
		question: "Spouse's Social Security number",
		values: [
			{ spouseSSN: "" }
		]
	},
	// 10
	{
		question: "Spouse's date of birth",
		values: [
			{ spouseDOB: new Date() }
		]
	},
	{
		question: "Spouse's occupation",
		values: [
			{ spouseOccupation: "" }
		]
	}
];
// .st
const PersonalInformationTPIStyles = [
	{},
	{
		question: "Your first name",
		valData: [
			{ firstName: "", placeholder: "Your first name", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Your last name",
		valData: [
			{ lastName: "", placeholder: "Your last name", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},

	{
		question: "What is your current filing status?",
		valData: [
			{ filingStatus: "", placeholder: "What is your current filing status?", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Your date of birth",
		valData: [
			{ dateOfBirth: "", placeholder: "Your date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Your Social Security number",
		valData: [
			{ ssn: "", placeholder: "Your Social Security number", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Your occupation",
		valData: [
			{ occupation: "", placeholder: "Your occupation", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Spouse's first name",
		valData: [
			{ spouseFirstName: "", placeholder: "Spouse's first name", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Spouse's last name",
		valData: [
			{ spouseLastName: "", placeholder: "Spouse's last name", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Spouse's Social Security number",
		valData: [
			{ spouseSSN: "", placeholder: "Spouse's Social Security number", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Spouse's date of birth",
		valData: [
			{ spouseDOB: new Date(), placeholder: "Spouse's date of birth", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Spouse's occupation",
		valData: [
			{ spouseOccupation: "", placeholder: "Spouse's occupation", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	}
];
// wages
const WagesTPIQuestions = [
	{
		question: "What are your expected total annual wages from businesses you do NOT directly own?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What were your spouse's total annual wages from businesses you do NOT directly own?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
];
// .st
const WagesTPIStyles = [
	{
		question: "What are your expected total annual wages from businesses you do NOT directly own?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What were your spouse's total annual wages from businesses you do NOT directly own?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
];
// 
const DependentChildrenTPIQuestions = [
	{
		question: "Do you have any children?",
		bool: null,
		values: [
			{ name: "" },
			{ DateOfBirth: new Date() },
			{ liveWithoutYou: "" },
			{ studentInCollege: "" },
			{ capableOfEarning: "" },
			{ projectingToEarnYourself: "" },
		]
	},
];
// 
const DependentChildrenTPIStyles = [
	{
		valData: [
			{ placeholder: "Name", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Date of Birth", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Does this dependent child live with you?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Is this dependent child a student in college?", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "How much is this dependent child capable of earning in 2024?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "How much is this dependent child projecting to earn as income in 2024 (not from businesses you directly own)?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
];
// PrimaryResidence
const PrimaryResidenceTPIQuestions = [
	{
		question: "Do you plan to perform work-related tasks at home?",
		bool: null
	},
	{
		question: "Do you have an office outside of your home?",
		bool: null
	},
	{
		question: "Did you move this year?",
		bool: null
	},
	{
		question: "Do you plan to move next year?",
		bool: null
	},
	{
		question: "Your street address?",
		values: [
			{ streetAddress: "", placeholder: "Your street address" }
		]
	},
	{
		question: "Your city?",
		values: [
			{ city: "", placeholder: "Your city" }
		]
	},
	{
		question: "Your state?",
		values: [
			{ state: "", placeholder: "Your state" }
		]
	},
	{
		question: "Your zip code?",
		values: [
			{ zipCode: "", placeholder: "Your zip code" }
		]
	},
	{
		question: "Home office square footage?",
		values: [
			{ homeOfficeSqFt: "", placeholder: "Home office square footage" }
		]
	},
	{
		question: "Home square footage?",
		values: [
			{ homeSqFt: "", placeholder: "Home square footage" }
		]
	},
	{
		question: "Do you rent or own your home?",
		values: [
			{ rentOrOwn: "", placeholder: "Do you rent or own your home?" }
		]
	},
	{
		question: "Annual rent cost?",
		values: [
			{ annualRent: "", placeholder: "Annual rent cost" }
		]
	},
	{
		question: "Annual rental insurance?",
		values: [
			{ rentalInsurance: "", placeholder: "Annual rental insurance" }
		]
	},
	{
		question: "Annual mortgage interest cost?",
		values: [
			{ mortgageInterest: "", placeholder: "Annual mortgage interest cost" }
		]
	},
	{
		question: "Annual property taxes?",
		values: [
			{ propertyTaxes: "", placeholder: "Annual property taxes" }
		]
	},
	{
		question: "Annual home insurance?",
		values: [
			{ homeInsurance: "", placeholder: "Annual home insurance" }
		]
	},
	{
		question: "Annual HOA fees?",
		values: [
			{ hoaFees: "", placeholder: "Annual HOA fees" }
		]
	},
	{
		question: "Annual cleaning (DIY & service) fees?",
		values: [
			{ cleaningFees: "", placeholder: "Annual cleaning (DIY & service) fees" }
		]
	},
	{
		question: "Annual lawn & landscaping (DIY or Service) fees?",
		values: [
			{ lawnFees: "", placeholder: "Annual lawn & landscaping (DIY or Service) fees" }
		]
	},
	{
		question: "Annual pest control fees?",
		values: [
			{ pestControlFees: "", placeholder: "Annual pest control fees" }
		]
	},
	{
		question: "Annual security fees?",
		values: [
			{ securityFees: "", placeholder: "Annual security fees" }
		]
	},
	{
		question: "Annual repairs & maintenance fees?",
		values: [
			{ maintenanceFees: "", placeholder: "Annual repairs & maintenance fees" }
		]
	},
	{
		question: "Annual renovations fees?",
		values: [
			{ renovationFees: "", placeholder: "Annual renovations fees" }
		]
	},
	{
		question: "Annual snow removal fees?",
		values: [
			{ snowRemovalFees: "", placeholder: "Annual snow removal fees" }
		]
	},
	{
		question: "Annual supplies fees?",
		values: [
			{ suppliesFees: "", placeholder: "Annual supplies fees" }
		]
	},
	{
		question: "Annual utilities: internet?",
		values: [
			{ utilitiesInternet: "", placeholder: "Annual utilities: internet" }
		]
	},
	{
		question: "Annual utilities: telephone?",
		values: [
			{ utilitiesTelephone: "", placeholder: "Annual utilities: telephone" }
		]
	},
	{
		question: "Annual utilities: water & sewer?",
		values: [
			{ utilitiesWaterSewer: "", placeholder: "Annual utilities: water & sewer" }
		]
	},
	{
		question: "Annual utilities: gas & oil?",
		values: [
			{ utilitiesGasOil: "", placeholder: "Annual utilities: gas & oil" }
		]
	},
	{
		question: "Annual utilities: electric?",
		values: [
			{ utilitiesElectric: "", placeholder: "Annual utilities: electric" }
		]
	},
	{
		question: "Annual utilities: other expenses?",
		values: [
			{ utilitiesOther: "", placeholder: "Annual utilities: other expenses" }
		]
	},
	{
		question: "Annual home depreciation?",
		values: [
			{ homeDepreciation: "", placeholder: "Annual home depreciation" }
		]
	},
	{
		question: "Expenses that are used 100% in the office itself?",
		values: [
			{ officeExpenses: "", placeholder: "Expenses that are used 100% in the office itself" }
		]
	},
	{
		question: "Annual other home costs?",
		values: [
			{ otherHomeCosts: "", placeholder: "Annual other home costs" }
		]
	},
	{
		question: "Total ANNUAL roundtrip mileage from your home to your office location?",
		values: [
			{ annualMileage: "", placeholder: "Total ANNUAL roundtrip mileage from your home to your office location" }
		]
	},

	{
		question: "Previous state of residence?",
		values: [
			{ previousState: "", placeholder: "Previous state of residence" }
		]
	},
	{
		question: "Do you plan to move next year?",
		values: [
			{ planToMove: "", placeholder: "Do you plan to move next year?" }
		]
	},
	{
		question: "What state do you plan to move to?",
		values: [
			{ futureState: "", placeholder: "What state do you plan to move to?" }
		]
	}
];
// .sttt
const PrimaryResidenceTPIStyles = [
	{},
	{},
	{},
	{},
	{
		valData: [
			{ streetAddress: "", placeholder: "Your street address", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		valData: [
			{ city: "", placeholder: "Your city", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		valData: [
			{ state: "", placeholder: "Your state", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Your zip code?",
		valData: [
			{ zipCode: "", placeholder: "Your zip code", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},

	{
		question: "Home office square footage?",
		valData: [
			{ homeOfficeSqFt: "", placeholder: "Home office square footage", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Home square footage?",
		valData: [
			{ homeSqFt: "", placeholder: "Home square footage", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Do you rent or own your home?",
		valData: [
			{ rentOrOwn: "", placeholder: "Do you rent or own your home?", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Annual rent cost?",
		valData: [
			{ annualRent: "", placeholder: "Annual rent cost", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual rental insurance?",
		valData: [
			{ rentalInsurance: "", placeholder: "Annual rental insurance", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual mortgage interest cost?",
		valData: [
			{ mortgageInterest: "", placeholder: "Annual mortgage interest cost", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual property taxes?",
		valData: [
			{ propertyTaxes: "", placeholder: "Annual property taxes", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual home insurance?",
		valData: [
			{ homeInsurance: "", placeholder: "Annual home insurance", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual HOA fees?",
		valData: [
			{ hoaFees: "", placeholder: "Annual HOA fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual cleaning (DIY & service) fees?",
		valData: [
			{ cleaningFees: "", placeholder: "Annual cleaning (DIY & service) fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual lawn & landscaping (DIY or Service) fees?",
		valData: [
			{ lawnFees: "", placeholder: "Annual lawn & landscaping (DIY or Service) fees", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual pest control fees?",
		valData: [
			{ pestControlFees: "", placeholder: "Annual pest control fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual security fees?",
		valData: [
			{ securityFees: "", placeholder: "Annual security fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual repairs & maintenance fees?",
		valData: [
			{ maintenanceFees: "", placeholder: "Annual repairs & maintenance fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual renovations fees?",
		valData: [
			{ renovationFees: "", placeholder: "Annual renovations fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual snow removal fees?",
		valData: [
			{ snowRemovalFees: "", placeholder: "Annual snow removal fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual supplies fees?",
		valData: [
			{ suppliesFees: "", placeholder: "Annual supplies fees", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual utilities: internet?",
		valData: [
			{ utilitiesInternet: "", placeholder: "Annual utilities: internet", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual utilities: telephone?",
		valData: [
			{ utilitiesTelephone: "", placeholder: "Annual utilities: telephone", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual utilities: water & sewer?",
		valData: [
			{ utilitiesWaterSewer: "", placeholder: "Annual utilities: water & sewer", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual utilities: gas & oil?",
		valData: [
			{ utilitiesGasOil: "", placeholder: "Annual utilities: gas & oil", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual utilities: electric?",
		valData: [
			{ utilitiesElectric: "", placeholder: "Annual utilities: electric", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual utilities: other expenses?",
		valData: [
			{ utilitiesOther: "", placeholder: "Annual utilities: other expenses", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual home depreciation?",
		valData: [
			{ homeDepreciation: "", placeholder: "Annual home depreciation", mask: "999999999" }
		]
	},
	{
		question: "Expenses that are used 100% in the office itself?",
		valData: [
			{ officeExpenses: "", placeholder: "Expenses that are used 100% in the office itself", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Annual other home costs?",
		valData: [
			{ otherHomeCosts: "", placeholder: "Annual other home costs", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "Total ANNUAL roundtrip mileage from your home to your office location?",
		valData: [
			{ annualMileage: "", placeholder: "Total ANNUAL roundtrip mileage from your home to your office location", styleProp: "col-lg-12 col-md-8 col-sm-12" }
		]
	},
	{
		question: "Previous state of residence?",
		valData: [
			{ previousState: "", placeholder: "Previous state of residence", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{
		question: "What state do you plan to move to?",
		valData: [
			{ futureState: "", placeholder: "What state do you plan to move to?", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	}
];
// secondary residence
const SecondaryResidenceTPIQuestions = [
	{
		question: "Do you own a vacation property or second home for personal use?",
		bool: null,
		values: [{ addressI: "" }, { propertyTypeI: "" }, { Mortgage: "" }, { TotalAnuualMortageAmount: "" }]
	},
	{
		question: "Have you purchased or acquired an interest in any rental real estate since your last tax return?",
		bool: null,
		values: [{ addressII: "" }, { propertyTypeII: "" }, { PurchasePriceI: "" }, { OwnershipI: "" }]
	},
	{
		question: "Do you intend to purchase or acquire interest in any rental real estate in the next 24 months?",
		bool: null,
		values: [{ addressIII: "" }, { propertyTypeIII: "" }, { PurchasePriceII: "" }, { OwnershipII: "" }]
	}
]
const SecondaryResidenceTPIStyles = [
	{
		valData: [{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Mortgage", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Total annual mortgage amount", mask: "999999999", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }, { placeholder: "Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	},
	{
		valData: [{ placeholder: "Address", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Type of Property?", styleProp: "col-lg-6 col-md-8 col-sm-12" }, { placeholder: "Purchase Price", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }, { placeholder: "Ownership", styleProp: "col-lg-6 col-md-8 col-sm-12" }]
	}
]
const HealthAndMedicalTPIQuestions = [
	{
		question: "What are your expected family medical insurance premiums in 2024?",
		values: [
			{
				familyMedicalInsurancePremiums: "",
			}
		]
	},
	{
		question: "What are your expected total family medical out-of-pocket expenses in 2024?",
		values: [
			{
				familyMedicalOutOfPocketExpenses: "",
			}
		]
	},
	{
		question: "What are your expected family medical copays?",
		values: [
			{
				familyMedicalCopays: "",
			}
		]
	},
	{
		question: "What are your expected family disability insurance premiums?",
		values: [
			{
				familyDisabilityInsurancePremiums: "",
			}
		]
	},
	{
		question: "What are your expected family long term care premiums?",
		values: [
			{
				familyLongTermCarePremiums: "",
			}
		]
	},
	{
		question: "What are your other unreimbursed medical expenses?",
		values: [
			{
				unreimbursedMedicalExpenses: "",
			}
		]
	}
];
const HealthAndMedicalTPIStyles = [
	{
		question: "What are your expected family medical insurance premiums in 2024?",
		valData: [
			{
				placeholder: "What are your expected family medical insurance premiums in 2024?",
				mask: "999999999"
			}
		]
	},
	{
		question: "What are your expected total family medical out-of-pocket expenses in 2024?",
		valData: [
			{
				placeholder: "What are your expected total family medical out-of-pocket expenses in 2024?",
				mask: "999999999"
			}
		]
	},
	{
		question: "What are your expected family medical copays?",
		valData: [
			{
				placeholder: "What are your expected family medical copays?",
				mask: "999999999"
			}
		]
	},
	{
		question: "What are your expected family disability insurance premiums?",
		valData: [
			{
				placeholder: "What are your expected family disability insurance premiums?",
				mask: "999999999"
			}
		]
	},
	{
		question: "What are your expected family long term care premiums?",
		valData: [
			{
				placeholder: "What are your expected family long term care premiums?",
				mask: "999999999"
			}
		]
	},
	{
		question: "What are your other unreimbursed medical expenses?",
		valData: [
			{
				placeholder: "What are your other unreimbursed medical expenses?",
				mask: "999999999"
			}
		]
	}
];
// Charity
const CharityTPIQuestions = [
	{
		question: "What is the total value of your non productive land not owned by your business?",
		values: [
			{
				valueOfNonProductiveLand: "",
			}
		]
	},
	{
		question: "What is the total gift amount you would be willing to give to charity in 2024?",
		values: [
			{
				totalGiftAmount: "",
			}
		]
	},
	{
		question: "What is your expected charitable AGI limitation?",
		values: [
			{
				expectedCharitableAGI: "",
			}
		]
	},
];
const CharityTPIStyles = [
	{
		valData: [
			{
				placeholder: "What is the total value of your non productive land not owned by your business?",
				mask: "999999999"
			}
		]
	},
	{
		valData: [
			{
				placeholder: "What is the total gift amount you would be willing to give to charity in 2024?",
				mask: "999999999"
			}
		]
	},
	{
		valData: [
			{
				placeholder: "What is your expected charitable AGI limitation?",
				mask: "999999999"
			}
		]
	},
];
// RetirementPlans
const RetirementPlansTPIQuestions = [
	{
		question: "Do you or your spouse have any personal (not from businesses you own) retirement plans currently in place?",
		bool: null,
		values: [
			{ typeOfAccount: "" },
			{ Custodian: "" },
			{ currentValue: "" },
			{ currentYearContribution: "" },
		]
	},
	// inputs fields
	{
		question: "At what age do you plan to retire?",
		values: [{ agePlanToRetire: "" }]
	},
	{
		question: "How much have you saved for retirement in total?",
		values: [{ totalRetirementSavings: "" }]
	},
	{
		question: "How much do you plan to contribute to your retirement plan annually?",
		values: [{ annualPersonalContribution: "" }]
	},
	{
		question: "What do you think your annual investment return will be?",
		values: [{ expectedAnnualReturn: "" }]
	},
	{
		question: "At what age does your spouse plan to retire?",
		values: [{ spouseAgePlanToRetire: "" }]
	},
	{
		question: "How much does your spouse have saved for retirement in total?",
		values: [{ spouseTotalSavings: "" }]
	},
	{
		question: "How much do you plan to contribute to a retirement plan for your spouse annually?",
		values: [{ spouseAnnualPersonalContribution: "" }]
	},
]
const RetirementPlansTPIStyles = [
	{
		valData: [
			{ placeholder: "Type of Account", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Custodian", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date" },
			{ placeholder: "Current Value", styleProp: "col-lg-6 col-md-8 col-sm-12", type: "Date" },
			{ placeholder: "Current Year Contribution", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	// inputs fields
	{
		question: "At what age do you plan to retire?",
		valData: [{ placeholder: "At what age do you plan to retire?", mask: "999999999" }]
	},
	{
		question: "How much have you saved for retirement in total?",
		valData: [{ placeholder: "How much have you saved for retirement in total?", mask: "999999999" }]
	},
	{
		question: "How much do you plan to contribute to your retirement plan annually?",
		valData: [{ placeholder: "How much do you plan to contribute to your retirement plan annually?", mask: "999999999" }]
	},
	{
		question: "What do you think your annual investment return will be?",
		valData: [{ placeholder: "What do you think your annual investment return will be?", mask: "999999999" }]
	},
	{
		question: "At what age does your spouse plan to retire?",
		valData: [{ placeholder: "At what age does your spouse plan to retire?", mask: "999999999" }]
	},
	{
		question: "How much does your spouse have saved for retirement in total?",
		valData: [{ placeholder: "How much does your spouse have saved for retirement in total?", mask: "999999999" }]
	},
	{
		question: "How much do you plan to contribute to a retirement plan for your spouse annually?",
		valData: [{ placeholder: "How much do you plan to contribute to a retirement plan for your spouse annually?", mask: "999999999" }]
	},
]
// SalesOfAssets
const SalesOfAssetsTPIQuestions = [
	{
		question: "Do you expect to sell significant assets for a gain this year (not related to a business you own)?",
		values: [
			{ nameOfAsset: "" },
			{ expectedSellingPrice: "" },
			{ expectedGainsOnSale: "" },
			{ willingToSell: "" },
			{ howMuchWillingToContribute: "" },
			{ howMuchWillingToExchange: "" },
		]
	},
	{
		question: "What is the total gain on your sale of all assets?",
		values: [
			{ gainOnYourSaleOfAsset: "", placeholder: "What is the total gain on your sale of all assets?" },
		]
	},
	{
		question: "Are you transferring these assets before a letter of intent for the sale of the asset has been signed?",
		values: [
			{ assetSigned: "", placeholder: "Are you transferring these assets before a letter of intent for the sale of the asset has been signed?" },
		]
	},
	{
		question: "How much cash from the sale would you like to keep for personal use?",
		values: [
			{ cashKeepForPersonalUse: "", placeholder: "How much cash from the sale would you like to keep for personal use?" },
		]
	},
	{
		question: "What is the expected limited partner percentage (interest allocated to charity)?",
		values: [
			{ expectedLimitedPartnerPercentage: "", placeholder: "What is the expected limited partner percentage (interest allocated to charity)?" },
		]
	},
	{
		question: "What is the calculated independent asset valuation percentage?",
		values: [
			{ calculatedIndependentAsset: "", placeholder: "What is the calculated independent asset valuation percentage?" },
		]
	},
	{
		question: "How much additional cash do you want to contribute to the Family Endowment (not included the gain on sale of asset)?",
		values: [
			{ additionalCashToContribute: "", placeholder: "How much additional cash do you want to contribute to the Family Endowment (not included the gain on sale of asset)?" },
		]
	},
	{
		question: "What is the total appreciated asset amount you wish to contribution to the Family Endowment (not included the gain on sale of asset; this may include appreciated stock, or real estate)?",
		values: [
			{ totalAppriciatedAsset: "", placeholder: "What is the total appreciated asset amount you wish to contribution to the Family Endowment (not included the gain on sale of asset; this may include appreciated stock, or real estate)?" },
		]
	},
]
const SalesOfAssetsTPIStyles = [
	{
		valData: [
			{ placeholder: "Name of asset", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Expected selling price of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "Expected gain on sale of asset", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If willing to sell asset as an installment sale, how many years would you be willing to hold the loan?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "How much of the gain on the sale would you be willing to contribute to an Opportunity Zone Investment?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "If this is real estate, how much would you be willing to exchange into another real estate asset?", styleProp: "col-lg-12 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total gain on your sale of all assets?",
		valData: [
			{ placeholder: "What is the total gain on your sale of all assets?" },
		]
	},
	{
		question: "Are you transferring these assets before a letter of intent for the sale of the asset has been signed?",
		valData: [
			{ placeholder: "Are you transferring these assets before a letter of intent for the sale of the asset has been signed?" },
		]
	},
	{
		question: "How much cash from the sale would you like to keep for personal use?",
		valData: [
			{ placeholder: "How much cash from the sale would you like to keep for personal use?" },
		]
	},
	{
		question: "What is the expected limited partner percentage (interest allocated to charity)?",
		valData: [
			{ placeholder: "What is the expected limited partner percentage (interest allocated to charity)?" },
		]
	},
	{
		question: "What is the calculated independent asset valuation percentage?",
		valData: [
			{ placeholder: "What is the calculated independent asset valuation percentage?" },
		]
	},
	{
		question: "How much additional cash do you want to contribute to the Family Endowment (not included the gain on sale of asset)?",
		valData: [
			{ placeholder: "How much additional cash do you want to contribute to the Family Endowment (not included the gain on sale of asset)?" },
		]
	},
	{
		question: "What is the total appreciated asset amount you wish to contribution to the Family Endowment (not included the gain on sale of asset; this may include appreciated stock, or real estate)?",
		valData: [
			{ placeholder: "What is the total appreciated asset amount you wish to contribution to the Family Endowment (not included the gain on sale of asset; this may include appreciated stock, or real estate)?" },
		]
	},
]
// purchaseOfAssets
const PurchaseOfAssetTPIQuestions = [
	{
		question: "Did you purchase an asset in the current year?",
		bool: null,
		values: [
			{ assetDescription: "" },
			{ loanLeasePayments: "" },
			{ insurance: "" },
			{ otherAssetExpenses: "" },
			{ percentUsedForBusiness: "" },
		]
	},
]
const PurchaseOfAssetTPIStyles = [
	{
		valData: [
			{ placeholder: 'Asset description', styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Loan/Lease payments", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Insurance (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "Other asset expenses", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "% used for business (if applicable)", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
const OtherIncomeTPIQuestions = [
	{
		question: "What is your total taxable INTEREST income?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are your total ordinary dividends from businesses you do NOT directly own?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What portion of dividends are qualified dividends from businesses you do NOT directly own?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are your total taxable IRA distributions?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is your total taxable pension?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are your total taxable Social Security benefits?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are your total state and local taxable refunds?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is your total alimony received?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are your total other gains and losses from businesses you do NOT directly own?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is your total unemployment income?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is your total estates and trusts income?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is your total taxable other income from businesses you do NOT directly own?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
]
const OtherIncomeTPIStyles = [
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
	{
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// CapitalGainsTPIQuestions
const CapitalGainsTPIQuestions = [
	{
		question: "What are your expected gains from the sale of securities in future year?",
		values: [
			{
				expectedGainsSaleSecurities2024: "",
			}
		]
	},
	{
		question: "How much of the gains on the sale would you be willing to contribute to an opportunity zone investment?",
		values: [
			{
				gainsContributionOpportunityZone: "",
			}
		]
	},
	{
		question: "What were your gains from the sale of securities in 2020?",
		values: [
			{
				gainsSaleSecurities2020: "",
			}
		]
	},
	{
		question: "What are your expected unrealized losses from securities in 2024? Enter as a positive number.",
		values: [
			{
				expectedUnrealizedLosses2024: "",
			}
		]
	}
];
// .st
const CapitalGainsTPIStyles = [
	{
		question: "What are your expected gains from the sale of securities in future year?",
		valData: [
			{
				placeholder: "What are your expected gains from the sale of securities in future year?",
				mask: "999999999"
			}
		]
	},
	{
		question: "How much of the gains on the sale would you be willing to contribute to an opportunity zone investment?",
		valData: [
			{
				placeholder: "How much of the gains on the sale would you be willing to contribute to an opportunity zone investment?",
				mask: "999999999"
			}
		]
	},
	{
		question: "What were your gains from the sale of securities in prior year?",
		valData: [
			{
				placeholder: "What were your gains from the sale of securities in prior year?",
				mask: "999999999"
			}
		]
	},
	{
		question: "What are your expected unrealized losses from securities in 2024? Enter as a positive number.",
		valData: [
			{
				placeholder: "What are your expected unrealized losses from securities in 2024? Enter as a positive number.",
				mask: "999999999"
			}
		]
	}
];
// OtherDeductions
const otherDeductionTPIQuestions = [
	{
		question: "What are the total educator expenses?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are the total unreimbursed business expenses?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are the total health savings account expenses?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are the total moving expenses?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is the total penalty on early withdrawal of savings?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is the total alimony paid?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is the total IRA deduction?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What is the total student loan interest deduction?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are the total tuition and fees NOT already deducted from a business you directly own?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	},
	{
		question: "What are the total other adjustments?",
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" },
		]
	}
];

const otherDeductionsTPIStyles = [
	{
		question: "What are the total educator expenses?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total unreimbursed business expenses?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total health savings account expenses?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total moving expenses?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total penalty on early withdrawal of savings?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total alimony paid?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total IRA deduction?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What is the total student loan interest deduction?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total tuition and fees NOT already deducted from a business you directly own?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	},
	{
		question: "What are the total other adjustments?",
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
		]
	}
]
// OILandGas
const OilAndGasTPIQuestions = [
	// INTERNATIONAL
	{
		question: "Would you be willing to move to Puerto Rico or the U.S. Virgin Islands if that move resulted in substantial tax savings?",
		bool: null,
	},
	// OIL
	{
		question: "Are you interested in investing in oil and gas?",
		bool: null,
		values: [
			{ totalCapitalInvestmentAmount: "", placeholder: `What is the total capital investment amount you would be willing to invest in an oil & gas company in 2021` },
			{ assumedPercentageOfInitialCapitalInvestmentIntangible: "", placeholder: "What the assumed percentage of initial capital investment will be allocated towards intangible drilling costs (IDCs)?" },
			{ assumedPercentageOfInitialCapitalInvestmentTangible: "", placeholder: "What is the assumed percentage of initial capital investment will be allocated towards tangible depreciable expenses?" },
		]
	},
	// Net Operating Losses
	{
		question: `Filing status in ${new Date().getFullYear() - 1}`,
		values: [
			{ fillingStatusOne: "" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 1}`,
		values: [
			{ taxableIncomeOne: "" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 2}`,
		values: [
			{ taxOne: "" }
		],
	},
	{
		question: `Filing status in ${new Date().getFullYear() - 2}`,
		values: [
			{ fillingStatusTwo: "" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 2}`,
		values: [
			{ taxableIncomeTwo: "" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 2}`,
		values: [
			{ taxTwo: "" }
		],
	},
	{
		question: `Filing status in ${new Date().getFullYear() - 3}`,
		values: [
			{ fillingStatusThree: "" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 3}`,
		values: [
			{ taxableIncomeThree: "" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 3}`,
		values: [
			{ taxThree: "" }
		],
	},
	{
		question: `Filing status in ${new Date().getFullYear() - 4}`,
		values: [
			{ fillingStatusFour: "" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 4}`,
		values: [
			{ taxableIncomeFour: "" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 4}`,
		values: [
			{ taxFour: "" }
		],
	},
	{
		question: `Filing status in ${new Date().getFullYear() - 5}`,
		values: [
			{ fillingStatus: "" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 5}`,
		values: [
			{ taxableIncome: "" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 5}`,
		values: [
			{ tax: "" }
		],
	},
];

const OilAndGasTPIStyles = [
	{},
	{
		valData: [
			{ placeholder: `What is the total capital investment amount you would be willing to invest in an oil & gas company in ${new Date().getFullYear()}?`, styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "What the assumed percentage of initial capital investment will be allocated towards intangible drilling costs (IDCs)?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
			{ placeholder: "What is the assumed percentage of initial capital investment will be allocated towards tangible depreciable expenses?", styleProp: "col-lg-12 col-md-8 col-sm-12" },
		]
	},
	// Net Operating Losses
	{
		question: `Filing status in ${new Date().getFullYear() - 1}`,
		valData: [
			{ placeholder: `Filing status in ${new Date().getFullYear() - 1}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 1}`,
		valData: [
			{ placeholder: `Taxable income in ${new Date().getFullYear() - 1}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 2}`,
		valData: [
			{ placeholder: `Tax in ${new Date().getFullYear() - 2}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Filing status in ${new Date().getFullYear() - 2}`,
		valData: [
			{ placeholder: `Filing status in ${new Date().getFullYear() - 2}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 2}`,
		valData: [
			{ placeholder: `Taxable income in ${new Date().getFullYear() - 3}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 2}`,
		valData: [
			{ placeholder: `Tax in ${new Date().getFullYear() - 3}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	// 
	{
		question: `Filing status in ${new Date().getFullYear() - 3}`,
		valData: [
			{ placeholder: `Filing status in ${new Date().getFullYear() - 4}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 3}`,
		valData: [
			{ placeholder: `Taxable income in ${new Date().getFullYear() - 4}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 3}`,
		valData: [
			{ placeholder: `Tax in ${new Date().getFullYear() - 5}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Filing status in ${new Date().getFullYear() - 4}`,
		valData: [
			{ placeholder: `Filing status in ${new Date().getFullYear() - 5}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Taxable income in ${new Date().getFullYear() - 4}`,
		valData: [
			{ placeholder: `Taxable income in ${new Date().getFullYear() - 6}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 4}`,
		valData: [
			{ placeholder: `Tax in ${new Date().getFullYear() - 6}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Filing status in ${new Date().getFullYear() - 5}`,
		valData: [
			{ placeholder: `Filing status in ${new Date().getFullYear() - 6}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	// 
	{
		question: `Taxable income in ${new Date().getFullYear() - 5}`,
		valData: [
			{ placeholder: `Taxable income in ${new Date().getFullYear() - 7}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
	{
		question: `Tax in ${new Date().getFullYear() - 5}`,
		valData: [
			{ placeholder: `Tax in ${new Date().getFullYear() - 7}`, styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		],
	},
]
// BNCL
// to check this first question********************
const BusinessIncomeBNCLQuestions = [
	{
		question: "Do you use an accounting software for your business's financials?",
		bool: null,
		values: [
			{}
		]
	},
	{
		question: "Do you have your own P&L or Balance Sheet for this business?",
		bool: null,
	},
	{
		question: "Gross receipts or sales",
		values: [
			{ grossReceipts: "", placeholder: "Gross receipts or sales" },
		]
	},
	{
		question: "Returns and allowances",
		values: [
			{ Description: "", placeholder: "Description" },
			{ amount: "", placeholder: "amount" },
		]
	},
]
const BusinessIncomeBNCLStyles = [
	{
		valData: [
			{ placeholder: "What accounting software do you use?", styleProp: "col-lg-6 col-md-8 col-sm-12" }
		]
	},
	{},
	{
		question: "Gross receipts or sales",
		valData: [
			{ grossReceipts: "", placeholder: "Gross receipts or sales" },
		]
	},
	{
		question: "Returns and allowances",
		valData: [
			{ Description: "", placeholder: "Description", styleProp: "col-lg-6 col-md-8 col-sm-12" },
			{ amount: "", placeholder: "amount", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	},
]
// <<<<<<<<
const ShareHolderIncomeBNCLQuestions = [
	{
		question: "What is the entity's expected gross revenue?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What is the entity's expected net profit or loss?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected W-2 wages (from this business)? Note: If you did not receive W-2 wages as a Schedule C entity, enter $0.?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected dividends on form 1099-DIV (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your expected guaranteed payments on Form K-1 (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "How much of your cash compensation (wages, distributions, dividends, etc) do you need (from this business) annually in order to maintain your lifestyle?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected W-2 wages (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected dividends on form 1099-DIV (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What are your spouse's expected guaranteed payments on Form K-1 (from this business)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "What is the total expected owners compensation including taxes for all OTHER owners (not including you or your spouse)?",
		bool: null,
		values: [
			{ twentyTwentyTwo: "" },
			{ twentyTwentyThree: "" },
			{ twentyTwentyFour: "" }
		]
	},
	{
		question: "W-2 Income",
		values: [
			{ w2Income: "" },
		]
	}
];


const ShareHolderIncomeBNCLStyles = [
	{
		question: "What is the entity's expected gross revenue?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What is the entity's expected net profit or loss?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected W-2 wages (from this business)? Note: If you did not receive W-2 wages as a Schedule C entity, enter $0.?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected dividends on form 1099-DIV (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your expected guaranteed payments on Form K-1 (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "How much of your cash compensation (wages, distributions, dividends, etc) do you need (from this business) annually in order to maintain your lifestyle?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected W-2 wages (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected dividends on form 1099-DIV (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What are your spouse's expected guaranteed payments on Form K-1 (from this business)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "What is the total expected owners compensation including taxes for all OTHER owners (not including you or your spouse)?",
		bool: null,
		valData: [
			{ placeholder: "2022", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2023", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" },
			{ placeholder: "2024", styleProp: "col-lg-6 col-md-8 col-sm-12", mask: "999999999" }
		]
	},
	{
		question: "W-2 Income",
		valData: [
			{ placeholder: "w-2 Income", styleProp: "col-lg-6 col-md-8 col-sm-12" },
		]
	}
];
// MISC
const MiscellaneousBNCLQuestions = [
	{
		question: "Is this the final year of filing?",
		bool: null
	},
	{
		question: "Did you receive a PPP loan?",
		bool: null
	},
	{
		question: "Was your PPP loan forgiven?",
		bool: null
	},
]
export const GLOBAL_VARIABLES = {
	prefix,
	taxProExpertises,
	usStates,
	entityType,
	addressType,
	PartnerType,
	Options1040,
	Options1065,
	Options1120C,
	StatusOption,
	otherLivings,
	FormNames1065,
	assetsOptions,
	FormNames1040,
	Options1120S,
	FormNames1120S,
	FormNames1120C,
	otherQuestions,
	expensesSummary,
	DocumentOptions,
	expensesOptions,
	relationShipType,
	durationLiveWith,
	LifeEventOptions,
	insuranceOptions,
	possibleExpenses,
	deductionOptions,
	DependentsOptions,
	IncomeSourcesList,
	refundBankDetails,
	ShareHolderOptions,
	accountingPeriods,
	incomeInformation,
	accountingMethods,
	LiabilitiesOptions,
	refundAccountNature,
	SimpleChoiceOptions,
	identificationOption,
	estimateTaxesOptions,
	refundPaymentOptions,
	FinancialEventOptions,
	otherQuestionsOptions,
	refundPaymentOptions1,
	costOfGoodSaleOptions,
	federalPaymentsOptions,
	refundAccountHolderType,
	possibledeductionOptions,
	PartnerInformationOption,
	goodsSalesMethodsOptions,
	OfficerApplicableOptions,
	Options1065QuestionsPart1,
	Options1065QuestionsPart2,
	DependentPersonAppliedOptions,
	refundAccountHolderNationality,
	OptionsTaxPlanningIndividual,
	OptionsTaxPreperationIndividualCurrentClientShort,
	OptionsTaxPreperationIndividualCurrentClientLong,
	OptionsForTaxPlanningIndividual,
	businessGeneralFinancesOptions,
	businessExpencesDescAmount,
	businessExpencesStateDesc,
	bIncome,
	retirementOptions,
	TaxPaymentRefundData,
	BusinessVehiclesData,
	DDEntityType,
	employeesOptions,
	covid19Options,
	fringeOptions,
	insuranceInputs,
	insuranceRadioOptions,
	futurePartners,
	BusinessVehiclesAnswers,
	BusinessVehiclesAnswersStyles,
	BusinessVehiclesRadioAnswers,
	SalesAssetsAnswers,
	PurchaseAssetsAnswers,
	CorporateCSCorpAnswers,
	CSCorpAnswers,
	PartnerShipAnswers,
	SoleProprietorshipBoolAnswers,
	SoleProprietorshipAnswers,
	FuturePartnerShareholderAnswers,
	RentalEstateRoyaltyIncomeAnswers,
	businessIncome,
	depreciationRadioOptions,
	PersonalInformationAnswers,
	PersonalInformationAnswersStyles,
	dependentAnswers,
	PrimaryResidenceAnswers,
	PrimaryResidenceAnswersStyles,
	SecondaryResidenceAnswers,
	SecondaryResidenceAnswersStyles,
	incomeDetailsBool,
	incomeDetailsBoolStyles,
	interestIncomeDetailsBool,
	interestIncomeDetailsBoolStyles,
	dividentIncomeDetailsBool,
	dividentIncomeDetailsBoolStyles,
	foreignAccountsDetailBool,
	foreignAccountsDetailBoolStyles,
	otherIncomeDetailBool,
	otherIncomeDetailBoolStyles,
	RetirementPlansBool,
	HealthAndMedicalFields,
	HealthAndMedicalFieldsStyles,
	otherDeductionSummaryFields,
	otherDeductionSummaryFieldsStyles,
	otherAdjustmentBool,
	itemizedDeductionsDetail,
	realEstateTaxes,
	realEstateTaxesStyles,
	educationalExpenses,
	additionalQuestions,
	additionalQuestionsStyles,
	otherCreditsFields,
	otherCreditsFieldsStyles,
	federalPriorYear,
	federalPriorYearStyles,
	FormNamesTaxPlanningIndividual,
	OptionsTaxPreperationIndividualCurrentClientShortFormNames,
	OptionsTaxPreperationIndividualCurrentClientLongFormNames,
	OptionsTaxPreperationIndividualNewClientShort,
	OptionsTaxPreperationIndividualNewClientShortFormNames,
	OptionsTaxPreperationIndividualNewClientLong,
	OptionsTaxPreperationIndividualNewClientLongFormNames,
	OptionsTaxPreperationQuestionnaireBusinessCurrentClientShort,
	OptionsTaxPreperationQuestionnaireBusinessCurrentClientShortFormNames,
	OptionsTaxPreperationQuestionnaireBusinessNewClientShort,
	OptionsTaxPreperationQuestionnaireBusinessNewClientShortFormNames,
	OptionsTaxPreperationQuestionnaireBusinessCurrentClientLong,
	OptionsTaxPreperationQuestionnaireBusinessCurrentClientLongFormNames,
	OptionsTaxPreperationQuestionnaireBusinessNewClientLong,
	OptionsTaxPreperationQuestionnaireBusinessNewClientLongFormNames,
	TaxPlaningIndividual,
	TaxPlaningIndividualFormNames,
	TaxPlanningBusinessOwner,
	TaxPlanningBusinessOwnerFormNames,
	// BusinessVehiclesQuestions
	PersonalInformationAnswers_Long,
	PersonalInformationAnswersStyles_Long,
	DependentsStyles_Long,
	Dependents_Long,
	PrimaryResidence_Long,
	PrimaryResidenceStyles_Long,
	SecondaryResidence_Long,
	SecondaryResidenceStyles_Long,
	WagesSummary_Long,
	WagesSummaryStyles_Long,
	IncomeDetails_Long,
	IncomeDetailsStyles_Long,
	OtherIncomeSummary_Long,
	OtherIncomeSummaryStyles_Long,
	InterestIncomeDetails_Long,
	IntersetIncomeDetailsStyles_Long,
	DividendIncomeDetails_Long,
	DividendIncomeDetailsStyles_Long,
	ForeignAccountsDetails_Long,
	ForeignAccountsDetailsStyles_Long,
	OtherIncomeDetails_Long,
	OtherIncomeDetailsStyles_Long,
	CapitalGainQuestions_Long,
	CapitalGainQuestionsStyles_Long,
	IncomeFromPartnerships_Long,
	IncomeFromPartnershipsStyles_Long,
	RetirementPlans_Long,
	RetirementPlansStyles_Long,
	HealthAndMedical_Long,
	HealthAndMedicalStyles_Long,
	otherDeductionSummaryFields_Long,
	otherDeductionSummaryStyles_Long,
	otherAdjustmentsDetails_Long,
	otherAdjustmentsDetailsStyles_Long,
	ItemizedDeductionDetail_Long,
	ItemizedDeductionDetailStyles_Long,
	IntangibleTaxDetail_Long,
	IntangibleTaxDetailStyles_Long,
	IncomeTaxPreparationFees_Long,
	IncomeTaxPreparationFeesStyles_Long,
	EducationalExpenses_Long,
	EducationalExpensesStyles_Long,
	SalesOfAssets_Long,
	SalesOfAssetsStyles_Long,
	PurchaseOfAsset_Long,
	PurchaseOfAssetStyles_Long,
	Charity_Long,
	CharityStyles_Long,
	OtherCredits_Long,
	OtherCreditsStyles_Long,
	QBID_Long,
	QBIDStyles_Long,
	OilAndGas_Long,
	OilAndGasStyles_Long,
	International_Long,
	InternationalStyles_Long,
	NetOperatingLosses_Long,
	NetOperatingLossesStyles_Long,
	AssetProtection_Long,
	AssetProtectionStyles_Long,
	AdditionalQuestions_Long,
	AdditionalQuestionsStyles_Long,
	PersonalInformation_individualNewClientShort,
	PersonalInformation_individualNewClientShort_Styles,
	Dependent_individualNewClientShort,
	Dependent_individualNewClientShort_Styles,
	PrimaryResidence_individualNewClientShort,
	PrimaryResidence_individualNewClientShort_Styles,
	SecondaryResidence_individualNewClientShort,
	SecondaryResidence_individualNewClientShort_Styles,
	IncomeDetails_individualNewClientShort,
	IncomeDetails_individualNewClientShort_Styles,
	InterestDetails_individualNewClientShort,
	InterestDetails_individualNewClientShort_Styles,
	DividendIncomeDetails_individualNewClientShort,
	DividendIncomeDetails_individualNewClientShort_Styles,
	ForeignAccountDetails_individualNewClientShort,
	ForeignAccountDetails_individualNewClientShort_Styles,
	OtherIncomeDetails_individualNewClientShort,
	OtherIncomeDetails_individualNewClientShort_Styles,
	RetirementPlans_individualNewClientShort,
	healthAndMedical_individualNewClientShort,
	healthAndMedical_individualNewClientShort_Styles,
	OtherDeductionsSummary_individualNewClientShort,
	OtherDeductionsSummary_individualNewClientShort_Styles,
	OtherAdjustmentDetail_individualNewClientShort,
	ItemizedDeduction_individualNewClientShort,
	ItemizedDeduction_individualNewClientShort_Styles,
	EducationalExpenses_individualNewClientShort,
	OtherCredits_individualNewClientShort,
	OtherCredits_individualNewClientShort_Styles,
	AdditionalQuestions_individualNewClientShort,
	AdditionalQuestions_individualNewClientShort_Styles,
	PersonalInformationAnswers_newClientLong,
	PersonalInformationAnswersStyles_newClientLong,
	PriorYearTaxReturnAnswers_newClientLong,
	PriorYearTaxReturnStyles_newClientLong,
	DependentsNewClient_Long,
	DependentsNewClientStyles_Long,
	// 
	GeneralInformationBCCShort,
	GeneralInformationBCCShortStyles,
	BusinessFinancialsBCCShort,
	BusinessFinancialsBCCShortStyles,
	SaleOfAssetBCCShort,
	SaleOfAssetBCCShortStyles,
	PurchaseOfAssetBCCShort,
	PurchaseOfAssetBCCShortStyles,
	MiscellaneousBCCShort,
	PriorYearTaxReturnAnswers_BusinessNewClientShort,
	PriorYearTaxReturnStyles_BusinessNewClientShort,
	BusinessFinancialsBNCShort,
	BusinessFinancialsBNCShortStyles,
	RentalEstateBNCShort,
	RentalEstateBNCShortStyles,
	GeneralInformationBCCLQuestions,
	GeneralInformationBCCLStyles,
	BusinessIncomeBCCLQuestions,
	BusinessIncomeBCCLStyles,
	BusinessExpensesBCCLQuestions,
	BusinessExpensesBCCLStyles,
	OtherInterestBCCLQuestions,
	OtherInterestBCCLStyles,
	suppliesBCCLQuestions,
	suppliesBCCLStyles,
	BusinessVehiclesBCCLQuestions,
	BusinessVehiclesBCCLStyles,
	ShareHolderIncomeBCCLQuestions,
	ShareHolderIncomeBCCLStyles,
	QBIDBCCLQuestions,
	QBIDBCCLQuestionsStyles,
	TaxfreeRentalBCCLQuestions,
	TaxfreeRentalBCCLStyles,
	RetirementBCCLQuestions,
	RetirementBCCLStyles,
	EmployeesBCCLQuestions,
	EmployeesBCCLStyles,
	PayrollBCCLQuestions,
	PayrollBCCLStyles,
	Covid19BCCLQuestions,
	Covid19BCCLStyles,
	FringeBenefitsBCCLQuestions,
	FringeBenefitsBCCLStyles,
	InsuranceBCCLQuestions,
	InsuranceBCCLStyles,
	SalesOfAssetsBCCLQuestions,
	SalesOfAssetsBCCLStyles,
	CorporateBCCLQuestions,
	CorporateBCCLStyles,
	SCORPBCCLQuestions,
	SCORPBCCLStyles,
	PartnershipBCCLQuestions,
	PartnershipBCCLStyles,
	SoleProprietorshipQuestions,
	SoleProprietorshipStyles,
	FuturePartnersAndShareholdersBCCLQuestions,
	FuturePartnersAndShareholdersBCCLStyles,
	RentalRealEstateAndRoyaltyIncomeBCCLQuestions,
	RentalRealEstateAndRoyaltyIncomeBCCLStyles,
	FarmBCCLQuestions,
	FarmBCCLStyles,
	FarmRentalBCCLQuestions,
	FarmRentalBCCLStyles,
	DepriciationBCCLQuestions,
	DepriciationBCCLStyles,
	FICATipCreditBCCLQuestions,
	FICATipCreditBCCLStyles,
	RAndDBCCLQuestions,
	RAndDBCCLStyles,
	WorkOpportunityCreditBCCLQuestions,
	WorkOpportunityCreditBCCLStyles,
	InternationalBCCLQuestions,
	InternationalBCCLStyles,
	ForeignAccountsBCCLQuestions,
	ForeignAccountsBCCLStyles,
	MiscellaneousBCCLQuestions,
	MiscellaneousBCCLStyles,
	BusinessIncomeBNCLQuestions,
	BusinessIncomeBNCLStyles,
	ShareHolderIncomeBNCLQuestions,
	ShareHolderIncomeBNCLStyles,
	MiscellaneousBNCLQuestions,
	possibleShutDowns,
	PersonalInformationTPIQuestions,
	PersonalInformationTPIStyles,
	WagesTPIQuestions,
	WagesTPIStyles,
	DependentChildrenTPIQuestions,
	DependentChildrenTPIStyles,
	PrimaryResidenceTPIQuestions,
	PrimaryResidenceTPIStyles,
	SecondaryResidenceTPIQuestions,
	SecondaryResidenceTPIStyles,
	HealthAndMedicalTPIQuestions,
	HealthAndMedicalTPIStyles,
	CharityTPIQuestions,
	CharityTPIStyles,
	RetirementPlansTPIQuestions,
	RetirementPlansTPIStyles,
	SalesOfAssetsTPIQuestions,
	SalesOfAssetsTPIStyles,
	PurchaseOfAssetTPIQuestions,
	PurchaseOfAssetTPIStyles,
	OtherIncomeTPIQuestions,
	OtherIncomeTPIStyles,
	CapitalGainsTPIQuestions,
	CapitalGainsTPIStyles,
	otherDeductionTPIQuestions,
	otherDeductionsTPIStyles,
	OilAndGasTPIQuestions,
	OilAndGasTPIStyles,
	GeneralInformationTPBOQuestions,
	GeneralInformationTPBOStyles,
	IncomeTPBOQuestions,
	IncomeTPBOQStyles,
	PartnersAndShareHoldersTPBOQuestions,
	PartnersAndShareHoldersTPBOStyles,
	QBIDTPBOQuestions,
	QBIDTPBOQStyles,
	TaxFreeRentalTPBOQuestions,
	TaxFreeRentalTPBOStyles,
	RetirementTPBOQuestions,
	RetirementTPBOStyles,
	covid19TPBOOptions,
	covid19TPBOStyles,
	PayrollTPBOQuestions,
	PayrollTPBOStyles,
	BusinessExpensesTPBOQuestions,
	BusinessExpensesTPBOStyles,
	FringeBenefitsTPBOQuestions,
	FringeBenefitsTPBOStyles,
	InsuranceTPBOQuestions,
	InsuranceTPBOStyles,
	EmployeesTPBOQuestions,
	EmployeesTPBOStyles,
	SaleofAssetsTPBOQuestions,
	SaleofAssetsTPBOStyles,
	PurchaseofAssetsTPBOQuestions,
	PurchaseofAssetsTPBOStyles,
	RentalRealEstateTPBOQuestions,
	RentalRealEstateTPBOStyles,
	DepreciationTPBOQuestions,
	DepreciationTPBOStyles,
	InternationalTPBOQuestions,
	InternationalTPBOStyles
};
